(function() {
 var STEPPER_DATA = window.__dhStepperData || {};
 var STEPPER_VERSION = "v64";
 var STEP = {
  process: 0,
  form: 1,
  material: 2,
  design: 3,
  text: 4
 };
 var STEP_LABELS = [ "Herstellung", "Form & Größe", "Material", "Design", "Beschriftung" ];
 var PROCESS_KEYS = [ "uv", "handcraft" ];
 var PROCESS_PATTERNS = {
  uv: /\buv\b|laser/i,
  handcraft: /handcraft/i
 };
 var PROCESS_FALLBACK_LABELS = {
  uv: "UV-Lasergravur",
  handcraft: "Handcraft"
 };
 var PROCESS_IMAGES = {
  uv: "https://cdn.shopify.com/s/files/1/0952/2092/4740/files/ALS06224_800x800.jpg?v=1788444255",
  handcraft: "https://cdn.shopify.com/s/files/1/0952/2092/4740/files/ALS06219_800x800.jpg?v=1788444255"
 };
 var PROCESS_CARD_LINES = {
  uv: [ {
   ok: true,
   text: "Materialien: Transparent, Einfarbig"
  }, {
   ok: false,
   text: "Nicht möglich: Glitzer, Perlmutt, Glow in the Dark"
  } ],
  handcraft: [ {
   ok: true,
   text: "Alle Materialien – auch Glitzer, Perlmutt & Glow in the Dark"
  }, {
   ok: true,
   text: "Kräftige Farben, von Hand ausgemalt"
  } ]
 };
 var PROCESS_RULES = {
  uv: {
   materialCategoriesAllow: /transparent|einfarbig|\buni\b|unifarben|klar/i,
   materialKeywordsDeny: /glitzer|glitter|glow|nachtleucht|perlmutt|galaxy|eiskristall|metallic|holo/i,
   materialTitlesDeny: [],
   motifCategoriesDeny: null
  },
  handcraft: {
   materialCategoriesAllow: null,
   materialKeywordsDeny: null,
   materialTitlesDeny: [],
   motifCategoriesDeny: null
  }
 };
 var FORM_CLASS_PATTERNS = {
  standard: /standard/i,
  sonder: /sonder/i
 };
 var STANDARD_FORM_FAMILIES = /^(flintstone|hexagon|kleks|kreis|raute)\b/i;
 var PRODUCT_VARIANTS = Array.isArray(STEPPER_DATA.variants) ? STEPPER_DATA.variants : [];
 var SHOP_CURRENCY = STEPPER_DATA.currency || "EUR";
 var MATERIAL_MODULE_SELECTOR = '[data-dynamic-designs-id="materialwahl"], [data-dynamic-designs-id="material"], .dh-material-modul';
 var MOTIF_MODULE_SELECTOR = ".dh-motiv-modul";
 var MATERIAL_WRAPPER_SELECTOR = ".dh-material-modul";
 var MATERIAL_KEYWORDS = /Eiskristall|Perlmutt|Galaxy|Transparent|Glow/i;
 var MOTIF_KEYWORDS = /Berge|Abenteuer/i;
 var REPLACE_MATERIAL = "material";
 var REPLACE_MOTIF = "replace";
 var NO_DESIGN_TITLE_REGEX = /^(kein|ohne|no)[-_ ]*(design|motiv)$/i;
 var NAME_PLACEHOLDER = "";
 var DESIGN_COLOR_DEFAULT = "#ffffff";
 var DESIGN_COLOR_GLOW = "#eaffdc";
 var GLOW_MATERIAL_REGEX = /glow|nachtleucht/i;
 var GLOW_BG_DARK = "#050806";
 var GLOW_BG_BLOOM = "rgba(96, 188, 104, .40)";
 var GLOW_BG_BLOOM_MID = "rgba(38, 78, 42, .55)";
 var GLOW_INK_HALO = "rgba(154, 246, 142, .92)";
 var GLOW_INK_BLUR = 12;
 var FORM_LABEL_OVERRIDES = {};
 var FORM_EXCLUDE_TITLES = [ "Testmarke", "Konfigurator - Berge & Abenteuer" ];
 var FORM_EXCLUDE_PREFIX_REGEX = /^Konfigurator\b/i;
 var SHAPE_ELEMENT_TITLE = "markenform";
 var NAME_ELEMENT_TITLE = "Name";
 var CUSTOM_TEXT_ELEMENT_TITLE = "Wunschtext";
 var HOVER_KILL = {
  removeClass: false,
  swallowEvents: true,
  neutralizeGhosts: true,
  minGhostEdge: 200,
  maxLogs: 5
 };
 var MINI_BREAKPOINT = 990;
 var MINI_EDGE = 64;
 var MINI_STAGE_RATIO = .2;
 var COARSE_POINTER = false;
 try {
  COARSE_POINTER = !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
 } catch (eCP) {}
 var DRAG_CHECK_MS = COARSE_POINTER ? 260 : 180;
 var DRAG_IDLE_MS = 1200;
 var ORDER_PROP = {
  namePos: "_name-pos",
  customTextLines: "_wunschtext-zeilen",
  customTextFontSize: "_wunschtext-fontsize",
  designPos: "_design-pos",
  designSize: "_design-size",
  shapePx: "_shape-px",
  customTextPos: "_wunschtext-pos",
  nameFontSize: "_name-fontsize",
  backViewKey: "_back-view-key",
  designSku: "_design-sku",
  designFile: "_design-file",
  overhang: "_overhang",
  nameFont: "_schriftart",
  customTextFont: "_wunschtext-schriftart",
  process: "_herstellung"
 };
 var BACK_VIEW_UPLOAD = {
  ticketEndpoint: "https://laser.dogs-hundemarke.de/api/back-view-upload-ticket",
  multiplier: 1,
  maxBytes: 2e6
 };
 var buildOrderProperties = null;
 function upsertOrderProperty(props, name, value) {
  if (!props || value == null || value === "") return;
  if (Array.isArray(props)) {
   for (var i = 0; i < props.length; i++) {
    var p = props[i];
    if (p && (p.name === name || p.key === name)) {
     if ("value" in p) p.value = value; else p[name] = value;
     return;
    }
   }
   props.push({
    name: name,
    value: value
   });
  } else if (typeof props === "object") {
   props[name] = value;
  }
 }
 (function registerCartPropertiesCallback() {
  try {
   window.FPD = window.FPD || {};
   var cbs = window.FPD.callbacks = window.FPD.callbacks || {};
   var prev = cbs.cartTextPropertiesPost;
   cbs.cartTextPropertiesPost = function(properties, lineItemCache, shopifyProduct) {
    try {
     if (typeof prev === "function") {
      var chained = prev.call(this, properties, lineItemCache, shopifyProduct);
      if (chained) properties = chained;
     }
    } catch (e) {}
    try {
     if (typeof buildOrderProperties === "function") {
      var ours = buildOrderProperties();
      Object.keys(ours).forEach(function(k) {
       if (k.toLowerCase().indexOf("_fpd") === 0) return;
       upsertOrderProperty(properties, k, ours[k]);
      });
      console.log("[dh-stepper] cartTextPropertiesPost: supplementary layout properties merged", ours);
     }
    } catch (e) {
     console.warn("[dh-stepper] cartTextPropertiesPost failed (form-input fallback still active):", e);
    }
    return properties;
   };
  } catch (e) {}
 })();
 var notifyViewChanged = function() {};
 var bootLoader = null;
 function mountBootLoader() {
  if (bootLoader) return;
  var atc = document.querySelector('form[action*="/cart/add"]');
  var anchor = document.querySelector(".fpd-view-selection-wrapper") || atc;
  if (!anchor || !anchor.parentNode) return;
  bootLoader = document.createElement("div");
  bootLoader.className = "dh-fpd-loader";
  bootLoader.innerHTML = '<span class="dh-spinner"></span>Dein Konfigurator wird geladen …';
  anchor.parentNode.insertBefore(bootLoader, anchor);
  if (atc) atc.classList.add("fpd-step-hidden");
 }
 if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountBootLoader);
 } else {
  mountBootLoader();
 }
 (function suppressFpdBoundaryToasts() {
  var TOAST_RX = /innerhalb der Begrenzung/i;
  function hideToastNode(c) {
   try {
    var box = c.closest && c.closest('[class*="snackbar"], [class*="toast"], [class*="notification"], [class*="message"]') || c;
    box.style.setProperty("display", "none", "important");
   } catch (e) {}
  }
  function sweepRoot(root) {
   try {
    if (!root || !root.querySelectorAll) return;
    var txt = root.textContent || root.body && root.body.textContent || "";
    if (!TOAST_RX.test(txt)) return;
    root.querySelectorAll("*").forEach(function(c) {
     if (c.children && c.children.length === 0) {
      var ct = c.textContent || "";
      if (ct.length < 160 && TOAST_RX.test(ct)) hideToastNode(c);
     }
    });
   } catch (e) {}
  }
  var shadowRoots = [];
  var shadowScanTick = 0;
  function rescanShadowRoots() {
   try {
    var found = [];
    document.querySelectorAll("*").forEach(function(el) {
     if (el.tagName.indexOf("-") !== -1 && el.shadowRoot) found.push(el.shadowRoot);
    });
    shadowRoots = found;
   } catch (e) {}
  }
  function sweep() {
   if (document.hidden) return;
   sweepRoot(document);
   if (shadowScanTick++ % 8 === 0) rescanShadowRoots();
   for (var i = 0; i < shadowRoots.length; i++) sweepRoot(shadowRoots[i]);
  }
  function arm() {
   try {
    new MutationObserver(function(muts) {
     for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
       var n = muts[i].addedNodes[j];
       if (n && n.nodeType === 1 && TOAST_RX.test(n.textContent || "")) {
        sweepRoot(document);
        return;
       }
      }
     }
    }).observe(document.body, {
     childList: true,
     subtree: true
    });
   } catch (e) {}
   setInterval(sweep, 600);
  }
  if (document.body) arm(); else document.addEventListener("DOMContentLoaded", arm);
 })();
 function whenFpdReady(cb) {
  var tries = 0;
  var iv = setInterval(function() {
   var fpd = window.FPD && window.FPD.instance;
   if (fpd && fpd.productCreated) {
    clearInterval(iv);
    if (bootLoader && bootLoader.parentNode) bootLoader.parentNode.removeChild(bootLoader);
    cb(fpd);
   } else if (++tries > 120) {
    clearInterval(iv);
    if (bootLoader) {
     bootLoader.innerHTML = "Der Konfigurator konnte nicht geladen werden – bitte lade die Seite neu.";
    }
   }
  }, 250);
 }
 function setTextByTitle(fpd, title, value) {
  var found = null;
  fpd.getElements(-1, "all", false).forEach(function(e) {
   if (e.title === title) found = e;
  });
  if (!found) return;
  try {
   if (typeof found.width === "number") {
    var pb = found.getBoundingRect(true, true);
    found.__dhPrevCenter = {
     x: pb.left + pb.width / 2,
     y: pb.top + pb.height / 2
    };
    found.set("width", 4e3);
   }
  } catch (eWide) {}
  found.set("text", value);
  found.fire("changed");
  fpd.viewInstances.forEach(function(v) {
   v.fabricCanvas.renderAll();
  });
 }
 function buildField(fpd, cfg, onChange) {
  var wrap = document.createElement("div");
  wrap.style.margin = "16px 0";
  var helpHtml = cfg.help ? ' <span class="dh-help" tabindex="0"><span class="dh-help-icon">?</span>' + '<span class="dh-help-tip">' + cfg.help + "</span></span>" : "";
  var fieldHtml = cfg.multiline ? '<textarea id="' + cfg.id + '" rows="' + (cfg.rows || 3) + '" maxlength="' + cfg.maxlength + '" placeholder="' + cfg.placeholder + '"></textarea>' : '<input id="' + cfg.id + '" type="text" maxlength="' + cfg.maxlength + '" placeholder="' + cfg.placeholder + '" ' + 'inputmode="' + (cfg.inputmode || "text") + '" ' + 'style="width:100%;padding:10px 14px;border:1px solid #ccc;border-radius:8px;font-size:16px;">';
  wrap.innerHTML = '<label style="display:block;font-size:14px;margin-bottom:6px;">' + cfg.label + helpHtml + "</label>" + fieldHtml + '<div id="' + cfg.id + '-hint" style="font-size:12px;color:#990000;height:16px;margin-top:4px;"></div>' + '<div id="' + cfg.id + '-info" style="font-size:12px;color:#777;margin-top:2px;"></div>';
  var input = wrap.querySelector("#" + cfg.id);
  var hint = wrap.querySelector("#" + cfg.id + "-hint");
  var info = wrap.querySelector("#" + cfg.id + "-info");
  var t, hintTimer;
  input.addEventListener("input", function(ev) {
   var original = ev.target.value;
   var clean = original.replace(cfg.filter, "");
   var hadInvalid = clean !== original;
   if (hadInvalid) ev.target.value = clean;
   clearTimeout(hintTimer);
   if (hadInvalid) {
    hint.textContent = cfg.hintText;
    hintTimer = setTimeout(function() {
     hint.textContent = "";
    }, 2e3);
   } else {
    hint.textContent = "";
   }
   if (cfg.write) {
    var res = cfg.write(clean.length ? clean : cfg.fallbackText);
    if (!res.ok && clean.length) {
     ev.target.value = cfg._lastGood || "";
     cfg.write(cfg._lastGood && cfg._lastGood.length ? cfg._lastGood : cfg.fallbackText);
     var limitMsg = cfg.limitTexts && res.reason ? cfg.limitTexts[res.reason] : null;
     if (typeof limitMsg === "function") limitMsg = limitMsg(res);
     hint.textContent = limitMsg || cfg.limitText || "Maximale Länge erreicht";
     hintTimer = setTimeout(function() {
      hint.textContent = "";
     }, 2500);
     return;
    }
    cfg._lastGood = clean;
    if (cfg.lengthWarnText) info.textContent = res.shrunk ? cfg.lengthWarnText : "";
    if (onChange) onChange(clean);
    return;
   }
   if (cfg.lengthWarnAt) {
    info.textContent = clean.length >= cfg.lengthWarnAt ? cfg.lengthWarnText : "";
   }
   clearTimeout(t);
   t = setTimeout(function() {
    setTextByTitle(fpd, cfg.elementTitle, clean.length ? clean : cfg.fallbackText);
    if (onChange) onChange(clean);
   }, 120);
  });
  var focusVal = null;
  input.addEventListener("focus", function() {
   focusVal = input.value;
  });
  if (typeof cfg.viewIndex === "number") {
   input.addEventListener("focus", function() {
    fpd.selectView(cfg.viewIndex);
    notifyViewChanged();
   });
  }
  if (typeof cfg.onCommit === "function") {
   input.addEventListener("blur", function() {
    var v = input.value;
    if (v === focusVal) return;
    focusVal = v;
    cfg.onCommit(v.trim());
   });
   if (!cfg.multiline) {
    input.addEventListener("keydown", function(ev) {
     if (ev.key === "Enter" || ev.keyCode === 13) {
      ev.preventDefault();
      input.blur();
     }
    });
   }
  }
  return wrap;
 }
 whenFpdReady(function(fpd) {
  console.log("[dh-stepper] " + STEPPER_VERSION + " aktiv");
  try {
   window.__dhFpd = fpd;
  } catch (eDbg) {}
  var atcForm = document.querySelector('form[action*="/cart/add"]');
  var atcButton = atcForm ? atcForm.querySelector('button[type="submit"], [name="add"]') : null;
  var fpdViewsWrapper = document.querySelector(".fpd-view-selection-wrapper");
  var moduleCache = {
   material: [],
   motiv: [],
   unknown: [],
   scannedAt: 0
  };
  function scanModules() {
   var nodes = Array.prototype.slice.call(document.querySelectorAll('fpd-module-designs, fpd-module-dynamic-designs, [data-moduletype*="designs"], [data-dynamic-designs-id]'));
   nodes = nodes.filter(function(n) {
    return !nodes.some(function(o) {
     return o !== n && o.contains(n);
    });
   });
   var res = {
    material: [],
    motiv: [],
    unknown: [],
    scannedAt: Date.now()
   };
   function pushOnce(list, el) {
    if (list.indexOf(el) === -1) list.push(el);
   }
   nodes.forEach(function(n) {
    var wrap;
    if (MATERIAL_MODULE_SELECTOR && (wrap = n.closest(MATERIAL_MODULE_SELECTOR))) {
     pushOnce(res.material, wrap);
     return;
    }
    if (MOTIF_MODULE_SELECTOR && (wrap = n.closest(MOTIF_MODULE_SELECTOR))) {
     pushOnce(res.motiv, wrap);
     return;
    }
    var txt = n.textContent || "";
    if (MOTIF_KEYWORDS.test(txt)) pushOnce(res.motiv, n); else if (MATERIAL_KEYWORDS.test(txt)) pushOnce(res.material, n); else pushOnce(res.unknown, n);
   });
   return res;
  }
  function getModules() {
   var incomplete = moduleCache.material.length === 0 || moduleCache.motiv.length === 0;
   if (incomplete && Date.now() - moduleCache.scannedAt > 1e3) {
    moduleCache = scanModules();
   }
   return moduleCache;
  }
  setTimeout(function() {
   var m = getModules();
   console.log("[dh-stepper] Modules detected – material:", m.material.length, "| motif:", m.motiv.length, "| unknown:", m.unknown.length, m);
   var customTextEl = getCustomTextElement();
   if (customTextEl) {
    console.log("[dh-stepper] Wunschtext limits – Form:", currentFormTitle() || "?", "(" + (formMm(currentFormTitle()) || "ohne mm") + ") | Zeilen:", customTextLineLimit(), "| Zeichen/Zeile:", CUSTOM_TEXT_MAX_CHARS_PER_LINE, "| Feld-maxlength:", getCustomTextCharLimit(), "| FPD-maxLength gesetzt auf:", customTextEl.maxLength, "| baseFont:", customTextEl.fontSize);
   }
  }, 3e3);
  function isMaterialElement(el) {
   if (el.replace === REPLACE_MATERIAL) return true;
   if (el.replace === REPLACE_MOTIF) return false;
   return !el.getObjects;
  }
  function getMotifElements() {
   var out = [];
   try {
    fpd.getCustomElements("all", -1, false).forEach(function(item) {
     var el = item.element || item;
     if (!isMaterialElement(el)) out.push(el);
    });
   } catch (e) {}
   return out;
  }
  function getMaterialElements() {
   var out = [];
   try {
    fpd.getCustomElements("all", -1, false).forEach(function(item) {
     var el = item.element || item;
     if (isMaterialElement(el)) out.push(el);
    });
   } catch (e) {}
   return out;
  }
  function getAllMaterialElements() {
   var out = [];
   try {
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.replace === REPLACE_MATERIAL) out.push(e);
    });
   } catch (e) {}
   return out;
  }
  function removeElementSafe(el) {
   try {
    if (typeof fpd.removeElement === "function") {
     fpd.removeElement(el);
     return;
    }
    var vi = fpd.viewInstances[fpd.currentViewIndex];
    if (vi && typeof vi.removeElement === "function") {
     vi.removeElement(el);
     return;
    }
    if (el.canvas) {
     var c = el.canvas;
     c.remove(el);
     c.renderAll();
    }
   } catch (e) {}
  }
  var dhDragAt = 0;
  function isOursElement(el) {
   if (!el) return false;
   if (el.title === NAME_ELEMENT_TITLE) return true;
   if (el.__dhOurs === true || el.__dhOurs === false) return el.__dhOurs;
   var ours = getMotifElements().indexOf(el) !== -1;
   el.__dhOurs = ours;
   return ours;
  }
  function forgetOursCache() {
   try {
    getMotifElements().forEach(function(el) {
     el.__dhOurs = true;
    });
   } catch (e) {}
  }
  function removeMotifElements() {
   getMotifElements().forEach(removeElementSafe);
   fpd.viewInstances.forEach(function(v) {
    try {
     v.fabricCanvas.renderAll();
    } catch (e) {}
   });
  }
  var FONT_STEP_MIN = 14;
  var FONT_STEP_MAX = 24;
  var FONT_SCALE_STEP_MIN = 11;
  var FONT_STEP_NAME_DEFAULT = 14;
  var FONT_STEP_TEXT_DEFAULT = 15;
  var FONT_PCT_MIN = 6;
  var FONT_PCT_MAX = 20;
  var TEXT_WIDTH_SLACK = .25;
  var MOTIF_PCT_MIN = 70;
  var MOTIF_PCT_MAX = 200;
  var nameSizeStep = FONT_STEP_NAME_DEFAULT;
  var customTextSizeStep = FONT_STEP_TEXT_DEFAULT;
  var TEXT_MIN_FONT = 16;
  var TEXT_FLOOR_RATIO = .4;
  function textFloorFor(base) {
   return Math.max(TEXT_MIN_FONT, Math.round((base || 40) * TEXT_FLOOR_RATIO));
  }
  var NAME_MAX_HEIGHT_RATIO = .45;
  var CUSTOM_TEXT_MAX_CHARS_PER_LINE = 16;
  var CUSTOM_TEXT_LINES_BY_MM = [ [ 30, 3 ], [ 25, 2 ], [ 0, 1 ] ];
  var CUSTOM_TEXT_LINES_DEFAULT = 3;
  var CUSTOM_TEXT_PLACEHOLDERS = [ "z. B. 0176 1234567", "0221 998877", "Bello" ];
  var customTextBaseFontSize = 0;
  var customTextCenterRef = null;
  var nameBaseFontSize = 0;
  function getCustomTextElement() {
   var found = null;
   try {
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === CUSTOM_TEXT_ELEMENT_TITLE) found = e;
    });
   } catch (e) {}
   return found;
  }
  function customTextCharCeiling() {
   var lines = customTextLineLimit();
   return lines * CUSTOM_TEXT_MAX_CHARS_PER_LINE + (lines - 1);
  }
  function applyCustomTextLimits(el) {
   if (!el) return;
   var ceiling = customTextCharCeiling();
   try {
    if (Number(el.maxLines) !== 0) el.set("maxLines", 0);
    if (Number(el.maxLength) !== ceiling) el.set("maxLength", ceiling);
   } catch (eU) {
    el.maxLines = 0;
    el.maxLength = ceiling;
   }
  }
  function formMm(title) {
   var m = /(\d+(?:[.,]\d+)?)\s*mm\b/i.exec(String(title || ""));
   return m ? parseFloat(m[1].replace(",", ".")) : 0;
  }
  function currentFormTitle() {
   var cfg = formConfig && formConfig[selectedFormIndex];
   return cfg && cfg.productTitle || "";
  }
  function customTextLineLimit() {
   var mm = formMm(currentFormTitle());
   if (!mm) return CUSTOM_TEXT_LINES_DEFAULT;
   for (var i = 0; i < CUSTOM_TEXT_LINES_BY_MM.length; i++) {
    if (mm >= CUSTOM_TEXT_LINES_BY_MM[i][0]) return CUSTOM_TEXT_LINES_BY_MM[i][1];
   }
   return 1;
  }
  function stripWhitespace(s) {
   return String(s || "").replace(/\s+/g, "");
  }
  var sizeStepsCalibrated = false;
  function stepForPercent(pct) {
   if (!(pct > 0)) return 0;
   var span = FONT_STEP_MAX - FONT_SCALE_STEP_MIN;
   var raw = FONT_SCALE_STEP_MIN + (pct - FONT_PCT_MIN) * span / (FONT_PCT_MAX - FONT_PCT_MIN);
   return Math.max(FONT_STEP_MIN, Math.min(FONT_STEP_MAX, Math.round(raw)));
  }
  function calibrateSizeSteps() {
   if (sizeStepsCalibrated) return;
   try {
    var frontCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
    var nEl = null, wEl = null;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.canvas === frontCanvas) nEl = e;
     if (e.title === CUSTOM_TEXT_ELEMENT_TITLE) wEl = e;
    });
    if (!nEl && !wEl) return;
    var hN = shapeHeightForView(MOTIF_FRONT_VIEW_INDEX);
    var hW = shapeHeightForView(BACK_VIEW_INDEX);
    var pctN = nEl && nEl.fontSize && hN ? nEl.fontSize / hN * 100 : 0;
    var pctW = wEl && wEl.fontSize && hW ? wEl.fontSize / hW * 100 : 0;
    var stN = stepForPercent(pctN), stW = stepForPercent(pctW);
    if (stN) nameSizeStep = stN;
    if (stW) customTextSizeStep = stW;
    sizeStepsCalibrated = true;
    console.log("[dh-stepper] " + STEPPER_VERSION + " Builder-Vorlage: Name " + (nEl ? Math.round(nEl.fontSize || 0) : "?") + "px, Wunschtext " + (wEl ? Math.round(wEl.fontSize || 0) : "?") + "px auf Formhöhe " + Math.round(hN) + "px/" + Math.round(hW) + "px");
    console.log("[dh-stepper] " + STEPPER_VERSION + " Startstufen — Name " + nameSizeStep + " (" + pctN.toFixed(1) + " % der Formhöhe), Wunschtext " + customTextSizeStep + " (" + pctW.toFixed(1) + " %) | Skala: Stufe " + FONT_SCALE_STEP_MIN + " = " + FONT_PCT_MIN + " %, Stufe " + FONT_STEP_MAX + " = " + FONT_PCT_MAX + " %");
   } catch (e) {}
  }
  function stepPercent(step) {
   var st = Math.max(FONT_STEP_MIN, Math.min(FONT_STEP_MAX, step || FONT_STEP_MIN));
   var span = FONT_STEP_MAX - FONT_SCALE_STEP_MIN;
   return FONT_PCT_MIN + (st - FONT_SCALE_STEP_MIN) * (FONT_PCT_MAX - FONT_PCT_MIN) / (span || 1);
  }
  function shapeHeightForView(viewIndex) {
   try {
    var shape = findShapeOnView(viewIndex);
    if (shape) {
     var b = shape.getBoundingRect(true, true);
     if (b && b.height > 20) return b.height;
    }
   } catch (e) {}
   return getStageSize().h;
  }
  function pxForStep(step, viewIndex) {
   return Math.max(8, Math.round(shapeHeightForView(viewIndex) * stepPercent(step) / 100));
  }
  function stepFits(el, viewIndex, cx, cy, step) {
   layoutTextAt(el, pxForStep(step, viewIndex), cx, cy);
   return textRectInsideShape(el, viewIndex);
  }
  function maxFittingStep(el, viewIndex, cx, cy) {
   if (!stepFits(el, viewIndex, cx, cy, FONT_STEP_MIN)) return 0;
   var lo = FONT_STEP_MIN, hi = FONT_STEP_MAX, best = FONT_STEP_MIN;
   while (lo <= hi) {
    var mid = lo + hi >> 1;
    if (stepFits(el, viewIndex, cx, cy, mid)) {
     best = mid;
     lo = mid + 1;
    } else {
     hi = mid - 1;
    }
   }
   return best;
  }
  function elementCenter(el, fallbackRef) {
   try {
    if (el.__dhPrevCenter) {
     var p = el.__dhPrevCenter;
     el.__dhPrevCenter = null;
     return p;
    }
    var b = el.getBoundingRect(true, true);
    if (b && b.width) return {
     x: b.left + b.width / 2,
     y: b.top + b.height / 2
    };
   } catch (e) {}
   return fallbackRef || {
    x: getStageSize().w / 2,
    y: getStageSize().h / 2
   };
  }
  function renderAllViews() {
   fpd.viewInstances.forEach(function(v) {
    try {
     v.fabricCanvas.renderAll();
    } catch (e) {}
   });
  }
  function maskForViewSync(viewIndex) {
   var got = null;
   try {
    withMask(viewIndex, function(m) {
     got = m;
    });
   } catch (e) {}
   return got;
  }
  function shapeOnCanvasOf(el) {
   var shape = null;
   try {
    if (el.canvas) el.canvas.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
   } catch (e) {}
   return shape;
  }
  function textRectInsideShape(el, viewIndex) {
   var b, mask = maskForViewSync(viewIndex);
   try {
    b = el.getBoundingRect(true, true);
   } catch (e) {
    return false;
   }
   if (!b.width || !b.height) return false;
   if (mask) {
    for (var xi = 0; xi <= 4; xi++) {
     for (var yi = 0; yi <= 2; yi++) {
      var px = b.left + b.width * (xi / 4);
      var py = b.top + b.height * (yi / 2);
      var gx = (px - mask.bbox.left) * mask.w / mask.bbox.width;
      var gy = (py - mask.bbox.top) * mask.h / mask.bbox.height;
      if (maskDistanceAt(mask, gx, gy) > .999) return false;
     }
    }
    return true;
   }
   var shape = shapeOnCanvasOf(el);
   if (!shape) return true;
   var sb = shape.getBoundingRect(true, true);
   var ix = sb.width * .08, iy = sb.height * .08;
   return b.left >= sb.left + ix && b.top >= sb.top + iy && b.left + b.width <= sb.left + sb.width - ix && b.top + b.height <= sb.top + sb.height - iy;
  }
  function layoutTextAt(el, s, cx, cy) {
   el.set("fontSize", s);
   try {
    if (typeof el.width === "number" && typeof el.calcTextWidth === "function") {
     el.set("width", 4e3);
     if (typeof el.initDimensions === "function") el.initDimensions();
     var tw = Math.ceil(el.calcTextWidth());
     el.set("width", Math.max(20, tw + Math.max(10, Math.round(s * TEXT_WIDTH_SLACK))));
     if (typeof el.initDimensions === "function") el.initDimensions();
    }
   } catch (eW) {}
   if (el.setCoords) el.setCoords();
   try {
    var b = el.getBoundingRect(true, true);
    el.left += cx - (b.left + b.width / 2);
    el.top += cy - (b.top + b.height / 2);
    if (el.setCoords) el.setCoords();
   } catch (eC) {}
  }
  function writeCustomText(text) {
   var el = getCustomTextElement();
   if (!el) return {
    ok: true,
    shrunk: false
   };
   applyCustomTextLimits(el);
   if (!customTextBaseFontSize) customTextBaseFontSize = el.fontSize || 54;
   if (!customTextCenterRef) {
    try {
     var b0 = el.getBoundingRect(true, true);
     customTextCenterRef = {
      x: b0.left + b0.width / 2,
      y: b0.top + b0.height / 2
     };
    } catch (e0) {}
   }
   el.set("textAlign", "center");
   var clean = String(text == null ? "" : text).replace(/\r/g, "");
   if (!clean.replace(/\s/g, "").length) {
    el.set("text", "");
    el.fire("changed");
    renderAllViews();
    updateThumbnails();
    try {
     scheduleWunschtextCheck();
    } catch (eV) {}
    return {
     ok: true,
     shrunk: false
    };
   }
   clean = clean.replace(/\n+$/, "");
   var lineLimit = customTextLineLimit();
   var textLines = clean.split("\n");
   if (textLines.length > lineLimit) return {
    ok: false,
    shrunk: false,
    reason: "lines",
    limit: lineLimit
   };
   for (var li = 0; li < textLines.length; li++) {
    if (textLines[li].length > CUSTOM_TEXT_MAX_CHARS_PER_LINE) return {
     ok: false,
     shrunk: false,
     reason: "linelen",
     limit: CUSTOM_TEXT_MAX_CHARS_PER_LINE
    };
   }
   var prevText = el.text, prevSize = el.fontSize, prevWidth = el.width;
   function restore() {
    el.set("text", prevText);
    el.set("fontSize", prevSize);
    if (prevWidth) el.set("width", prevWidth);
    if (el.setCoords) el.setCoords();
   }
   try {
    if (typeof el.width === "number") el.set("width", 4e3);
   } catch (eWide) {}
   el.set("text", clean);
   if (stripWhitespace(el.text) !== stripWhitespace(clean)) {
    restore();
    return {
     ok: false,
     shrunk: false,
     reason: "fit"
    };
   }
   var vi = BACK_VIEW_INDEX;
   var cx = customTextCenterRef ? customTextCenterRef.x : getStageSize().w / 2;
   var cy = customTextCenterRef ? customTextCenterRef.y : getStageSize().h / 2;
   var maxStep = maxFittingStep(el, vi, cx, cy);
   if (!maxStep) {
    restore();
    return {
     ok: false,
     shrunk: false,
     reason: "fit"
    };
   }
   var useStep = Math.min(customTextSizeStep, maxStep);
   var clamped = useStep < customTextSizeStep;
   customTextSizeStep = useStep;
   layoutTextAt(el, pxForStep(useStep, vi), cx, cy);
   el.fire("changed");
   renderAllViews();
   applyAutoDesignColor();
   updateThumbnails();
   try {
    scheduleWunschtextCheck();
   } catch (eV) {}
   return {
    ok: true,
    shrunk: clamped
   };
  }
  function applyNameAutoSize() {
   try {
    var frontCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
    var el = null;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.canvas === frontCanvas) el = e;
    });
    if (!el) return;
    var c = elementCenter(el, null);
    if (!nameValue || !String(el.text || "").length) {
     if (typeof el.width === "number" && el.width > 1e3) {
      layoutTextAt(el, pxForStep(nameSizeStep, MOTIF_FRONT_VIEW_INDEX), c.x, c.y);
      if (el.canvas) {
       try {
        el.canvas.renderAll();
       } catch (eR0) {}
      }
     }
     return;
    }
    if (!nameBaseFontSize) nameBaseFontSize = el.fontSize || 32;
    var maxStep = maxFittingStep(el, MOTIF_FRONT_VIEW_INDEX, c.x, c.y);
    if (!maxStep) maxStep = FONT_STEP_MIN;
    if (nameSizeStep > maxStep) nameSizeStep = maxStep;
    layoutTextAt(el, pxForStep(nameSizeStep, MOTIF_FRONT_VIEW_INDEX), c.x, c.y);
    if (el.canvas) {
     try {
      el.canvas.renderAll();
     } catch (eR) {}
    }
    updateThumbnails();
    try {
     scheduleNameCheck();
    } catch (eN) {}
   } catch (e) {}
  }
  function lockControls(el, keep) {
   try {
    var src = el.controls || window.fabric && window.fabric.Object && window.fabric.Object.prototype.controls || {};
    var vis = {};
    Object.keys(src).forEach(function(k) {
     vis[k] = !!keep && keep.indexOf(k) !== -1;
    });
    if (typeof el.setControlsVisibility === "function") el.setControlsVisibility(vis);
   } catch (e) {}
  }
  function applyTextElementPolicy() {
   try {
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title !== NAME_ELEMENT_TITLE && e.title !== CUSTOM_TEXT_ELEMENT_TITLE) return;
     if (e.isEditing && typeof e.exitEditing === "function") {
      try {
       e.exitEditing();
      } catch (e2) {}
     }
     e.editable = false;
     var inLettering = currentStep === STEP.text;
     if (e.title === CUSTOM_TEXT_ELEMENT_TITLE) {
      var wtActive = inLettering && !!customTextValue;
      e.selectable = wtActive;
      e.evented = wtActive;
      e.lockMovementX = true;
      e.lockMovementY = true;
      e.lockRotation = true;
      e.lockScalingX = !wtActive;
      e.lockScalingY = !wtActive;
      e.lockScalingFlip = true;
      e.hasControls = wtActive;
      applyTextHandleStyle(e, wtActive, BACK_VIEW_INDEX);
      if (!wtActive && e.canvas && typeof e.canvas.getActiveObject === "function" && e.canvas.getActiveObject() === e) {
       try {
        e.canvas.discardActiveObject();
        e.canvas.renderAll();
       } catch (eD2) {}
      }
     } else {
      e.selectable = inLettering;
      e.evented = inLettering;
      e.lockMovementX = !inLettering;
      e.lockMovementY = !inLettering;
      e.lockRotation = true;
      e.lockScalingX = !inLettering;
      e.lockScalingY = !inLettering;
      e.lockScalingFlip = true;
      e.hasControls = inLettering && !!nameValue;
      applyTextHandleStyle(e, inLettering && !!nameValue, MOTIF_FRONT_VIEW_INDEX);
      e.borderColor = "#ffffff";
      e.borderScaleFactor = 2.5;
      e.padding = 6;
      e.hasBorders = true;
      var wantOp = !inLettering && !nameValue ? 0 : 1;
      if (e.opacity !== wantOp) {
       if (typeof e.set === "function") e.set("opacity", wantOp); else e.opacity = wantOp;
       if (e.canvas) {
        try {
         e.canvas.renderAll();
        } catch (eR) {}
       }
      }
      if (!inLettering && e.canvas && typeof e.canvas.getActiveObject === "function" && e.canvas.getActiveObject() === e) {
       try {
        e.canvas.discardActiveObject();
        e.canvas.renderAll();
       } catch (eD) {}
      }
     }
    });
   } catch (e) {}
  }
  var TEXT_HANDLE_KEY = "bl";
  var TEXT_HANDLES = [ TEXT_HANDLE_KEY ];
  var nameMaxStepCached = 0;
  var textMaxStepCached = 0;
  var plainHandleLogged = false;
  function plainScaleControl(el) {
   var F = window.fabric;
   var src = el.controls || {};
   var ref = src.br || src.bl || src.tr || src.tl || null;
   var Ctor = F && typeof F.Control === "function" ? F.Control : ref && ref.constructor;
   if (typeof Ctor !== "function" || !Ctor.prototype || typeof Ctor.prototype.render !== "function") return null;
   var utils = F && F.controlsUtils || {};
   var action = typeof utils.scalingEqually === "function" ? utils.scalingEqually : ref && typeof ref.actionHandler === "function" ? ref.actionHandler : null;
   if (!action) return null;
   var cursor = typeof utils.scaleCursorStyleHandler === "function" ? utils.scaleCursorStyleHandler : ref && ref.cursorStyleHandler || undefined;
   var ctl = new Ctor({
    x: -.5,
    y: .5,
    actionHandler: action,
    cursorStyleHandler: cursor,
    actionName: "scale"
   });
   if (typeof ctl.render !== "function") return null;
   return ctl;
  }
  function installPlainTextHandle(el) {
   try {
    if (el.__dhPlainControls) {
     if (el.controls !== el.__dhPlainControls) el.controls = el.__dhPlainControls;
     return true;
    }
    var ctl = plainScaleControl(el);
    if (!ctl) return false;
    var merged = {};
    var src = el.controls || {};
    Object.keys(src).forEach(function(k) {
     merged[k] = hiddenControlCopy(src[k]);
    });
    ctl.getVisibility = function(obj) {
     return !obj || obj.__dhHandleOn !== false;
    };
    merged[TEXT_HANDLE_KEY] = ctl;
    el.__dhPlainControls = merged;
    el.controls = merged;
    if (!plainHandleLogged) {
     plainHandleLogged = true;
     console.log("[dh-stepper] " + STEPPER_VERSION + " Text-Griff: eigener Skalier-Kreis unten links, FPD-Controls fest aus (" + Object.keys(src).join(",") + ")");
    }
    return true;
   } catch (e) {
    return false;
   }
  }
  function hiddenControlCopy(base) {
   var copy;
   try {
    copy = base && typeof base === "object" ? Object.create(base) : {};
   } catch (e) {
    copy = {};
   }
   copy.visible = false;
   copy.getVisibility = function() {
    return false;
   };
   return copy;
  }
  var textHandleTimers = [];
  function reapplyTextHandlesSoon() {
   while (textHandleTimers.length) clearTimeout(textHandleTimers.pop());
   [ 0, 150 ].forEach(function(ms) {
    textHandleTimers.push(setTimeout(function() {
     try {
      applyTextElementPolicy();
     } catch (e) {}
    }, ms));
   });
  }
  function applyTextHandleStyle(e, on, viewIndex) {
   try {
    e.__dhHandleOn = !!on;
    if (on) installPlainTextHandle(e);
    lockControls(e, on ? TEXT_HANDLES : []);
    if (!on) return;
    e.transparentCorners = false;
    e.cornerStyle = "circle";
    e.cornerColor = "#ffffff";
    e.cornerStrokeColor = "#333333";
    e.cornerSize = 14;
    var minPx = pxForStep(FONT_STEP_MIN, viewIndex);
    if (e.fontSize > 0) e.minScaleLimit = Math.max(.05, minPx / e.fontSize);
   } catch (eS) {}
  }
  function stepForPx(px, viewIndex) {
   var h = shapeHeightForView(viewIndex) || 1;
   return stepForPercent(px / h * 100);
  }
  function clampTextScale(el, viewIndex, maxStep) {
   try {
    var base = el.fontSize || 1;
    var sY = el.scaleY || 1;
    var px = base * sY;
    var lo = pxForStep(FONT_STEP_MIN, viewIndex);
    var hi = pxForStep(Math.max(FONT_STEP_MIN, Math.min(FONT_STEP_MAX, maxStep || FONT_STEP_MAX)), viewIndex);
    var target = Math.min(hi, Math.max(lo, px));
    if (Math.abs(target - px) > .5) {
     var f = target / base;
     el.scaleX = f;
     el.scaleY = f;
     if (el.setCoords) el.setCoords();
    }
    return stepForPx(el.fontSize * (el.scaleY || 1), viewIndex);
   } catch (e) {
    return 0;
   }
  }
  function liveSyncSizeSelect(id, step) {
   try {
    var sel = document.getElementById(id);
    if (sel && step && sel.value !== String(step)) sel.value = String(step);
   } catch (e) {}
  }
  function bakeNameScale(el) {
   var sY = el.scaleY || 1, sX = el.scaleX || 1;
   if (Math.abs(sX - 1) < .001 && Math.abs(sY - 1) < .001) return false;
   var step = stepForPx((el.fontSize || 32) * sY, MOTIF_FRONT_VIEW_INDEX);
   try {
    var pb = el.getBoundingRect(true, true);
    el.__dhPrevCenter = {
     x: pb.left + pb.width / 2,
     y: pb.top + pb.height / 2
    };
   } catch (eC) {}
   el.scaleX = 1;
   el.scaleY = 1;
   if (el.setCoords) el.setCoords();
   var maxStep = nameMaxStepCached || FONT_STEP_MAX;
   nameSizeStep = Math.max(FONT_STEP_MIN, Math.min(maxStep, step));
   el.__dhNameSized = true;
   applyNameAutoSize();
   refreshSizeOptions();
   return true;
  }
  function bakeCustomTextScale(el) {
   var sY = el.scaleY || 1, sX = el.scaleX || 1;
   if (Math.abs(sX - 1) < .001 && Math.abs(sY - 1) < .001) return false;
   var step = stepForPx((el.fontSize || 32) * sY, BACK_VIEW_INDEX);
   el.scaleX = 1;
   el.scaleY = 1;
   var maxStep = textMaxStepCached || FONT_STEP_MAX;
   customTextSizeStep = Math.max(FONT_STEP_MIN, Math.min(maxStep, step));
   writeCustomText(customTextValue);
   refreshSizeOptions();
   return true;
  }
  function selectCustomTextElement() {
   try {
    var wt = getCustomTextElement();
    var c = wt && wt.canvas;
    if (!wt || !c || !customTextValue) return;
    applyTextElementPolicy();
    if (fpd.currentViewIndex !== BACK_VIEW_INDEX && typeof fpd.selectView === "function") fpd.selectView(BACK_VIEW_INDEX);
    if (typeof c.setActiveObject === "function") {
     c.setActiveObject(wt);
     c.renderAll();
    }
   } catch (e) {}
  }
  function afterTextEntry(viewIndex, val) {
   if (window.innerWidth >= MINI_BREAKPOINT) return;
   if (currentStep !== STEP.text) return;
   if (!String(val || "").trim()) return;
   setTimeout(function() {
    try {
     if (currentStep !== STEP.text) return;
     if (fpd.currentViewIndex !== viewIndex && typeof fpd.selectView === "function") {
      fpd.selectView(viewIndex);
      notifyViewChanged();
     }
     scrollToStage();
     if (viewIndex === MOTIF_FRONT_VIEW_INDEX) {
      if (nameValue) selectNameElement();
     } else {
      selectCustomTextElement();
     }
     console.log("[dh-stepper] " + STEPPER_VERSION + " Texteingabe abgeschlossen \u2192 zur Vorschau gescrollt (" + (viewIndex === MOTIF_FRONT_VIEW_INDEX ? "Name" : "Wunschtext") + ")");
    } catch (e) {}
   }, 220);
  }
  function selectNameElement() {
   try {
    var vi = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
    var c = vi && vi.fabricCanvas;
    if (!c) return;
    var nameEl = null;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.canvas === c) nameEl = e;
    });
    if (!nameEl) return;
    if (fpd.currentViewIndex !== MOTIF_FRONT_VIEW_INDEX && typeof fpd.selectView === "function") {
     fpd.selectView(MOTIF_FRONT_VIEW_INDEX);
    }
    if (typeof c.setActiveObject === "function") {
     c.setActiveObject(nameEl);
     c.renderAll();
    }
   } catch (e) {}
  }
  function clampElementIntoShape(el) {
   try {
    if (!el || !el.canvas) return;
    var shape = null;
    el.canvas.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
    if (!shape) return;
    var sb = shape.getBoundingRect(true, true);
    var inset = .12;
    var minX = sb.left + sb.width * inset, maxX = sb.left + sb.width * (1 - inset);
    var minY = sb.top + sb.height * inset, maxY = sb.top + sb.height * (1 - inset);
    var eb = el.getBoundingRect(true, true);
    var cx = eb.left + eb.width / 2, cy = eb.top + eb.height / 2;
    var nx = Math.min(Math.max(cx, minX), maxX);
    var ny = Math.min(Math.max(cy, minY), maxY);
    if (nx !== cx || ny !== cy) {
     el.left += nx - cx;
     el.top += ny - cy;
     if (el.setCoords) el.setCoords();
     el.canvas.renderAll();
    }
    updateThumbnails();
   } catch (e) {}
  }
  function getStageSize() {
   var w = parseFloat(fpd.mainOptions && fpd.mainOptions.stageWidth) || 600;
   var h = parseFloat(fpd.mainOptions && fpd.mainOptions.stageHeight) || w;
   return {
    w: w,
    h: h
   };
  }
  var MOBILE_STAGE_FIT = .9;
  var dhStageApplying = false;
  function computeStageTarget(c) {
   try {
    if (!c || !c.wrapperEl) return null;
    var st = getStageSize();
    var stageEl = c.wrapperEl.parentElement;
    var hostEl = null;
    try {
     hostEl = c.wrapperEl.closest && (c.wrapperEl.closest(".fpd-container") || c.wrapperEl.closest("fpd-main")) || null;
    } catch (eH) {}
    if (!hostEl) hostEl = stageEl;
    var hostW = hostEl ? hostEl.clientWidth : 0;
    if (!hostW || hostW < 50) return null;
    var isMobile = window.innerWidth < 990;
    var wantW = Math.min(hostW, st.w);
    var wantH = wantW * st.h / st.w;
    var wantZoom = wantW / st.w * (isMobile ? MOBILE_STAGE_FIT : 1);
    return {
     stageEl: stageEl,
     hostEl: hostEl,
     isMobile: isMobile,
     wantW: wantW,
     wantH: wantH,
     wantZoom: wantZoom,
     tx: (wantW - st.w * wantZoom) / 2,
     ty: (wantH - st.h * wantZoom) / 2
    };
   } catch (e) {
    return null;
   }
  }
  function enforceStageScale() {
   try {
    fpd.viewInstances.forEach(function(v) {
     var c = v && v.fabricCanvas;
     if (!c || !c.wrapperEl || typeof c.setDimensions !== "function" || typeof c.setZoom !== "function") return;
     var wrapEl = c.wrapperEl;
     try {
      if (wrapEl.classList && wrapEl.classList.contains("fpd-hidden")) return;
      if (wrapEl.closest && wrapEl.closest(".fpd-hidden")) return;
      if (wrapEl.getBoundingClientRect().width < 50) return;
     } catch (eVis) {}
     var stageEl = wrapEl.parentElement;
     if (!stageEl || stageEl.clientWidth < 50) return;
     var t = computeStageTarget(c);
     if (!t) return;
     var hostEl = t.hostEl, isMobile = t.isMobile;
     var wantW = t.wantW, wantH = t.wantH, wantZoom = t.wantZoom, tx = t.tx, ty = t.ty;
     var vpt = c.viewportTransform || [ 1, 0, 0, 1, 0, 0 ];
     var paintedW = 0;
     try {
      paintedW = c.lowerCanvasEl ? c.lowerCanvasEl.getBoundingClientRect().width : 0;
     } catch (eCw) {}
     var fabricOk = Math.abs(c.getWidth() - wantW) <= 2 && Math.abs(vpt[0] - wantZoom) <= .005 && Math.abs((vpt[4] || 0) - tx) <= 2 && Math.abs((vpt[5] || 0) - ty) <= 2;
     var paintOk = paintedW > 0 && Math.abs(paintedW - wantW) <= 3;
     if (fabricOk && paintOk) return;
     var before = Math.round(c.getWidth());
     var beforePaint = Math.round(paintedW);
     dhStageApplying = true;
     try {
      c.setDimensions({
       width: wantW,
       height: wantH
      });
      if (typeof c.setViewportTransform === "function") {
       c.setViewportTransform([ wantZoom, 0, 0, wantZoom, tx, ty ]);
      } else {
       c.setZoom(wantZoom);
      }
     } finally {
      dhStageApplying = false;
     }
     try {
      [ c.lowerCanvasEl, c.upperCanvasEl, c.wrapperEl ].forEach(function(el) {
       if (!el || !el.style) return;
       el.style.setProperty("width", wantW + "px", "important");
       el.style.setProperty("height", wantH + "px", "important");
      });
     } catch (eCss) {}
     c.renderAll();
     console.log("[dh-stepper] " + STEPPER_VERSION + " stage rescale: fabric " + before + " / painted " + beforePaint + " -> " + Math.round(wantW) + " | zoom " + wantZoom.toFixed(3) + (isMobile && MOBILE_STAGE_FIT !== 1 ? " (mobile fit " + MOBILE_STAGE_FIT + ", zentriert)" : ""));
     try {
      var rr = c.lowerCanvasEl.getBoundingClientRect();
      if (Math.abs(rr.width - wantW) > 3) {
       var contR = hostEl.getBoundingClientRect();
       var sig = Math.round(rr.width) + "x" + Math.round(rr.height) + "@" + Math.round(rr.left - contR.left) + "," + Math.round(rr.top - contR.top);
       if (c.__dhWarnSig !== sig) {
        c.__dhWarnSig = sig;
        console.warn("[dh-stepper] " + STEPPER_VERSION + ": Anzeige " + Math.round(rr.width) + "px statt " + Math.round(wantW) + "px — Canvas-Rect " + sig + " im Container " + Math.round(contR.width) + "x" + Math.round(contR.height) + " — externes CSS/Transform/Zoom. Vorfahren:");
        var anc = c.wrapperEl, ai = 0;
        while (anc && ai < 6) {
         var csA = window.getComputedStyle(anc);
         console.warn("   ", anc.tagName, String(anc.className || "").slice(0, 44), "| w:", Math.round(anc.getBoundingClientRect().width), "| transform:", csA.transform !== "none" ? csA.transform : "-", "| cssZoom:", csA.zoom && csA.zoom !== "1" ? csA.zoom : "-");
         anc = anc.parentElement;
         ai++;
        }
       }
      } else {
       c.__dhWarnSig = "";
      }
     } catch (ePost) {}
    });
   } catch (e) {}
  }
  var stageGuardRaf = false;
  function scheduleStageGuard() {
   if (dhDragActive && Date.now() - dhDragAt < DRAG_IDLE_MS) return;
   if (stageGuardRaf) return;
   stageGuardRaf = true;
   try {
    requestAnimationFrame(function() {
     stageGuardRaf = false;
     enforceStageScale();
    });
   } catch (e) {
    stageGuardRaf = false;
   }
  }
  var dhSourceLogs = 0;
  function stackHint() {
   try {
    var lines = String((new Error).stack || "").split("\n").map(function(l) {
     return l.trim();
    }).filter(function(l) {
     return l && l.indexOf("stackHint") === -1 && l.indexOf("logSource") === -1 && !/^Error$/.test(l);
    });
    return lines.slice(1, 7).join(" ← ");
   } catch (e) {
    return "?";
   }
  }
  function logSource(what) {
   if (dhSourceLogs >= 8) return;
   dhSourceLogs++;
   console.log("[dh-stepper] " + STEPPER_VERSION + " " + what + " — Quelle: " + stackHint());
  }
  var dhPointerDown = false;
  function isOurElement(el) {
   try {
    return !!el && (el.title === NAME_ELEMENT_TITLE || getMotifElements().indexOf(el) !== -1);
   } catch (e) {
    return false;
   }
  }
  function installStageOwnership(c) {
   if (!c || c.__dhStageOwned) return;
   c.__dhStageOwned = true;
   var origVpt = c.setViewportTransform, origDim = c.setDimensions, origDiscard = c.discardActiveObject;
   if (typeof origVpt === "function") c.setViewportTransform = function(vpt) {
    if (!dhStageApplying && vpt && vpt.length >= 6) {
     var t = computeStageTarget(this);
     if (t && (Math.abs(vpt[0] - t.wantZoom) > .005 || Math.abs((vpt[4] || 0) - t.tx) > 2 || Math.abs((vpt[5] || 0) - t.ty) > 2)) {
      logSource("Zoom-Änderung von außen ersetzt (" + Number(vpt[0]).toFixed(3) + " → " + t.wantZoom.toFixed(3) + ")");
      vpt = [ t.wantZoom, 0, 0, t.wantZoom, t.tx, t.ty ];
     }
    }
    return origVpt.call(this, vpt);
   };
   if (typeof origDim === "function") c.setDimensions = function(dims, options) {
    if (!dhStageApplying && dims && typeof dims === "object" && !(options && options.cssOnly)) {
     var t = computeStageTarget(this);
     var w = parseFloat(dims.width), h = parseFloat(dims.height);
     if (t && (isFinite(w) && Math.abs(w - t.wantW) > 2 || isFinite(h) && Math.abs(h - t.wantH) > 2)) {
      logSource("Größenänderung von außen ersetzt (" + Math.round(w) + "x" + Math.round(h) + " → " + Math.round(t.wantW) + "x" + Math.round(t.wantH) + ")");
      dims = {
       width: t.wantW,
       height: t.wantH
      };
     }
    }
    return origDim.call(this, dims, options);
   };
   if (typeof origDiscard === "function") c.discardActiveObject = function(e) {
    if (!e) {
     try {
      var a = this.getActiveObject();
      if (a && isOurElement(a)) logSource("Abwahl von außen (" + (a.title || a.type) + (dhPointerDown || this._currentTransform ? ", während Interaktion" : "") + ")");
     } catch (eA) {}
    }
    return origDiscard.apply(this, arguments);
   };
   try {
    c.on("mouse:down", function() {
     dhPointerDown = true;
    });
    c.on("mouse:up", function() {
     dhPointerDown = false;
     if (currentStep === STEP.text) reapplyTextHandlesSoon();
    });
    [ "selection:created", "selection:updated" ].forEach(function(ev) {
     c.on(ev, function(opt) {
      var t = opt && (opt.target || opt.selected && opt.selected[0]);
      if (t && (t.title === NAME_ELEMENT_TITLE || t.title === CUSTOM_TEXT_ELEMENT_TITLE)) reapplyTextHandlesSoon();
     });
    });
   } catch (eEv) {}
  }
  [ "mouseup", "touchend", "touchcancel", "pointerup", "pointercancel" ].forEach(function(type) {
   document.addEventListener(type, function() {
    dhPointerDown = false;
    dhDragActive = false;
   }, true);
  });
  function captureCanvas(c, multiplier) {
   var wasCapturing = thumbsCapturing;
   thumbsCapturing = true;
   try {
    return captureCanvasInner(c, multiplier);
   } finally {
    thumbsCapturing = wasCapturing;
   }
  }
  function captureCanvasInner(c, multiplier) {
   var pendingRender = c.isRendering;
   var active = null, vptBefore = null, wBefore = 0, hBefore = 0;
   try {
    active = typeof c.getActiveObject === "function" ? c.getActiveObject() : null;
    vptBefore = (c.viewportTransform || [ 1, 0, 0, 1, 0, 0 ]).slice(0);
    wBefore = c.getWidth();
    hBefore = c.getHeight();
   } catch (eS) {}
   var el = null;
   try {
    var vp = c.viewportTransform, zoom = vp[0] * multiplier;
    el = document.createElement("canvas");
    el.width = Math.max(1, Math.round(c.width * multiplier));
    el.height = Math.max(1, Math.round(c.height * multiplier));
    var w = c.width, h = c.height, inter = c.interactive, retina = c.enableRetinaScaling, top = c.contextTop;
    c.contextTop = null;
    c.enableRetinaScaling = false;
    c.interactive = false;
    c.viewportTransform = [ zoom, 0, 0, zoom, vp[4] * multiplier, vp[5] * multiplier ];
    c.width = el.width;
    c.height = el.height;
    try {
     c.calcViewportBoundaries();
     c.renderCanvas(el.getContext("2d"), c._objects);
    } finally {
     c.viewportTransform = vp;
     c.width = w;
     c.height = h;
     c.calcViewportBoundaries();
     c.interactive = inter;
     c.enableRetinaScaling = retina;
     c.contextTop = top;
    }
   } catch (eB) {
    el = null;
   }
   var data = null;
   if (el) {
    try {
     data = el.toDataURL("image/png");
    } catch (eD) {
     data = null;
    }
   }
   if (!data) {
    data = c.toDataURL({
     format: "png",
     multiplier: multiplier
    });
   }
   try {
    var vptAfter = c.viewportTransform || [ 1, 0, 0, 1, 0, 0 ];
    var changed = false;
    if (vptBefore && (Math.abs(vptAfter[0] - vptBefore[0]) > 1e-6 || Math.abs((vptAfter[4] || 0) - (vptBefore[4] || 0)) > .5 || Math.abs((vptAfter[5] || 0) - (vptBefore[5] || 0)) > .5)) {
     dhStageApplying = true;
     try {
      c.setViewportTransform(vptBefore);
     } finally {
      dhStageApplying = false;
     }
     changed = true;
    }
    if (wBefore && (Math.abs(c.getWidth() - wBefore) > .5 || Math.abs(c.getHeight() - hBefore) > .5)) {
     dhStageApplying = true;
     try {
      c.setDimensions({
       width: wBefore,
       height: hBefore
      });
     } finally {
      dhStageApplying = false;
     }
     changed = true;
    }
    if (active && c.getActiveObject() !== active && c.getObjects().indexOf(active) !== -1) {
     c.setActiveObject(active);
     changed = true;
    }
    if (changed) {
     logSource("Aufnahme hat Bühne/Auswahl verändert — zurückgesetzt");
     c.renderAll();
    } else if (pendingRender && !c.isRendering) {
     c.requestRenderAll();
    }
   } catch (eR) {}
   return data;
  }
  var dhDeadSpaceFixedEls = [];
  function undoDeadSpaceFixes() {
   dhDeadSpaceFixedEls.forEach(function(n) {
    try {
     if (n.__dhDeadSpaceObs) {
      n.__dhDeadSpaceObs.disconnect();
      n.__dhDeadSpaceObs = null;
     }
     [ "height", "max-height", "min-height", "padding-bottom", "align-self" ].forEach(function(p) {
      n.style.removeProperty(p);
     });
     n.__dhDeadSpaceLogged = false;
     n.__dhDefendLogged = false;
     n.__dhDeadSpaceMax = 0;
     n.__dhGrowOn = false;
     n.__dhGrowMin = 0;
    } catch (e) {}
   });
   dhDeadSpaceFixedEls = [];
  }
  function defendDeadSpaceFix(n) {
   if (n.__dhDeadSpaceObs) return;
   try {
    var reent = false;
    var obs = new MutationObserver(function() {
     if (reent) return;
     var h = (n.style.height || "").trim();
     if (h && h !== "auto") {
      reent = true;
      try {
       n.style.setProperty("height", "auto", "important");
       n.style.setProperty("align-self", "start", "important");
      } catch (eS) {}
      reent = false;
      if (!n.__dhDefendLogged) {
       n.__dhDefendLogged = true;
       console.log("[dh-stepper] v54m: Hoehe wird von aussen zurueckgesetzt — dauerhaft verteidigt:", String(n.className || n.tagName).slice(0, 50));
      }
     }
    });
    obs.observe(n, {
     attributes: true,
     attributeFilter: [ "style" ]
    });
    n.__dhDeadSpaceObs = obs;
   } catch (e) {}
  }
  function collapseStageRatioBox() {
   try {
    if (window.innerWidth >= 990) {
     if (dhDeadSpaceFixedEls.length) undoDeadSpaceFixes();
     return;
    }
    var host = findStageHost();
    if (!host) return;
    var contentH = 0, hostTop = 0;
    try {
     var hr = host.getBoundingClientRect();
     contentH = hr.height;
     hostTop = hr.top;
    } catch (eH) {}
    if (!contentH || contentH < 100) return;
    var toolsBottom = 0;
    try {
     if (stageTools && !stageTools.hidden && stageTools.parentNode && document.body.contains(stageTools)) {
      var tr = stageTools.getBoundingClientRect();
      if (tr.height > 0) toolsBottom = tr.bottom - hostTop;
     }
    } catch (eT) {}
    var n = host.parentElement, hops = 0;
    while (n && n !== document.body && hops < 8) {
     if (n.contains(stepper)) break;
     var cs = window.getComputedStyle(n);
     var padB = parseFloat(cs.paddingBottom) || 0;
     var pads = (parseFloat(cs.paddingTop) || 0) + padB;
     var r = n.getBoundingClientRect();
     var hasTools = !!(toolsBottom && n.contains(stageTools));
     var wantH = hasTools ? Math.max(contentH, toolsBottom) : contentH;
     var wantMax = Math.ceil(wantH + pads + 24);
     var applied = n.__dhDeadSpaceMax || 0;
     if (n.__dhGrowOn || hasTools && /hidden|clip/.test(cs.overflowY) && r.height - pads < wantH - 2) {
      var ratioHack = !n.__dhGrowOn && padB > 100 && n.clientHeight - padB < 80;
      var keepPads = ratioHack ? pads - padB : pads;
      var wantMin = Math.ceil(wantH + keepPads + 4);
      if (!n.__dhGrowOn) {
       n.__dhGrowOn = true;
       if (ratioHack) n.style.setProperty("padding-bottom", "0", "important");
       n.style.setProperty("height", "auto", "important");
       n.style.setProperty("align-self", "start", "important");
       defendDeadSpaceFix(n);
       if (dhDeadSpaceFixedEls.indexOf(n) === -1) dhDeadSpaceFixedEls.push(n);
       console.log("[dh-stepper] " + STEPPER_VERSION + " Bühnen-Wrapper erweitert (Motiv-Regler): " + n.tagName + " " + String(n.className || "").slice(0, 60) + " (" + Math.round(r.height - pads) + "px < " + Math.round(wantH) + "px" + (ratioHack ? ", Ratio-Box" : "") + ")");
      }
      if (n.__dhGrowMin !== wantMin) {
       n.__dhGrowMin = wantMin;
       n.style.setProperty("min-height", wantMin + "px", "important");
       if (applied && applied < wantMin) {
        n.style.setProperty("max-height", wantMin + "px", "important");
        n.__dhDeadSpaceMax = applied = wantMin;
       }
      }
     }
     if (r.height - pads - wantH > 50 || applied && Math.abs(applied - wantMax) > 4) {
      n.style.setProperty("height", "auto", "important");
      n.style.setProperty("max-height", wantMax + "px", "important");
      n.__dhDeadSpaceMax = wantMax;
      if ((parseFloat(cs.minHeight) || 0) - wantH > 50) {
       n.style.setProperty("min-height", "0", "important");
      }
      if (padB > 100 && n.clientHeight - padB < 80) {
       n.style.setProperty("padding-bottom", "0", "important");
      }
      n.style.setProperty("align-self", "start", "important");
      defendDeadSpaceFix(n);
      if (dhDeadSpaceFixedEls.indexOf(n) === -1) dhDeadSpaceFixedEls.push(n);
      if (!n.__dhDeadSpaceLogged) {
       n.__dhDeadSpaceLogged = true;
       var kids = "";
       try {
        kids = Array.prototype.map.call(n.children, function(c) {
         var kh = 0;
         try {
          kh = Math.round(c.getBoundingClientRect().height);
         } catch (eK) {}
         return c.tagName + ":" + kh;
        }).join(",");
       } catch (eKs) {}
       console.log("[dh-stepper] v54m dead space fixed:", n.tagName, String(n.className || "").slice(0, 60), "(" + Math.round(r.height - pads - wantH) + "px over stage) kids=" + kids);
      }
     }
     n = n.parentElement;
     hops++;
    }
   } catch (e) {}
  }
  var stageGuardResizeTimer = null;
  window.addEventListener("resize", function() {
   clearTimeout(stageGuardResizeTimer);
   stageGuardResizeTimer = setTimeout(function() {
    enforceStageScale();
    collapseStageRatioBox();
    applyStageVisibility();
    applyMiniVisibility();
    updateTopbarTop();
    scheduleMiniDraw();
   }, 200);
  });
  function attachNameDragHandlers() {
   fpd.viewInstances.forEach(function(v, vIdx) {
    var c = v && v.fabricCanvas;
    if (!c || c.__dhNameClampBound) return;
    thumbsDirty[vIdx] = true;
    try {
     installStageOwnership(c);
    } catch (eOwn) {}
    try {
     c.on("object:moving", function(opt) {
      var el = opt && opt.target;
      if (!el) return;
      var isOurs = isOursElement(el);
      if (isOurs) {
       el.__dhDragging = true;
       dhDragActive = true;
       dhDragAt = Date.now();
       computeOverlapNow(false);
       scheduleOverlayDraw();
      }
      var now = Date.now();
      if (c.__dhLastMoveCheck && now - c.__dhLastMoveCheck < DRAG_CHECK_MS) return;
      c.__dhLastMoveCheck = now;
      if (isOurs) checkFrontElement(el);
     });
     c.on("object:scaling", function(opt) {
      var el = opt && opt.target;
      if (!el) return;
      var ours = isOursElement(el);
      if (el.title === CUSTOM_TEXT_ELEMENT_TITLE) {
       el.__dhDragging = true;
       dhDragActive = true;
       dhDragAt = Date.now();
       liveSyncSizeSelect("dh-text-size", clampTextScale(el, BACK_VIEW_INDEX, textMaxStepCached));
       return;
      }
      if (ours) {
       el.__dhDragging = true;
       el.__dhWasScaled = true;
       dhDragActive = true;
       dhDragAt = Date.now();
       if (el.title === NAME_ELEMENT_TITLE) {
        liveSyncSizeSelect("dh-name-size", clampTextScale(el, MOTIF_FRONT_VIEW_INDEX, nameMaxStepCached));
       } else {
        el.__dhMotifScaled = true;
        clampMotifScale(el);
        syncMotifSizeSlider();
       }
       computeOverlapNow(false);
       scheduleOverlayDraw();
      }
      var nowS = Date.now();
      if (c.__dhLastMoveCheck && nowS - c.__dhLastMoveCheck < DRAG_CHECK_MS) return;
      c.__dhLastMoveCheck = nowS;
      if (ours) checkFrontElement(el);
     });
     c.on("object:modified", function(opt) {
      var el = opt && opt.target;
      if (!el) return;
      el.__dhDragging = false;
      dhDragActive = false;
      if (el.title === CUSTOM_TEXT_ELEMENT_TITLE || el.title === NAME_ELEMENT_TITLE) reapplyTextHandlesSoon();
      if (el.title === CUSTOM_TEXT_ELEMENT_TITLE) {
       try {
        bakeCustomTextScale(el);
       } catch (eW) {}
       try {
        scheduleWunschtextCheck();
       } catch (eW2) {}
       scheduleOverlayDraw();
       return;
      }
      if (el.title === NAME_ELEMENT_TITLE) {
       try {
        bakeNameScale(el);
       } catch (eB) {}
       clampElementIntoShape(el);
       checkFrontElement(el);
       computeOverlapNow(true);
       scheduleOverlayDraw();
       return;
      }
      if (isOursElement(el)) {
       el.__dhMotifDragged = true;
       try {
        if (el.__dhWasScaled) {
         el.__dhWasScaled = false;
         el.__dhMotifScaled = true;
         clampMotifScale(el);
         syncMotifSizeSlider();
        }
       } catch (eMs) {}
       clampElementIntoShape(el);
       checkFrontElement(el);
       computeOverlapNow(true);
       scheduleOverlayDraw();
      }
     });
     c.on("after:render", function() {
      if (thumbsCapturing) return;
      thumbsDirty[vIdx] = true;
      scheduleOverlayDraw();
      scheduleStageGuard();
      scheduleMiniDraw();
     });
     try {
      if (c.lowerCanvasEl && !c.__dhCssObs) {
       c.__dhCssObs = new MutationObserver(scheduleStageGuard);
       c.__dhCssObs.observe(c.lowerCanvasEl, {
        attributes: true,
        attributeFilter: [ "style", "width", "height" ]
       });
      }
     } catch (eObs) {}
     c.__dhNameClampBound = true;
    } catch (e) {}
   });
  }
  function getCustomTextCharLimit() {
   applyCustomTextLimits(getCustomTextElement());
   return customTextCharCeiling();
  }
  function isNoDesignName(raw) {
   var t = String(raw || "").replace(/\.(png|jpe?g|svg|webp)$/i, "").replace(/[\s]+/g, " ").trim();
   return NO_DESIGN_TITLE_REGEX.test(t);
  }
  function isNoDesignSource(url) {
   var base = String(url || "").split("?")[0].split("#")[0].split("/").pop();
   return isNoDesignName(base);
  }
  function isNoDesignTile(item) {
   if (!item || !item.getAttribute) return false;
   return isNoDesignName(item.getAttribute("data-title"));
  }
  function isNoDesignElement(el) {
   if (!el) return false;
   if (isNoDesignName(el.title)) return true;
   var src = el.source || el.src || el.parameters && el.parameters.source || "";
   return isNoDesignSource(src);
  }
  function purgeNoDesignElements() {
   var purged = false;
   getMotifElements().forEach(function(el) {
    if (isNoDesignElement(el)) {
     removeElementSafe(el);
     purged = true;
    }
   });
   if (purged) {
    noDesignChosen = true;
    fpd.viewInstances.forEach(function(v) {
     try {
      v.fabricCanvas.renderAll();
     } catch (e) {}
    });
   }
   return purged;
  }
  var DESIGN_MODULE_SCOPE = "fpd-module-designs, fpd-module-dynamic-designs, [data-dynamic-designs-id]";
  var DH_OWN_UI_SCOPE = ".dh-stepper, .dh-views, .dh-topbar, .dh-coach, .dh-modal-backdrop, .fpd-item";
  var fpdAssetOrigins = [];
  var fpdOriginsScanned = false;
  var ghostKills = 0;
  var hoverClassKills = 0;
  var hoverClassLogged = false;
  function urlOrigin(u) {
   try {
    return new URL(String(u || ""), location.href).origin;
   } catch (e) {
    return "";
   }
  }
  function scanAssetOrigins() {
   if (fpdOriginsScanned) return;
   try {
    var dj = fpd.mainOptions && fpd.mainOptions.designsJSON || [];
    if (!dj.length) return;
    dj.forEach(function(c) {
     (c.designs || []).forEach(function(d) {
      [ d.thumbnail, d.image, d.source ].forEach(function(u) {
       if (!u) return;
       var o = urlOrigin(u);
       if (o && o !== "null" && fpdAssetOrigins.indexOf(o) === -1) fpdAssetOrigins.push(o);
      });
     });
    });
    if (!fpdAssetOrigins.length) return;
    fpdOriginsScanned = true;
    console.log("[dh-stepper] " + STEPPER_VERSION + " Design-Asset-Hosts: " + fpdAssetOrigins.join(", "));
   } catch (e) {}
  }
  function nodeChain(n) {
   var out = [], i = 0;
   try {
    while (n && i < 4) {
     out.push(n.tagName + (n.className && String(n.className).trim() ? "." + String(n.className).trim().replace(/\s+/g, ".").slice(0, 40) : ""));
     n = n.parentElement;
     i++;
    }
   } catch (e) {}
   return out.join(" < ");
  }
  function isHoverGhost(img) {
   try {
    if (!img || img.nodeType !== 1 || img.tagName !== "IMG") return false;
    if (img.hasAttribute("data-dh-hoverkill")) return false;
    if (img.className && String(img.className).trim()) return false;
    if (img.closest && img.closest(DH_OWN_UI_SCOPE)) return false;
    var src = img.currentSrc || img.getAttribute("src") || "";
    if (!src) return false;
    if (fpdAssetOrigins.length) {
     return fpdAssetOrigins.indexOf(urlOrigin(src)) !== -1;
    }
    if (!img.closest || !img.closest(DESIGN_MODULE_SCOPE)) return false;
    var cs = window.getComputedStyle(img);
    if (cs.position !== "absolute" && cs.position !== "fixed") return false;
    var r = img.getBoundingClientRect();
    return Math.max(r.width, r.height) >= HOVER_KILL.minGhostEdge;
   } catch (e) {
    return false;
   }
  }
  function neutralizeGhost(img) {
   try {
    img.setAttribute("data-dh-hoverkill", "1");
    [ "display", "visibility", "opacity", "pointer-events" ].forEach(function(p, i) {
     img.style.setProperty(p, [ "none", "hidden", "0", "none" ][i], "important");
    });
    ghostKills++;
    if (ghostKills <= HOVER_KILL.maxLogs) {
     var r = {
      width: 0,
      height: 0
     };
     try {
      r = img.getBoundingClientRect();
     } catch (eR) {}
     console.log("[dh-stepper] " + STEPPER_VERSION + " Hover-Vorschau neutralisiert #" + ghostKills + " — " + Math.round(r.width) + "x" + Math.round(r.height) + " | src: " + String(img.currentSrc || img.src || "").split("/").pop().slice(0, 60) + " | Kette: " + nodeChain(img.parentElement));
    }
   } catch (e) {}
  }
  function maybeKillGhost(img) {
   if (!HOVER_KILL.neutralizeGhosts) return;
   if (isHoverGhost(img)) neutralizeGhost(img);
  }
  function reassertGhostKills() {
   if (!HOVER_KILL.neutralizeGhosts) return;
   try {
    document.querySelectorAll("img[data-dh-hoverkill]").forEach(function(img) {
     if (img.style.display !== "none") {
      img.style.setProperty("display", "none", "important");
      img.style.setProperty("pointer-events", "none", "important");
     }
    });
   } catch (e) {}
  }
  function sweepGhostsOnce() {
   if (!HOVER_KILL.neutralizeGhosts) return;
   try {
    document.querySelectorAll("img").forEach(maybeKillGhost);
   } catch (e) {}
  }
  function armGhostObserver() {
   if (!HOVER_KILL.neutralizeGhosts) return;
   try {
    new MutationObserver(function(muts) {
     for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
       var n = added[j];
       if (!n || n.nodeType !== 1) continue;
       if (n.tagName === "IMG") {
        maybeKillGhost(n);
       } else if (n.querySelectorAll) {
        var imgs = n.querySelectorAll("img");
        for (var k = 0; k < imgs.length && k < 12; k++) maybeKillGhost(imgs[k]);
       }
      }
     }
    }).observe(document.body, {
     childList: true,
     subtree: true
    });
   } catch (e) {}
  }
  [ "mouseover", "mouseenter", "pointerover", "pointerenter" ].forEach(function(type) {
   document.addEventListener(type, function(ev) {
    if (!HOVER_KILL.swallowEvents) return;
    try {
     var t = ev.target;
     if (!t || !t.closest) return;
     var item = t.closest(".fpd-item");
     if (!item || !item.closest(DESIGN_MODULE_SCOPE)) return;
     ev.stopPropagation();
     ev.stopImmediatePropagation();
    } catch (e) {}
   }, true);
  });
  var tileProbeDone = false;
  function probeTileBlocker() {
   if (tileProbeDone) return;
   if (currentStep !== STEP.material && currentStep !== STEP.design) return;
   try {
    var mods = getModules();
    var list = mods.material.concat(mods.motiv, mods.unknown);
    var tile = null;
    for (var i = 0; i < list.length && !tile; i++) {
     var cand = list[i].querySelectorAll(".fpd-item:not(.fpd-hidden)");
     for (var j = 0; j < cand.length; j++) {
      var r0 = cand[j].getBoundingClientRect();
      if (r0.width > 60 && r0.height > 60 && r0.top >= 0 && r0.bottom <= window.innerHeight) {
       tile = cand[j];
       break;
      }
     }
    }
    if (!tile) return;
    tileProbeDone = true;
    var r = tile.getBoundingClientRect();
    var top = document.elementFromPoint(Math.round(r.left + r.width / 2), Math.round(r.top + Math.min(56, r.height / 2)));
    if (top && !tile.contains(top)) {
     console.warn("[dh-stepper] " + STEPPER_VERSION + " Kachel-Blocker: über der Kachelmitte liegt " + nodeChain(top) + " — Tap erreicht die Kachel NICHT.");
    } else {
     console.log("[dh-stepper] " + STEPPER_VERSION + " Kachel-Tap frei (oberstes Element: " + (top ? top.tagName : "?") + ", innerhalb der Kachel).");
    }
   } catch (e) {
    tileProbeDone = true;
   }
  }
  function noDesignTileFromEvent(ev) {
   var item = ev.target && ev.target.closest ? ev.target.closest(".fpd-item") : null;
   if (!item || item.classList.contains("fpd-category")) return null;
   if (!item.closest(DESIGN_MODULE_SCOPE)) return null;
   return isNoDesignTile(item) ? item : null;
  }
  [ "pointerdown", "pointerup", "mousedown", "mouseup", "touchstart", "touchend" ].forEach(function(type) {
   document.addEventListener(type, function(ev) {
    if (noDesignTileFromEvent(ev)) {
     ev.stopPropagation();
     ev.stopImmediatePropagation();
    }
   }, true);
  });
  document.addEventListener("click", function(ev) {
   if (!noDesignTileFromEvent(ev)) return;
   ev.preventDefault();
   ev.stopPropagation();
   ev.stopImmediatePropagation();
   removeMotifElements();
   noDesignChosen = true;
   render();
  }, true);
  var MOTIF_FRONT_VIEW_INDEX = 0;
  function motifDesignTileFromEvent(ev) {
   var item = ev.target && ev.target.closest ? ev.target.closest(".fpd-item") : null;
   if (!item || item.classList.contains("fpd-category")) return null;
   if (isNoDesignTile(item)) return null;
   var mods = getModules();
   var inMotifModule = mods.motiv.concat(mods.unknown).some(function(m) {
    return m.contains(item);
   });
   return inMotifModule ? item : null;
  }
  [ "pointerdown", "pointerup", "mousedown", "mouseup", "touchstart", "touchend" ].forEach(function(type) {
   document.addEventListener(type, function(ev) {
    if (fpd.currentViewIndex === MOTIF_FRONT_VIEW_INDEX) return;
    if (motifDesignTileFromEvent(ev)) {
     ev.stopPropagation();
     ev.stopImmediatePropagation();
    }
   }, true);
  });
  document.addEventListener("click", function(ev) {
   if (fpd.currentViewIndex === MOTIF_FRONT_VIEW_INDEX) return;
   var tile = motifDesignTileFromEvent(ev);
   if (!tile) return;
   ev.preventDefault();
   ev.stopPropagation();
   ev.stopImmediatePropagation();
   fpd.selectView(MOTIF_FRONT_VIEW_INDEX);
   notifyViewChanged();
   setTimeout(function() {
    try {
     tile.click();
    } catch (e) {}
   }, 150);
  }, true);
  function purgeMisplacedMotifs() {
   var purged = false;
   try {
    var frontView = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
    var frontCanvas = frontView && frontView.fabricCanvas;
    if (!frontCanvas) return false;
    getMotifElements().forEach(function(el) {
     if (el.canvas && el.canvas !== frontCanvas) {
      removeElementSafe(el);
      purged = true;
     }
    });
    if (purged) {
     fpd.viewInstances.forEach(function(v) {
      try {
       v.fabricCanvas.renderAll();
      } catch (e) {}
     });
    }
   } catch (e) {}
   return purged;
  }
  function fixTextBaselines() {
   try {
    if (window.fabric && window.fabric.Text && window.fabric.Text.prototype.textBaseline === "alphabetical") {
     window.fabric.Text.prototype.textBaseline = "alphabetic";
    }
   } catch (e) {}
   try {
    fpd.viewInstances.forEach(function(v) {
     (function walk(objs) {
      objs.forEach(function(o) {
       if (o.textBaseline === "alphabetical") {
        if (typeof o.set === "function") o.set("textBaseline", "alphabetic"); else o.textBaseline = "alphabetic";
       }
       if (o._objects) walk(o._objects);
      });
     })(v.fabricCanvas.getObjects());
    });
   } catch (e) {}
  }
  var viewTitles = [];
  try {
   fpd.getProduct().forEach(function(v) {
    viewTitles.push(v.title);
   });
  } catch (e) {}
  var viewsBox = document.createElement("div");
  viewsBox.className = "dh-views";
  var viewsLabel = document.createElement("div");
  viewsLabel.className = "dh-views-label";
  viewsLabel.textContent = "Aktuelle Live-Ansicht:";
  viewsBox.appendChild(viewsLabel);
  var viewCells = [];
  fpd.viewInstances.forEach(function(vi, i) {
   var cell = document.createElement("div");
   cell.className = "dh-view-cell";
   cell.innerHTML = '<div class="dh-view-tile"><img alt="' + (viewTitles[i] || "") + '" draggable="false"></div>' + '<div class="dh-view-caption">' + (viewTitles[i] || "") + "</div>";
   cell.addEventListener("click", function() {
    fpd.selectView(i);
    render();
   });
   viewsBox.appendChild(cell);
   viewCells.push(cell);
  });
  var thumbsDirty = {};
  var thumbsCapturing = false;
  function updateThumbnails() {
   var viewsHidden = window.innerWidth < MINI_BREAKPOINT;
   viewCells.forEach(function(cell, i) {
    cell.classList.toggle("is-active", fpd.currentViewIndex === i);
    if (thumbsDirty[i] === false || viewsHidden) return;
    try {
     var vi = fpd.viewInstances[i];
     if (!vi) return;
     var data = captureCanvas(vi.fabricCanvas, .2);
     if (!data) return;
     thumbsDirty[i] = false;
     var img = cell.querySelector("img");
     if (img && img.src !== data) img.src = data;
    } catch (e) {}
   });
  }
  var viewBadge = document.createElement("div");
  viewBadge.className = "dh-view-badge";
  var lastBadgeText = "";
  function stageRootEl() {
   var host = findStageHost();
   if (!host) return null;
   return stageToolsRoot(host) || host;
  }
  function stageEmpty() {
   return currentStep === STEP.process && !formConfirmed;
  }
  var stageOffState = null;
  var emptyHintEl = null;
  var EMPTY_HINT_TEXT = "Bitte w\u00E4hle zuerst das Herstellungsverfahren";
  function syncEmptyHint(show) {
   try {
    var host = findStageHost();
    if (!show || !host) {
     if (emptyHintEl && emptyHintEl.parentNode) emptyHintEl.parentNode.removeChild(emptyHintEl);
     return;
    }
    if (!emptyHintEl) {
     emptyHintEl = document.createElement("div");
     emptyHintEl.className = "dh-stage-empty-hint";
     emptyHintEl.setAttribute("aria-live", "polite");
     emptyHintEl.innerHTML = '<span class="dh-stage-empty-text">' + EMPTY_HINT_TEXT + '</span><span class="dh-stage-empty-arrow" aria-hidden="true">\u2192</span>';
    }
    if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
    if (emptyHintEl.parentNode !== host) host.appendChild(emptyHintEl);
   } catch (e) {}
  }
  function applyStageVisibility() {
   var root = stageRootEl();
   if (!root) return;
   var mobile = window.innerWidth < MINI_BREAKPOINT;
   var col = null;
   try {
    col = root.closest ? root.closest(".product-media") : null;
   } catch (e) {}
   var hideTarget = col || root;
   var wantHide = currentStep === STEP.process && mobile;
   if (hideTarget.classList.contains("dh-stage-off") !== wantHide) hideTarget.classList.toggle("dh-stage-off", wantHide);
   if (hideTarget !== root && root.classList.contains("dh-stage-off")) root.classList.remove("dh-stage-off");
   var empty = stageEmpty();
   syncEmptyHint(empty && !mobile);
   if (viewsBox.classList.contains("dh-views-off") !== empty) viewsBox.classList.toggle("dh-views-off", empty);
   if (viewBadge.classList.contains("dh-badge-off") !== empty) viewBadge.classList.toggle("dh-badge-off", empty);
   var sig = (wantHide ? 1 : 0) + ":" + (empty ? 1 : 0);
   if (sig !== stageOffState) {
    stageOffState = sig;
    syncShapeVisibility();
    fpd.viewInstances.forEach(function(v, i) {
     thumbsDirty[i] = true;
    });
    if (!wantHide) {
     setTimeout(function() {
      try {
       enforceStageScale();
       collapseStageRatioBox();
       renderAllViews();
       updateThumbnails();
       scheduleOverlayDraw();
      } catch (eS) {}
     }, 30);
    }
   }
  }
  function findStageHost() {
   try {
    var vi = fpd.viewInstances[fpd.currentViewIndex] || fpd.viewInstances[0];
    var fc = vi && vi.fabricCanvas;
    var wrap = fc && (fc.wrapperEl || fc.upperCanvasEl && fc.upperCanvasEl.parentElement);
    if (!wrap) return null;
    return wrap.parentElement || wrap;
   } catch (e) {
    return null;
   }
  }
  function viewTitleAt(i) {
   try {
    var vi = fpd.viewInstances[i];
    if (vi) {
     if (typeof vi.title === "string" && vi.title) return vi.title;
     if (vi.options && typeof vi.options.title === "string" && vi.options.title) return vi.options.title;
     if (vi.viewData && typeof vi.viewData.title === "string" && vi.viewData.title) return vi.viewData.title;
    }
   } catch (e) {}
   return viewTitles[i] || "";
  }
  function currentViewTitle() {
   var i = fpd.currentViewIndex || 0;
   return viewTitleAt(i) || "Ansicht " + (i + 1);
  }
  function updateViewBadge() {
   if (!document.body.contains(viewBadge)) {
    var host = findStageHost();
    if (host) {
     try {
      if (window.getComputedStyle(host).position === "static") {
       host.style.position = "relative";
      }
      host.appendChild(viewBadge);
     } catch (e) {}
    }
   }
   var t = currentViewTitle();
   if (t !== lastBadgeText) {
    lastBadgeText = t;
    viewBadge.textContent = t;
    viewBadge.classList.remove("is-flash");
    void viewBadge.offsetWidth;
    viewBadge.classList.add("is-flash");
   }
  }
  notifyViewChanged = function() {
   try {
    updateViewBadge();
    updateThumbnails();
    updateMiniCaption();
    scheduleMiniDraw();
   } catch (e) {}
  };
  try {
   fpd.addEventListener("viewSelect", function() {
    setTimeout(function() {
     updateViewBadge();
     updateMiniCaption();
     scheduleMiniDraw();
    }, 0);
   });
  } catch (e) {}
  var currentStep = STEP.process;
  var unlocked = STEP.process;
  var nameValue = "";
  var customTextValue = "";
  var noDesignChosen = false;
  var formConfirmed = false;
  var selectedFormIndex = 0;
  var backViewUploadKey = "";
  var process = "";
  var formTab = "standard";
  var materialInvalidNote = false;
  var drivenVariantId = null;
  var formIdLoggedFor = null;
  var pickerLogDone = false;
  var compareAvailable = false;
  var stepper = document.createElement("div");
  stepper.className = "dh-stepper";
  var labels = STEP_LABELS;
  var nav = document.createElement("div");
  nav.className = "dh-stepper-nav";
  labels.forEach(function(label, i) {
   var s = document.createElement("div");
   s.className = "dh-step";
   s.innerHTML = '<span class="dh-step-num">' + (i + 1) + "</span>" + '<span class="dh-step-label">' + label + "</span>";
   s.addEventListener("click", function() {
    if (i <= unlocked) goTo(i);
   });
   nav.appendChild(s);
  });
  stepper.appendChild(nav);
  var STEP_HINTS = [ "Wähle die Herstellung – sie bestimmt die möglichen Materialien.", "Tippe auf deine Form.", "Tippe auf dein Material.", "Wähle ein Motiv – oder „Kein Design“.", "" ];
  var stepHint = document.createElement("div");
  stepHint.className = "dh-step-hint";
  stepHint.hidden = true;
  stepper.appendChild(stepHint);
  function updateStepHint() {
   var t = STEP_HINTS[currentStep] || "";
   if (stepHint.textContent !== t) stepHint.textContent = t;
   if (stepHint.hidden !== !t) stepHint.hidden = !t;
  }
  function buttonRow(showBack, nextDisabled) {
   return '<div class="dh-btn-row">' + '<button class="dh-back" type="button"' + (showBack ? "" : " hidden") + ">Zurück</button>" + '<button class="dh-next" type="button"' + (nextDisabled ? " disabled" : "") + ">Weiter</button>" + "</div>";
  }
  var panelProcess = document.createElement("div");
  panelProcess.className = "dh-panel";
  panelProcess.innerHTML = '<div class="dh-proc-cards"></div>' + '<div class="dh-compare-under"><button type="button" class="dh-link dh-compare-link" hidden>Zum Vergleich der Herstellungsarten</button></div>' + buttonRow(false, true);
  var processCardsWrap = panelProcess.querySelector(".dh-proc-cards");
  var processNextBtn = panelProcess.querySelector(".dh-next");
  var processCards = {};
  var panelForm = document.createElement("div");
  panelForm.className = "dh-panel";
  var formGrid = document.createElement("div");
  formGrid.className = "dh-form-grid";
  var formTiles = [];
  var formConfig = [];
  var formGridSig = null;
  function prettyFormLabel(title) {
   if (FORM_LABEL_OVERRIDES[title]) return FORM_LABEL_OVERRIDES[title];
   return String(title).replace(/(\d)\s*mm\b/i, "$1 mm");
  }
  function formClassFor(title) {
   return STANDARD_FORM_FAMILIES.test(String(title || "").trim()) ? "standard" : "sonder";
  }
  function computeFormConfig() {
   var out = [];
   getAssignedProducts().forEach(function(p, i) {
    var t = productTitle(p) || "";
    if (FORM_EXCLUDE_TITLES.indexOf(t) !== -1 || FORM_EXCLUDE_PREFIX_REGEX.test(t)) return;
    out.push({
     label: prettyFormLabel(t || "Form " + (i + 1)),
     productTitle: t,
     productIndex: i,
     formClass: formClassFor(t)
    });
   });
   out.sort(function(a, b) {
    return a.label.localeCompare(b.label, "de");
   });
   return out;
  }
  function rebuildFormGrid() {
   var cfg = computeFormConfig();
   var sig = cfg.map(function(c) {
    return c.productIndex + ":" + c.productTitle;
   }).join("|");
   if (sig === formGridSig) return;
   formGridSig = sig;
   formGrid.innerHTML = "";
   formTiles = [];
   formConfig = cfg;
   if (selectedFormIndex >= cfg.length) selectedFormIndex = 0;
   cfg.forEach(function(c, i) {
    var tile = document.createElement("div");
    tile.className = "dh-form-tile" + (c.formClass === "sonder" ? " is-sonder" : "") + (i === selectedFormIndex ? " is-selected" : "");
    tile.innerHTML = '<img alt="" style="display:none" draggable="false" onerror="this.style.display=\'none\'">' + "<span>" + c.label + "</span>";
    tile.addEventListener("click", function() {
     confirmForm();
     switchForm(i);
     advanceTo(STEP.material);
    });
    formGrid.appendChild(tile);
    formTiles.push(tile);
   });
  }
  var formTabs = document.createElement("div");
  formTabs.className = "dh-form-tabs";
  formTabs.hidden = true;
  formTabs.innerHTML = '<button type="button" class="dh-form-tab" data-tab="standard"><span class="dh-form-tab-label">Standardmarken</span></button>' + '<button type="button" class="dh-form-tab" data-tab="sonder"><span class="dh-form-tab-label">Sondermarken</span></button>';
  formTabs.addEventListener("click", function(ev) {
   var btn = ev.target && ev.target.closest ? ev.target.closest(".dh-form-tab") : null;
   if (!btn) return;
   setFormTab(btn.getAttribute("data-tab"));
  });
  panelForm.appendChild(formTabs);
  panelForm.appendChild(formGrid);
  var formNav = document.createElement("div");
  formNav.className = "dh-form-nav";
  formNav.innerHTML = '<button type="button" data-dir="-1" aria-label="Vorherige Formen">&#8592;</button>' + '<button type="button" data-dir="1" aria-label="Weitere Formen">&#8594;</button>';
  panelForm.appendChild(formNav);
  var FORM_TILE_STEP = 132;
  var formArcRaf = false;
  function formArcUpdate() {
   try {
    var rect = formGrid.getBoundingClientRect();
    if (!rect.width) return;
    var mid = rect.left + rect.width / 2;
    formTiles.forEach(function(t) {
     if (t.hidden) return;
     var r = t.getBoundingClientRect();
     var d = (r.left + r.width / 2 - mid) / Math.max(1, rect.width / 2);
     d = Math.max(-1.2, Math.min(1.2, d));
     t.style.transform = "translateY(" + (d * d * 26).toFixed(1) + "px) " + "rotate(" + (d * 9).toFixed(2) + "deg) " + "scale(" + (1 - Math.min(.12, Math.abs(d) * .12)).toFixed(3) + ")";
    });
   } catch (e) {}
  }
  function scheduleFormArc() {
   if (formArcRaf) return;
   formArcRaf = true;
   try {
    requestAnimationFrame(function() {
     formArcRaf = false;
     formArcUpdate();
    });
   } catch (e) {
    formArcRaf = false;
    formArcUpdate();
   }
  }
  formGrid.addEventListener("scroll", scheduleFormArc, {
   passive: true
  });
  window.addEventListener("resize", scheduleFormArc);
  var formAutoStopped = false;
  function stopFormAuto() {
   formAutoStopped = true;
  }
  [ "pointerdown", "wheel", "touchstart" ].forEach(function(evName) {
   formGrid.addEventListener(evName, stopFormAuto, {
    passive: true
   });
  });
  if (window.matchMedia && window.matchMedia("(hover: hover)").matches) {
   var formHoverDir = 0;
   var formHoverActive = false;
   var formHoverVel = 0;
   var formSnapRestoreTimer = null;
   function suspendFormSnap() {
    if (formSnapRestoreTimer) {
     clearTimeout(formSnapRestoreTimer);
     formSnapRestoreTimer = null;
    }
    formGrid.style.scrollSnapType = "none";
   }
   function restoreFormSnap() {
    formGrid.style.scrollSnapType = "";
   }
   var formScrollPos = 0;
   var formSettleTarget = null;
   function nearestTileCenterLeft(lookaheadPos) {
    var center = lookaheadPos + formGrid.clientWidth / 2;
    var best = null, bestD = 1e9;
    formTiles.forEach(function(t) {
     if (t.hidden) return;
     var c = t.offsetLeft + t.offsetWidth / 2;
     var d = Math.abs(c - center);
     if (d < bestD) {
      bestD = d;
      best = c;
     }
    });
    if (best == null) return null;
    var maxScroll = Math.max(0, formGrid.scrollWidth - formGrid.clientWidth);
    return Math.max(0, Math.min(maxScroll, best - formGrid.clientWidth / 2));
   }
   function formHoverStep() {
    if (formHoverDir) {
     formSettleTarget = null;
     formHoverVel += (formHoverDir * 6 - formHoverVel) * .07;
     formScrollPos += formHoverVel;
     var maxS = Math.max(0, formGrid.scrollWidth - formGrid.clientWidth);
     formScrollPos = Math.max(0, Math.min(maxS, formScrollPos));
     formGrid.scrollLeft = formScrollPos;
     try {
      requestAnimationFrame(formHoverStep);
     } catch (eR) {
      formHoverActive = false;
     }
     return;
    }
    if (formSettleTarget == null) {
     formSettleTarget = nearestTileCenterLeft(formScrollPos + formHoverVel * 10);
     if (formSettleTarget == null) {
      formHoverActive = false;
      restoreFormSnap();
      return;
     }
    }
    formHoverVel *= .86;
    var diff = formSettleTarget - formScrollPos;
    formScrollPos += diff * .085 + formHoverVel;
    formGrid.scrollLeft = formScrollPos;
    if (Math.abs(diff) < .6 && Math.abs(formHoverVel) < .2) {
     formScrollPos = formSettleTarget;
     formGrid.scrollLeft = formScrollPos;
     formHoverVel = 0;
     formSettleTarget = null;
     formHoverActive = false;
     restoreFormSnap();
     return;
    }
    try {
     requestAnimationFrame(formHoverStep);
    } catch (eR2) {
     formHoverActive = false;
     restoreFormSnap();
    }
   }
   formGrid.addEventListener("mousemove", function(ev) {
    var r = formGrid.getBoundingClientRect();
    if (!r.width) return;
    var x = (ev.clientX - r.left) / r.width;
    var dir = x < .18 ? -1 : x > .82 ? 1 : 0;
    formHoverDir = dir;
    if (dir) {
     stopFormAuto();
     if (!formHoverActive) {
      formHoverActive = true;
      suspendFormSnap();
      formScrollPos = formGrid.scrollLeft;
      formHoverStep();
     }
    }
   });
   formGrid.addEventListener("mouseleave", function() {
    formHoverDir = 0;
   });
  }
  setInterval(function() {
   if (document.hidden) return;
   if (formAutoStopped || currentStep !== STEP.form) return;
   if (!formGrid.offsetParent) return;
   var maxScroll = formGrid.scrollWidth - formGrid.clientWidth;
   if (maxScroll <= 4) return;
   var next = formGrid.scrollLeft + FORM_TILE_STEP;
   if (next >= maxScroll - 4) next = 0;
   try {
    formGrid.scrollTo({
     left: next,
     behavior: "smooth"
    });
   } catch (eS) {
    formGrid.scrollLeft = next;
   }
  }, 3e3);
  formNav.addEventListener("click", function(ev) {
   var btn = ev.target && ev.target.closest ? ev.target.closest("button[data-dir]") : null;
   if (!btn) return;
   stopFormAuto();
   var dir = parseInt(btn.getAttribute("data-dir"), 10) || 1;
   try {
    formGrid.scrollBy({
     left: dir * FORM_TILE_STEP * 2,
     behavior: "smooth"
    });
   } catch (eS) {
    formGrid.scrollLeft += dir * FORM_TILE_STEP * 2;
   }
  });
  function centerSelectedFormTile() {
   try {
    var sel = formGrid.querySelector(".dh-form-tile.is-selected") || formTiles[selectedFormIndex];
    if (!sel) return;
    var target = sel.offsetLeft - (formGrid.clientWidth - sel.offsetWidth) / 2;
    formGrid.scrollTo({
     left: Math.max(0, target),
     behavior: "smooth"
    });
   } catch (e) {}
  }
  function formClassCounts() {
   var n = {
    standard: 0,
    sonder: 0
   };
   formConfig.forEach(function(c) {
    n[c.formClass === "sonder" ? "sonder" : "standard"]++;
   });
   return n;
  }
  function formClassSurcharge() {
   var proc = processChosen() ? process : "uv";
   var a = variantFor(proc, "sonder"), b = variantFor(proc, "standard");
   if (!a || !b || a.id === b.id) return 0;
   return (parseInt(a.price, 10) || 0) - (parseInt(b.price, 10) || 0);
  }
  function setFormTab(tab) {
   if (tab !== "standard" && tab !== "sonder") return;
   if (formTab === tab) return;
   formTab = tab;
   stopFormAuto();
   applyFormTab();
   try {
    formGrid.scrollLeft = 0;
   } catch (e) {}
   var selCfg = formConfig[selectedFormIndex];
   if (selCfg && selCfg.formClass === tab) setTimeout(centerSelectedFormTile, 30);
   scheduleFormArc();
  }
  function applyFormTab() {
   var n = formClassCounts();
   var both = n.standard > 0 && n.sonder > 0;
   formTabs.hidden = !both;
   if (!both) formTab = n.sonder > 0 && !n.standard ? "sonder" : "standard";
   formTiles.forEach(function(t, i) {
    var cfg = formConfig[i];
    var hide = both && cfg && cfg.formClass !== formTab;
    if (t.hidden !== hide) t.hidden = hide;
   });
   if (!both) return;
   var plus = formClassSurcharge();
   Array.prototype.forEach.call(formTabs.querySelectorAll(".dh-form-tab"), function(btn) {
    var tab = btn.getAttribute("data-tab");
    btn.classList.toggle("is-active", tab === formTab);
    var label = btn.querySelector(".dh-form-tab-label");
    var want = tab === "sonder" ? "Sondermarken" + (plus > 0 ? ' <span class="dh-form-tab-plus">+ ' + formatMoney(plus) + "</span>" : "") : "Standardmarken";
    if (label.innerHTML !== want) label.innerHTML = want;
   });
  }
  var formPriceLine = document.createElement("div");
  formPriceLine.className = "dh-price-line";
  formPriceLine.hidden = true;
  panelForm.appendChild(formPriceLine);
  var formBtnWrap = document.createElement("div");
  formBtnWrap.innerHTML = buttonRow(true, false);
  while (formBtnWrap.firstChild) panelForm.appendChild(formBtnWrap.firstChild);
  var panelMaterial = document.createElement("div");
  panelMaterial.className = "dh-panel";
  panelMaterial.innerHTML = '<div class="dh-block-hint dh-material-invalid"></div>' + '<div class="dh-lock-hint"><span class="dh-lock-text"></span><br><button type="button" class="dh-link dh-change-process">Herstellung ändern</button><span class="dh-lock-sep"> · </span><button type="button" class="dh-link dh-compare-link" hidden>Zum Vergleich</button></div>' + buttonRow(true, true);
  var materialNextBtn = panelMaterial.querySelector(".dh-next");
  var materialInvalidHint = panelMaterial.querySelector(".dh-material-invalid");
  var materialLockHint = panelMaterial.querySelector(".dh-lock-hint");
  var materialLockText = panelMaterial.querySelector(".dh-lock-text");
  panelMaterial.querySelector(".dh-change-process").addEventListener("click", function() {
   goTo(STEP.process);
  });
  var panelDesign = document.createElement("div");
  panelDesign.className = "dh-panel";
  panelDesign.innerHTML = buttonRow(true, true);
  var designNextBtn = panelDesign.querySelector(".dh-next");
  var stageTools = document.createElement("div");
  stageTools.className = "dh-stage-tools";
  stageTools.hidden = true;
  var motifSizeWrap = document.createElement("div");
  motifSizeWrap.className = "dh-motif-size";
  motifSizeWrap.innerHTML = '<div class="dh-motif-size-head"><label class="dh-motif-size-label" for="dh-motif-size-range">Motiv-Gr&ouml;&szlig;e</label>' + '<button type="button" class="dh-motif-size-val" title="Auf 100 % zur&uuml;cksetzen" aria-label="Motiv-Gr&ouml;&szlig;e auf 100 % zur&uuml;cksetzen">100&nbsp;%</button></div>' + '<div class="dh-motif-size-row">' + '<button type="button" class="dh-motif-size-btn dh-motif-size-minus" data-step="-5" aria-label="Motiv verkleinern">&minus;</button>' + '<input id="dh-motif-size-range" type="range" min="' + MOTIF_PCT_MIN + '" max="' + MOTIF_PCT_MAX + '" step="1" value="100" aria-label="Motiv-Gr&ouml;&szlig;e in Prozent">' + '<button type="button" class="dh-motif-size-btn dh-motif-size-plus" data-step="5" aria-label="Motiv vergr&ouml;&szlig;ern">+</button>' + "</div>" + '<div class="dh-motif-size-scale"><span>' + MOTIF_PCT_MIN + '&nbsp;%</span><span class="dh-motif-size-mid">100&nbsp;% Standard</span><span>' + MOTIF_PCT_MAX + '&nbsp;%</span></div>' + '<div class="dh-motif-size-note">W&auml;hle zuerst ein Design aus der Liste &ndash; danach stellst du hier die Gr&ouml;&szlig;e des Motivs ein.</div>';
  stageTools.appendChild(motifSizeWrap);
  var motifSizeInput = motifSizeWrap.querySelector("input");
  var motifSizeVal = motifSizeWrap.querySelector(".dh-motif-size-val");
  var motifSizeMinus = motifSizeWrap.querySelector(".dh-motif-size-minus");
  var motifSizePlus = motifSizeWrap.querySelector(".dh-motif-size-plus");
  var motifSizeEl = null;
  function setMotifSizeUi(pct) {
   var p = Math.round(Math.min(MOTIF_PCT_MAX, Math.max(MOTIF_PCT_MIN, pct || 100)));
   var label = p + "&nbsp;%";
   if (motifSizeVal.innerHTML !== label) motifSizeVal.innerHTML = label;
   var fill = ((p - MOTIF_PCT_MIN) / (MOTIF_PCT_MAX - MOTIF_PCT_MIN) * 100).toFixed(2) + "%";
   try {
    if (motifSizeInput.style.getPropertyValue("--dh-fill") !== fill) motifSizeInput.style.setProperty("--dh-fill", fill);
   } catch (eF) {}
   var atMin = p <= MOTIF_PCT_MIN, atMax = p >= MOTIF_PCT_MAX;
   if (motifSizeMinus.disabled !== atMin) motifSizeMinus.disabled = atMin;
   if (motifSizePlus.disabled !== atMax) motifSizePlus.disabled = atMax;
  }
  function setMotifSizeValue(pct) {
   var p = Math.round(Math.min(MOTIF_PCT_MAX, Math.max(MOTIF_PCT_MIN, pct)));
   motifSizeInput.value = String(p);
   onMotifSizeInput();
  }
  motifSizeWrap.addEventListener("click", function(ev) {
   var btn = ev.target && ev.target.closest ? ev.target.closest(".dh-motif-size-btn, .dh-motif-size-val") : null;
   if (!btn || btn.disabled) return;
   ev.preventDefault();
   if (btn.classList.contains("dh-motif-size-val")) {
    setMotifSizeValue(100);
    return;
   }
   var step = parseInt(btn.getAttribute("data-step"), 10) || 0;
   var cur = parseInt(motifSizeInput.value, 10) || 100;
   var snapped = step > 0 ? Math.floor(cur / 5) * 5 + step : Math.ceil(cur / 5) * 5 + step;
   setMotifSizeValue(snapped);
  });
  var stageToolsAnchor = null;
  var stageToolsVerified = false;
  var stageToolsRetryAt = 0;
  var stageToolsFails = 0;
  function stageToolsRoot(host) {
   try {
    return host.closest && (host.closest(".fpd-container") || host.closest("fpd-main")) || null;
   } catch (e) {
    return null;
   }
  }
  function stageToolsClipped(t) {
   try {
    var n = stageTools.parentElement, hops = 0;
    while (n && n !== document.body && hops < 10) {
     var cs = window.getComputedStyle(n);
     if (/hidden|clip/.test(cs.overflowY)) {
      var r = n.getBoundingClientRect();
      if (r.height > 0 && (t.bottom > r.bottom + 2 || t.top < r.top - 2)) return true;
     }
     n = n.parentElement;
     hops++;
    }
   } catch (e) {}
   return false;
  }
  function stageToolsGeometryOk(anchor) {
   var a, t, b;
   try {
    b = document.body.getBoundingClientRect();
    a = anchor.getBoundingClientRect();
    t = stageTools.getBoundingClientRect();
   } catch (e) {
    return true;
   }
   if (!b.width && !b.height) return true;
   if (!a.width || !a.height) return null;
   if (!t.width || !t.height) return false;
   if (t.top < a.bottom - 6) return false;
   if (t.top - a.bottom > 220) return false;
   if (t.right < a.left + 40 || t.left > a.right - 40) return false;
   if (stageToolsClipped(t)) return false;
   return true;
  }
  function mountStageTools() {
   var host = findStageHost();
   if (!host || !host.parentNode) return;
   var anchors = [ host ];
   var root = stageToolsRoot(host);
   if (root && root !== host && root.parentNode) anchors.push(root);
   for (var i = 0; i < anchors.length; i++) {
    var a = anchors[i];
    if (stageTools.previousElementSibling !== a || stageTools.parentNode !== a.parentNode) {
     a.parentNode.insertBefore(stageTools, a.nextSibling);
    }
    collapseStageRatioBox();
    var ok = stageToolsGeometryOk(a);
    if (ok !== false) {
     if (stageToolsAnchor !== a) {
      stageToolsAnchor = a;
      console.log("[dh-stepper] " + STEPPER_VERSION + " Motiv-Regler unter der Bühne: " + nodeChain(a) + (ok === true ? "" : " (Lage noch nicht geprüft)"));
     }
     stageToolsVerified = ok === true;
     stageToolsFails = 0;
     return;
    }
   }
   var row = panelDesign.querySelector(".dh-btn-row");
   if (stageTools.parentNode !== panelDesign) {
    if (row) panelDesign.insertBefore(stageTools, row); else panelDesign.appendChild(stageTools);
   }
   stageToolsFails++;
   stageToolsRetryAt = stageToolsFails >= 3 ? Infinity : Date.now() + 3e3;
   if (stageToolsAnchor !== panelDesign) {
    stageToolsAnchor = panelDesign;
    console.warn("[dh-stepper] " + STEPPER_VERSION + " Motiv-Regler: unter der Bühne kein Platz (" + nodeChain(host) + ") — bleibt im Design-Schritt" + (stageToolsFails >= 3 ? " (endgültig)" : ""));
   }
   stageToolsVerified = false;
  }
  function ensureStageTools() {
   var attached = !!stageTools.parentNode && document.body.contains(stageTools);
   if (attached && stageToolsAnchor === panelDesign) {
    if (Date.now() < stageToolsRetryAt) return;
    mountStageTools();
    return;
   }
   if (attached && stageToolsAnchor) {
    var host = findStageHost();
    var moved = host && stageToolsAnchor !== host && !stageToolsAnchor.contains(host);
    if (!moved) {
     if (stageToolsVerified) return;
     var ok = stageToolsGeometryOk(stageToolsAnchor);
     if (ok === true) {
      stageToolsVerified = true;
      return;
     }
     if (ok === null) return;
    }
   }
   mountStageTools();
  }
  function currentFrontMotif() {
   try {
    var vi = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
    var c = vi && vi.fabricCanvas;
    var m = null;
    if (c) getMotifElements().forEach(function(el) {
     if (el.canvas === c) m = el;
    });
    return m;
   } catch (e) {
    return null;
   }
  }
  function ensureMotifBase(m) {
   if (!m) return 1;
   if (!m.__dhScaleBase) {
    m.__dhScaleBase = m.scaleX || 1;
    m.__dhScaleBaseY = m.scaleY || 1;
   }
   return m.__dhScaleBase;
  }
  function motifPercent(m) {
   var base = ensureMotifBase(m);
   var pct = Math.round((m.scaleX || 1) / (base || 1) * 100);
   return Math.min(MOTIF_PCT_MAX, Math.max(MOTIF_PCT_MIN, pct));
  }
  function clampMotifScale(m) {
   var base = ensureMotifBase(m);
   var baseY = m.__dhScaleBaseY || base;
   var lo = base * MOTIF_PCT_MIN / 100, hi = base * MOTIF_PCT_MAX / 100;
   var sx = m.scaleX || base;
   var target = Math.min(hi, Math.max(lo, sx));
   if (Math.abs(target - sx) > 1e-4) {
    var f = target / (base || 1);
    m.scaleX = target;
    m.scaleY = baseY * f;
    if (m.setCoords) m.setCoords();
    return true;
   }
   return false;
  }
  function setMotifSizeEmpty(empty) {
   if (motifSizeWrap.classList.contains("is-empty") === empty) return;
   motifSizeWrap.classList.toggle("is-empty", empty);
   motifSizeInput.disabled = empty;
   motifSizeVal.disabled = empty;
   if (empty) {
    motifSizeMinus.disabled = true;
    motifSizePlus.disabled = true;
    motifSizeInput.value = "100";
    motifSizeVal.innerHTML = "&ndash;";
    try {
     motifSizeInput.style.setProperty("--dh-fill", ((100 - MOTIF_PCT_MIN) / (MOTIF_PCT_MAX - MOTIF_PCT_MIN) * 100).toFixed(2) + "%");
    } catch (eF) {}
   }
  }
  function syncMotifSizeSlider() {
   if (currentStep !== STEP.design) {
    if (!stageTools.hidden) {
     stageTools.hidden = true;
     collapseStageRatioBox();
    }
    motifSizeEl = null;
    return;
   }
   var wasHidden = stageTools.hidden;
   if (wasHidden) stageTools.hidden = false;
   ensureStageTools();
   if (wasHidden) collapseStageRatioBox();
   var m = currentFrontMotif();
   if (!m) {
    setMotifSizeEmpty(true);
    motifSizeEl = null;
    return;
   }
   setMotifSizeEmpty(false);
   motifSizeEl = m;
   ensureMotifBase(m);
   m.minScaleLimit = m.__dhScaleBase * MOTIF_PCT_MIN / 100;
   var pct = motifPercent(m);
   if (document.activeElement !== motifSizeInput && motifSizeInput.value !== String(pct)) {
    motifSizeInput.value = String(pct);
   }
   setMotifSizeUi(pct);
  }
  var motifSizeCheckTimer = null;
  function onMotifSizeInput() {
   var m = motifSizeEl || currentFrontMotif();
   if (!m) return;
   ensureMotifBase(m);
   var f = Math.min(MOTIF_PCT_MAX / 100, Math.max(MOTIF_PCT_MIN / 100, (parseInt(motifSizeInput.value, 10) || 100) / 100));
   setMotifSizeUi(Math.round(f * 100));
   m.__dhMotifScaled = true;
   m.__dhDragging = true;
   dhDragActive = true;
   try {
    var eb = m.getBoundingRect(true, true);
    var cx = eb.left + eb.width / 2, cy = eb.top + eb.height / 2;
    m.scaleX = m.__dhScaleBase * f;
    m.scaleY = m.__dhScaleBaseY * f;
    if (m.setCoords) m.setCoords();
    var eb2 = m.getBoundingRect(true, true);
    m.left += cx - (eb2.left + eb2.width / 2);
    m.top += cy - (eb2.top + eb2.height / 2);
    if (m.setCoords) m.setCoords();
    if (m.canvas) m.canvas.renderAll();
   } catch (eS) {}
   scheduleOverlayDraw();
   clearTimeout(motifSizeCheckTimer);
   motifSizeCheckTimer = setTimeout(function() {
    m.__dhDragging = false;
    dhDragActive = false;
    checkFrontElement(m);
    updateThumbnails();
   }, 250);
  }
  motifSizeInput.addEventListener("input", onMotifSizeInput);
  motifSizeInput.addEventListener("change", onMotifSizeInput);
  var panelLabeling = document.createElement("div");
  panelLabeling.className = "dh-panel";
  var selectedFont = "";
  var builderDefaultFont = "";
  var builderDefaultFontWt = "";
  var TOOL_FONTS = [ "Architects Daughter", "Caveat Brush", "DM Serif Display", "Jolly Lodger", "Mountains of Christmas", "Mystery Quest", "Open Sans", "Sedgwick Ave" ];
  var DEFAULT_FONT = "Open Sans";
  var BACK_FONT_WHITELIST = [ "Open Sans", "Architects Daughter" ];
  var allowedFonts = [];
  function normFontName(n) {
   return String(n || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }
  function fontInList(font, list) {
   var want = normFontName(font);
   if (!want) return false;
   for (var i = 0; i < list.length; i++) {
    if (normFontName(list[i]) === want) return true;
   }
   return false;
  }
  function fontIsToolFont(font) {
   return fontInList(font, TOOL_FONTS);
  }
  function fontIsBackSafe(font) {
   return fontInList(font, BACK_FONT_WHITELIST);
  }
  function resolveAllowedFont(font) {
   var want = normFontName(font);
   if (!want) return "";
   for (var i = 0; i < allowedFonts.length; i++) {
    if (normFontName(allowedFonts[i]) === want) return allowedFonts[i];
   }
   return "";
  }
  function backDefaultFont() {
   var f = resolveAllowedFont(DEFAULT_FONT);
   if (f && fontIsBackSafe(f)) return f;
   if (builderDefaultFontWt && fontIsBackSafe(builderDefaultFontWt)) return builderDefaultFontWt;
   for (var i = 0; i < allowedFonts.length; i++) {
    if (fontIsBackSafe(allowedFonts[i])) return allowedFonts[i];
   }
   return DEFAULT_FONT;
  }
  function effectiveBackFont(font) {
   if (font && fontIsBackSafe(font)) return font;
   return backDefaultFont();
  }
  function getConfiguredFonts() {
   try {
    var fonts = fpd.mainOptions && fpd.mainOptions.fonts || [];
    return fonts.map(function(f) {
     return typeof f === "string" ? f : f && (f.name || f.family) || "";
    }).filter(Boolean);
   } catch (e) {
    return [];
   }
  }
  function widenTextbox(e) {
   try {
    if (typeof e.width !== "number") return;
    var pb = e.getBoundingRect(true, true);
    e.__dhPrevCenter = {
     x: pb.left + pb.width / 2,
     y: pb.top + pb.height / 2
    };
    e.set("width", 4e3);
   } catch (eW) {}
  }
  function applyFont(font) {
   if (!font) return;
   try {
    var backFont = effectiveBackFont(font);
    var nameEls = [];
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (typeof e.set !== "function") return;
     if (e.title === NAME_ELEMENT_TITLE) {
      widenTextbox(e);
      e.set("fontFamily", font);
      nameEls.push(e);
     } else if (e.title === CUSTOM_TEXT_ELEMENT_TITLE) {
      widenTextbox(e);
      e.set("fontFamily", backFont);
     }
    });
    applyNameAutoSize();
    nameEls.forEach(function(e) {
     if (e.fire) e.fire("changed");
    });
    try {
     writeCustomText(customTextValue && customTextValue.length ? customTextValue : "");
    } catch (e3) {}
    fpd.viewInstances.forEach(function(v) {
     try {
      v.fabricCanvas.renderAll();
     } catch (e2) {}
    });
    updateFontHint();
    updateThumbnails();
   } catch (e) {}
  }
  function updateFontHint() {
   var hint = fontWrap.querySelector(".dh-font-hint");
   if (!hint) return;
   var show = !!selectedFont && !fontIsBackSafe(selectedFont);
   hint.style.display = show ? "block" : "none";
   if (show) {
    hint.textContent = "Aus Gründen der Lesbarkeit wird die Rückseite ausschließlich in der Schriftart " + backDefaultFont() + " graviert.";
   }
  }
  var fontWrap = document.createElement("div");
  fontWrap.style.margin = "16px 0";
  fontWrap.innerHTML = '<label style="display:block;font-size:14px;margin-bottom:6px;">Schriftart</label>' + '<div class="dh-font-dd">' + '<button type="button" class="dh-font-dd-btn">Standard</button>' + '<div class="dh-font-dd-list"></div>' + "</div>" + '<div class="dh-font-hint" style="display:none;font-size:12px;line-height:1.5;color:#7a5b00;margin-top:6px;"></div>';
  var fontDd = fontWrap.querySelector(".dh-font-dd");
  var fontBtn = fontWrap.querySelector(".dh-font-dd-btn");
  var fontList = fontWrap.querySelector(".dh-font-dd-list");
  fontBtn.addEventListener("click", function() {
   fontDd.classList.toggle("is-open");
  });
  document.addEventListener("click", function(ev) {
   if (!fontDd.contains(ev.target)) fontDd.classList.remove("is-open");
  });
  function selectFont(f) {
   if (!f) return;
   selectedFont = f;
   applyFont(f);
   fontBtn.textContent = f;
   fontBtn.style.fontFamily = '"' + f + '"';
   Array.prototype.forEach.call(fontList.children, function(it) {
    it.classList.toggle("is-selected", it.textContent === f);
   });
  }
  var fontSelectBuilt = false;
  function populateFontSelect() {
   if (fontSelectBuilt) return;
   var fonts = getConfiguredFonts();
   if (!fonts.length) {
    fontWrap.style.display = "none";
    return;
   }
   fontSelectBuilt = true;
   try {
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.fontFamily) builderDefaultFont = e.fontFamily;
     if (e.title === CUSTOM_TEXT_ELEMENT_TITLE && e.fontFamily) builderDefaultFontWt = e.fontFamily;
    });
   } catch (e) {}
   allowedFonts = [];
   var rejected = [];
   fonts.forEach(function(f) {
    if (!fontIsToolFont(f)) {
     rejected.push(f);
    } else if (!resolveAllowedFont(f)) {
     allowedFonts.push(f);
    }
   });
   if (rejected.length) {
    console.warn("[dh-stepper] " + STEPPER_VERSION + ": FPD-Schriften ohne Tool-Pendant ausgeblendet: " + rejected.join(", "));
   }
   var missing = TOOL_FONTS.filter(function(t) {
    return !resolveAllowedFont(t);
   });
   if (missing.length) {
    console.log("[dh-stepper] " + STEPPER_VERSION + ": Tool-Schriften nicht in der FPD-Liste: " + missing.join(", "));
   }
   if (!allowedFonts.length) {
    fontWrap.style.display = "none";
    console.warn("[dh-stepper] " + STEPPER_VERSION + ": keine Tool-Schrift in der FPD-Liste — Schriftwahl ausgeblendet, Builder-Schrift bleibt (" + builderDefaultFont + " / " + builderDefaultFontWt + ")");
    return;
   }
   fontWrap.style.display = "";
   allowedFonts.forEach(function(f) {
    var item = document.createElement("div");
    item.className = "dh-font-dd-item";
    item.textContent = f;
    item.style.fontFamily = '"' + f + '"';
    item.addEventListener("click", function() {
     selectFont(f);
     fontDd.classList.remove("is-open");
    });
    fontList.appendChild(item);
   });
   var startFont = resolveAllowedFont(DEFAULT_FONT) || resolveAllowedFont(builderDefaultFont) || allowedFonts[0];
   selectFont(startFont);
   console.log("[dh-stepper] " + STEPPER_VERSION + " Schriften: " + allowedFonts.join(", ") + " | Start: " + startFont + " | Rückseite-Schriftart: " + backDefaultFont());
  }
  var labelingBtnRow = document.createElement("div");
  labelingBtnRow.className = "dh-btn-row";
  labelingBtnRow.style.marginTop = "0";
  labelingBtnRow.innerHTML = '<button class="dh-back" type="button">Zurück</button><span></span>';
  panelLabeling.appendChild(labelingBtnRow);
  panelLabeling.appendChild(fontWrap);
  function sideCard(title) {
   var card = document.createElement("div");
   card.className = "dh-side-card";
   var head = document.createElement("div");
   head.className = "dh-side-card-head";
   head.textContent = title;
   card.appendChild(head);
   return card;
  }
  var frontCard = sideCard("Vorderseite");
  var backCard = sideCard("Rückseite");
  function buildSizeRow(id, value, onPick) {
   var row = document.createElement("div");
   row.className = "dh-size-row";
   var opts = "";
   for (var st = FONT_STEP_MIN; st <= FONT_STEP_MAX; st++) {
    opts += '<option value="' + st + '"' + (st === value ? " selected" : "") + ">" + st + "</option>";
   }
   row.innerHTML = '<label for="' + id + '">Schriftgröße</label>' + '<select id="' + id + '" class="dh-size-select">' + opts + "</select>";
   var sel = row.querySelector("select");
   sel.addEventListener("change", function() {
    var v = parseInt(sel.value, 10);
    if (!isFinite(v)) return;
    onPick(Math.max(FONT_STEP_MIN, Math.min(FONT_STEP_MAX, v)));
   });
   return row;
  }
  calibrateSizeSteps();
  var nameSizeRow = buildSizeRow("dh-name-size", nameSizeStep, function(v) {
   nameSizeStep = v;
   applyNameAutoSize();
   refreshSizeOptions();
  });
  var textSizeRow = buildSizeRow("dh-text-size", customTextSizeStep, function(v) {
   customTextSizeStep = v;
   writeCustomText(customTextValue);
   refreshSizeOptions();
  });
  function sizeSelectFor(id) {
   return document.getElementById(id);
  }
  function applySizeOptions(id, current, maxStep) {
   var sel = sizeSelectFor(id);
   if (!sel) return;
   Array.prototype.forEach.call(sel.options, function(o) {
    var v = parseInt(o.value, 10);
    var dis = maxStep > 0 && v > maxStep;
    if (o.disabled !== dis) o.disabled = dis;
   });
   if (sel.value !== String(current)) sel.value = String(current);
  }
  function refreshSizeOptions() {
   try {
    var frontCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
    var nameEl = null;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.canvas === frontCanvas) nameEl = e;
    });
    var nameMax = 0;
    if (nameEl && nameValue) {
     var c = elementCenter(nameEl, null);
     nameMax = maxFittingStep(nameEl, MOTIF_FRONT_VIEW_INDEX, c.x, c.y);
     if (nameSizeStep > nameMax && nameMax) nameSizeStep = nameMax;
     layoutTextAt(nameEl, pxForStep(nameSizeStep, MOTIF_FRONT_VIEW_INDEX), c.x, c.y);
     if (nameEl.canvas) nameEl.canvas.renderAll();
    }
    nameMaxStepCached = nameMax;
    applySizeOptions("dh-name-size", nameSizeStep, nameMax);
    var wt = getCustomTextElement();
    var textMax = 0;
    if (wt && customTextValue) {
     var cx = customTextCenterRef ? customTextCenterRef.x : getStageSize().w / 2;
     var cy = customTextCenterRef ? customTextCenterRef.y : getStageSize().h / 2;
     textMax = maxFittingStep(wt, BACK_VIEW_INDEX, cx, cy);
     if (customTextSizeStep > textMax && textMax) customTextSizeStep = textMax;
     layoutTextAt(wt, pxForStep(customTextSizeStep, BACK_VIEW_INDEX), cx, cy);
     if (wt.canvas) wt.canvas.renderAll();
    }
    textMaxStepCached = textMax;
    applySizeOptions("dh-text-size", customTextSizeStep, textMax);
    updateThumbnails();
   } catch (e) {}
  }
  var nameField = buildField(fpd, {
   id: "dog-name-input",
   label: "Name des Hundes (optional)",
   placeholder: "z. B. Bello",
   maxlength: 15,
   filter: /[^A-Za-zÄÖÜäöüß \-]/g,
   hintText: "Nur Buchstaben möglich",
   elementTitle: NAME_ELEMENT_TITLE,
   fallbackText: NAME_PLACEHOLDER,
   viewIndex: 0,
   onCommit: function(val) {
    afterTextEntry(MOTIF_FRONT_VIEW_INDEX, val);
   }
  }, function(val) {
   nameValue = val;
   applyNameAutoSize();
   refreshSizeOptions();
   render();
   try {
    scheduleNameCheck();
   } catch (eN) {}
  });
  frontCard.appendChild(nameField);
  frontCard.appendChild(nameSizeRow);
  var nameInfo = nameField.querySelector("#dog-name-input-info");
  if (nameInfo) nameInfo.textContent = "Tipp: Du kannst den Namen direkt auf der Marke verschieben und frei platzieren.";
  var customTextFieldCfg = {
   id: "custom-text-input",
   label: "Wunschtext (optional)",
   help: "Wie viele Zeilen möglich sind, hängt von der Markengröße ab: 30 mm " + "drei Zeilen, 25 mm zwei, 20 mm eine — mit bis zu 16 Zeichen je Zeile. " + "Den Umbruch setzt du mit der Enter-Taste genau dort, wo du ihn haben " + "willst. Die Schriftgröße wählst du selbst — Größen, die für deinen Text zu groß wären, sind in der Liste " + "ausgegraut; mit jeder Zeile wird es enger. Kleine Schriftgrößen können " + "auf der fertigen Marke schwerer lesbar sein als in der Vorschau. " + "Für die Lesbarkeit sehr langer Wunschtexte übernehmen wir keine Haftung; " + "Reklamationen, die allein auf der gewählten Textlänge beruhen, sind " + "ausgeschlossen.",
   placeholder: "z. B. 0176 1234567",
   maxlength: 50,
   multiline: true,
   rows: 3,
   filter: /[^0-9A-Za-zÄÖÜäöüß+\-.,!?()@&\/ \n]/g,
   hintText: "Dieses Zeichen ist nicht möglich",
   lengthWarnText: "Diese Schriftgröße passt nicht mehr — angezeigt wird die größte passende.",
   limitText: "Das passt so nicht mehr auf die Marke",
   limitTexts: {
    lines: function(res) {
     return res.limit === 1 ? "Diese Markengröße trägt nur eine Zeile" : "Diese Markengröße trägt höchstens " + res.limit + " Zeilen";
    },
    linelen: function(res) {
     return "Höchstens " + res.limit + " Zeichen pro Zeile";
    },
    fit: "Das passt nicht mehr auf die Marke — kürze den Text oder eine Zeile"
   },
   elementTitle: CUSTOM_TEXT_ELEMENT_TITLE,
   fallbackText: "",
   write: writeCustomText,
   viewIndex: 1,
   onCommit: function(val) {
    afterTextEntry(BACK_VIEW_INDEX, val);
   }
  };
  backCard.appendChild(buildField(fpd, customTextFieldCfg, function(val) {
   customTextValue = val;
   refreshSizeOptions();
  }));
  function reconcileCustomTextToLimit() {
   var limit = customTextLineLimit();
   var lines = String(customTextValue || "").replace(/\r/g, "").replace(/\n+$/, "").split("\n");
   if (lines.length > limit) {
    customTextValue = lines.slice(0, limit).join("\n");
    var input = document.getElementById("custom-text-input");
    if (input) input.value = customTextValue;
    if (customTextFieldCfg) customTextFieldCfg._lastGood = customTextValue;
    var hint = document.getElementById("custom-text-input-hint");
    if (hint) {
     hint.textContent = (limit === 1 ? "Diese Markengröße trägt nur eine Zeile" : "Diese Markengröße trägt höchstens " + limit + " Zeilen") + " — der Rest wurde entfernt";
     setTimeout(function() {
      if (hint.textContent.indexOf("wurde entfernt") !== -1) hint.textContent = "";
     }, 6e3);
    }
   }
   writeCustomText(customTextValue);
  }
  backCard.appendChild(textSizeRow);
  panelLabeling.appendChild(frontCard);
  panelLabeling.appendChild(backCard);
  var variantBlockHint = document.createElement("div");
  variantBlockHint.className = "dh-block-hint";
  var panels = [ panelProcess, panelForm, panelMaterial, panelDesign, panelLabeling ];
  panels.forEach(function(p) {
   stepper.appendChild(p);
  });
  processNextBtn.addEventListener("click", function() {
   if (processChosen()) advanceTo(STEP.form);
  });
  panelForm.querySelector(".dh-next").addEventListener("click", function() {
   advanceTo(STEP.material);
  });
  panelMaterial.querySelector(".dh-next").addEventListener("click", function() {
   advanceTo(STEP.design);
  });
  designNextBtn.addEventListener("click", function() {
   advanceTo(STEP.text);
  });
  panels.forEach(function(p, i) {
   var back = p.querySelector(".dh-back");
   if (back) back.addEventListener("click", function() {
    if (i > 0) goTo(i - 1);
   });
  });
  function advanceTo(i) {
   if (i > unlocked) unlocked = i;
   if (i > STEP.form) confirmForm();
   goTo(i);
  }
  function confirmForm() {
   formConfirmed = true;
  }
  function goTo(i) {
   var prev = currentStep;
   currentStep = i;
   if (i !== STEP.design) hideCoach();
   applyTextElementPolicy();
   if (i === STEP.text && prev !== STEP.text) selectNameElement();
   if (i === STEP.form && prev !== STEP.form) {
    formTab = currentFormClass();
    applyFormTab();
    setTimeout(function() {
     centerSelectedFormTile();
     scheduleFormArc();
    }, 60);
   }
   render();
  }
  document.addEventListener("click", function(ev) {
   try {
    if (currentStep !== STEP.material) return;
    var item = ev.target && ev.target.closest ? ev.target.closest(".fpd-item") : null;
    if (!item || item.classList.contains("fpd-category") || item.classList.contains("fpd-hidden")) return;
    if (item.classList.contains("dh-locked-tile")) return;
    if (!item.closest(MATERIAL_MODULE_SELECTOR)) return;
    var tries = 0;
    var poll = setInterval(function() {
     if (currentStep !== STEP.material) {
      clearInterval(poll);
      return;
     }
     if (materialStepSatisfied()) {
      clearInterval(poll);
      advanceTo(STEP.design);
     } else if (++tries > 20) clearInterval(poll);
    }, 150);
   } catch (e) {}
  });
  function designStepSatisfied() {
   return noDesignChosen || getMotifElements().length > 0;
  }
  function materialStepSatisfied() {
   var mats = getAllMaterialElements();
   if (!mats.length) return false;
   for (var i = 0; i < mats.length; i++) {
    if (!materialElementAllowed(mats[i])) return false;
   }
   return true;
  }
  function processChosen() {
   return process === "uv" || process === "handcraft";
  }
  function normOpt(s) {
   return String(s || "").trim().toLowerCase();
  }
  function formatMoney(cents) {
   var n = (parseInt(cents, 10) || 0) / 100;
   try {
    return new Intl.NumberFormat("de-DE", {
     style: "currency",
     currency: SHOP_CURRENCY || "EUR"
    }).format(n);
   } catch (e) {
    return n.toFixed(2).replace(".", ",") + " €";
   }
  }
  function variantOptions(v) {
   return (v && v.options || []).map(function(o) {
    return String(o == null ? "" : o);
   });
  }
  function anyVariantHasFormClass() {
   return PRODUCT_VARIANTS.some(function(v) {
    return variantOptions(v).some(function(o) {
     return FORM_CLASS_PATTERNS.standard.test(o) || FORM_CLASS_PATTERNS.sonder.test(o);
    });
   });
  }
  function variantFor(proc, formClass) {
   var pp = PROCESS_PATTERNS[proc], fp = FORM_CLASS_PATTERNS[formClass];
   if (!pp || !fp) return null;
   var exact = null, loose = null;
   PRODUCT_VARIANTS.forEach(function(v) {
    var opts = variantOptions(v);
    if (!opts.some(function(o) {
     return pp.test(o);
    })) return;
    if (opts.some(function(o) {
     return fp.test(o);
    })) {
     if (!exact) exact = v;
    } else if (!loose) loose = v;
   });
   if (exact) return exact;
   if (loose && !anyVariantHasFormClass()) return loose;
   return null;
  }
  function processLabel(key) {
   var pp = PROCESS_PATTERNS[key];
   for (var i = 0; i < PRODUCT_VARIANTS.length; i++) {
    var opts = variantOptions(PRODUCT_VARIANTS[i]);
    for (var j = 0; j < opts.length; j++) {
     if (pp.test(opts[j])) return opts[j];
    }
   }
   return PROCESS_FALLBACK_LABELS[key] || key;
  }
  function processSurcharge() {
   var a = processMinPrice("handcraft"), b = processMinPrice("uv");
   if (a == null || b == null) return 0;
   return a - b;
  }
  function currentFormClass() {
   var cfg = formConfig[selectedFormIndex];
   return cfg && cfg.formClass ? cfg.formClass : "sonder";
  }
  function currentVariant() {
   if (!processChosen()) return null;
   return variantFor(process, currentFormClass());
  }
  function variantOrderable() {
   if (!PRODUCT_VARIANTS.length) return true;
   var v = currentVariant();
   return !!v && v.available !== false;
  }
  function isOurNode(el) {
   try {
    return !!(el && el.closest && el.closest(".dh-stepper, .dh-views, .dh-topbar, .dh-coach, .dh-modal-backdrop"));
   } catch (e) {
    return false;
   }
  }
  function hidePickerContainer(el) {
   try {
    var c = el.closest("variant-radios, variant-selects, variant-picker, variant-option, .product-form__input, fieldset") || el.parentElement;
    if (c && !isOurNode(c) && !c.classList.contains("dh-picker-hidden")) c.classList.add("dh-picker-hidden");
   } catch (e) {}
  }
  function driveThemeVariant(v) {
   var hits = [];
   variantOptions(v).forEach(function(val) {
    var want = normOpt(val), done = false;
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length && !done; i++) {
     var r = radios[i];
     if (isOurNode(r) || normOpt(r.value) !== want) continue;
     hidePickerContainer(r);
     if (!r.checked) {
      try {
       r.click();
      } catch (eC) {}
      if (!r.checked) {
       r.checked = true;
       try {
        r.dispatchEvent(new Event("change", {
         bubbles: true
        }));
       } catch (eE) {}
      }
     }
     hits.push("radio:" + val);
     done = true;
    }
    if (done) return;
    var selects = document.querySelectorAll("select");
    for (var j = 0; j < selects.length && !done; j++) {
     var s = selects[j];
     if (isOurNode(s) || s.name === "id") continue;
     for (var k = 0; k < s.options.length; k++) {
      var o = s.options[k];
      if (normOpt(o.value) === want || normOpt(o.textContent) === want) {
       hidePickerContainer(s);
       if (s.selectedIndex !== k) {
        s.selectedIndex = k;
        try {
         s.dispatchEvent(new Event("change", {
          bubbles: true
         }));
        } catch (eE2) {}
       }
       hits.push("select:" + val);
       done = true;
       break;
      }
     }
    }
   });
   if (!pickerLogDone) {
    pickerLogDone = true;
    console.log("[dh-stepper] " + STEPPER_VERSION + " Varianten-Wähler: " + (hits.length ? hits.join(", ") : "keiner gefunden — Formular-ID wird direkt gesetzt"));
   }
   setTimeout(function() {
    ensureFormVariantId(v.id);
   }, 250);
   return hits.length;
  }
  function ensureFormVariantId(id) {
   if (!atcForm || id == null) return;
   var inp = atcForm.querySelector('input[name="id"], select[name="id"]');
   if (!inp) {
    inp = document.createElement("input");
    inp.type = "hidden";
    inp.name = "id";
    atcForm.appendChild(inp);
   }
   if (String(inp.value) === String(id)) return;
   inp.value = String(id);
   if (inp.tagName === "SELECT") {
    try {
     inp.dispatchEvent(new Event("change", {
      bubbles: true
     }));
    } catch (eS) {}
   }
   if (formIdLoggedFor !== id) {
    formIdLoggedFor = id;
    console.log("[dh-stepper] " + STEPPER_VERSION + " Formular-Varianten-ID gesetzt: " + id);
   }
   orderPropsSig = null;
   try {
    syncOrderPropertyInputs();
   } catch (eP) {}
  }
  function rehidePickerContainers() {
   try {
    var wants = {};
    PRODUCT_VARIANTS.forEach(function(v) {
     variantOptions(v).forEach(function(o) {
      wants[normOpt(o)] = true;
     });
    });
    document.querySelectorAll('input[type="radio"], select').forEach(function(el) {
     if (isOurNode(el) || el.closest(".dh-picker-hidden")) return;
     if (el.tagName === "SELECT") {
      if (el.name === "id") return;
      for (var k = 0; k < el.options.length; k++) {
       if (wants[normOpt(el.options[k].value)]) {
        hidePickerContainer(el);
        return;
       }
      }
      return;
     }
     if (wants[normOpt(el.value)]) hidePickerContainer(el);
    });
   } catch (e) {}
  }
  function driveVariant() {
   var v = currentVariant();
   if (!v) return;
   if (drivenVariantId === v.id) {
    ensureFormVariantId(v.id);
    rehidePickerContainers();
    return;
   }
   drivenVariantId = v.id;
   driveThemeVariant(v);
  }
  function variantsForProcess(key) {
   var pp = PROCESS_PATTERNS[key];
   if (!pp) return [];
   return PRODUCT_VARIANTS.filter(function(v) {
    return variantOptions(v).some(function(o) {
     return pp.test(o);
    });
   });
  }
  function processPrices(key) {
   var out = [];
   variantsForProcess(key).forEach(function(v) {
    var p = parseInt(v.price, 10);
    if (isFinite(p) && out.indexOf(p) === -1) out.push(p);
   });
   out.sort(function(a, b) {
    return a - b;
   });
   return out;
  }
  function processMinPrice(key) {
   var p = processPrices(key);
   return p.length ? p[0] : null;
  }
  function processCardLines(key) {
   var cats = getMaterialCategoryTitles();
   var fallback = (PROCESS_CARD_LINES[key] || []).slice();
   if (!cats.length) return fallback;
   var allowed = [], denied = [];
   cats.forEach(function(c) {
    (categoryAllowedFor("uv", c) ? allowed : denied).push(c);
   });
   if (key === "uv") {
    var l = [];
    if (allowed.length) l.push({
     ok: true,
     text: "Materialien: " + joinDe(allowed)
    });
    if (denied.length) l.push({
     ok: false,
     text: "Nicht möglich: " + joinDe(denied)
    });
    return l.length ? l : fallback;
   }
   return [ {
    ok: true,
    text: denied.length ? "Alle Materialien – auch " + joinDe(denied) : "Alle Materialien"
   }, {
    ok: true,
    text: "Kräftige Farben, von Hand ausgemalt"
   } ];
  }
  var processCardsDynamic = false;
  var PROC_ZOOM_SVG = '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true" focusable="false"><circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="2.2"></circle><path d="M12.8 12.8L17.5 17.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path><path d="M6 8.5h5M8.5 6v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>';
  function buildProcessCards() {
   processCardsWrap.innerHTML = "";
   processCards = {};
   processCardsDynamic = getMaterialCategoryTitles().length > 0;
   PROCESS_KEYS.forEach(function(key) {
    var card = document.createElement("div");
    card.className = "dh-proc-card";
    card.setAttribute("role", "button");
    card.setAttribute("tabindex", "0");
    card.setAttribute("data-process", key);
    card.addEventListener("keydown", function(ev) {
     if (ev.key === "Enter" || ev.key === " " || ev.key === "Spacebar") {
      ev.preventDefault();
      setProcess(key);
     }
    });
    var prices = processPrices(key);
    var priceHtml = "";
    if (prices.length) {
     priceHtml = '<span class="dh-proc-price">' + (prices.length > 1 ? '<small>ab</small> ' : "") + formatMoney(prices[0]) + "</span>";
    }
    var plusHtml = "";
    if (key === "handcraft") {
     var mu = processMinPrice("uv"), mh = processMinPrice("handcraft");
     if (mu != null && mh != null && mh > mu) {
      plusHtml = '<span class="dh-proc-plus">+ ' + formatMoney(mh - mu) + " gegenüber UV</span>";
     }
    }
    var label = processLabel(key);
    var imgUrl = processImageUrl(key);
    var imgHtml = imgUrl ? '<button type="button" class="dh-proc-thumb-btn" aria-label="Gravurbeispiel vergrößern" aria-expanded="false"><img class="dh-proc-thumb" src="' + processThumbUrl(imgUrl).replace(/"/g, "%22") + '" alt="" loading="lazy" draggable="false"><span class="dh-proc-thumb-zoom" aria-hidden="true">' + PROC_ZOOM_SVG + '</span></button>' : '<span class="dh-proc-thumb is-empty"></span>';
    var bigHtml = imgUrl ? '<div class="dh-proc-big" hidden><div class="dh-proc-big-inner"><img alt="' + label + ' – Gravurbeispiel" draggable="false" data-src="' + imgUrl.replace(/"/g, "%22") + '"><button type="button" class="dh-proc-big-close" aria-label="Verkleinern">&times;</button></div></div>' : "";
    var lines = processCardLines(key).map(function(l) {
     return '<li class="' + (l.ok ? "is-ok" : "is-no") + '">' + l.text + "</li>";
    }).join("");
    card.innerHTML = '<div class="dh-proc-row">' + imgHtml + '<div class="dh-proc-main"><div class="dh-proc-title">' + label + "</div>" + plusHtml + "</div>" + priceHtml + "</div>" + bigHtml + '<ul class="dh-proc-lines">' + lines + "</ul>";
    card.addEventListener("click", function(ev) {
     var z = ev.target && ev.target.closest ? ev.target.closest(".dh-proc-thumb-btn, .dh-proc-big") : null;
     if (z) {
      ev.preventDefault();
      ev.stopPropagation();
      toggleProcZoom(card);
      return;
     }
     setProcess(key);
    });
    processCardsWrap.appendChild(card);
    processCards[key] = card;
   });
   updateProcessCards();
  }
  function toggleProcZoom(card, force) {
   var big = card.querySelector(".dh-proc-big");
   var btn = card.querySelector(".dh-proc-thumb-btn");
   if (!big) return;
   var open = typeof force === "boolean" ? force : big.hidden;
   if (open) {
    var img = big.querySelector("img");
    if (img && !img.getAttribute("src")) img.src = img.getAttribute("data-src");
    big.hidden = false;
    void big.offsetHeight;
    card.classList.add("is-zoomed");
    Object.keys(processCards).forEach(function(k) {
     if (processCards[k] !== card) toggleProcZoom(processCards[k], false);
    });
   } else {
    card.classList.remove("is-zoomed");
    big.hidden = true;
   }
   if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
  }
  function refreshProcessCardsIfNeeded() {
   if (processCardsDynamic) return;
   if (!getMaterialCategoryTitles().length) return;
   buildProcessCards();
  }
  function processImageUrl(key) {
   var v = PROCESS_IMAGES[key];
   if (v && typeof v === "object") v = v.front || v.back || "";
   return String(v || "").trim();
  }
  function processThumbUrl(url) {
   return String(url || "").replace(/_(\d+)x(\d+)(\.[a-z]+)(\?|$)/i, "_200x200$3$4");
  }
  function updateProcessCards() {
   PROCESS_KEYS.forEach(function(key) {
    var card = processCards[key];
    if (card) card.classList.toggle("is-selected", process === key);
   });
   processNextBtn.disabled = !processChosen();
  }
  function setProcess(key) {
   if (key !== "uv" && key !== "handcraft") return;
   var prev = process;
   process = key;
   updateProcessCards();
   driveVariant();
   var purged = purgeLockedMaterials();
   if (purged) {
    materialInvalidNote = true;
    materialSyncAttempts = 0;
    materialSyncGaveUp = false;
    if (unlocked > STEP.material) unlocked = STEP.material;
    goTo(STEP.material);
    try {
     var host = findStageHost();
     if (host && typeof host.scrollIntoView === "function") host.scrollIntoView({
      behavior: "smooth",
      block: "center"
     });
    } catch (eS) {}
    return;
   }
   if (prev !== key || currentStep === STEP.process) advanceTo(STEP.form); else render();
  }
  var materialCategoryIndex = null;
  function getMaterialCategoryTitles() {
   try {
    var dd = fpd.mainOptions.dynamicDesigns;
    var out = [];
    Object.keys(dd || {}).forEach(function(k) {
     (dd[k].categories || []).forEach(function(c) {
      var t = String(c).trim();
      if (t && out.indexOf(t) === -1) out.push(t);
     });
    });
    return out;
   } catch (e) {
    return [];
   }
  }
  function buildMaterialCategoryIndex() {
   if (materialCategoryIndex) return materialCategoryIndex;
   var idx = {}, found = false;
   try {
    var names = getMaterialCategoryNames();
    (fpd.mainOptions && fpd.mainOptions.designsJSON || []).forEach(function(c) {
     var ct = String(c.title || "").trim();
     if (!ct) return;
     if (names.length && names.indexOf(ct.toLowerCase()) === -1) return;
     found = true;
     (c.designs || []).forEach(function(d) {
      var t = normOpt(d.title);
      if (t && !idx[t]) idx[t] = ct;
     });
    });
   } catch (e) {}
   if (found) materialCategoryIndex = idx;
   return idx;
  }
  function materialCategoryOf(title) {
   var idx = buildMaterialCategoryIndex();
   return idx[normOpt(title)] || "";
  }
  function categoryAllowedFor(proc, cat) {
   var rules = PROCESS_RULES[proc];
   if (!rules) return true;
   var c = String(cat || "");
   if (rules.materialKeywordsDeny && rules.materialKeywordsDeny.test(c)) return false;
   if (rules.materialCategoriesAllow) return rules.materialCategoriesAllow.test(c);
   return true;
  }
  function materialAllowedFor(proc, cat, title) {
   var rules = PROCESS_RULES[proc];
   if (!rules) return true;
   var t = String(title || "");
   if (rules.materialTitlesDeny && rules.materialTitlesDeny.some(function(d) {
    return normOpt(d) === normOpt(t);
   })) return false;
   if (rules.materialKeywordsDeny && rules.materialKeywordsDeny.test(t)) return false;
   if (cat) return categoryAllowedFor(proc, cat);
   return true;
  }
  function materialElementAllowed(el) {
   if (!processChosen()) return true;
   var t = el && el.title || "";
   return materialAllowedFor(process, materialCategoryOf(t), t);
  }
  function materialTileLocked(item) {
   if (!processChosen()) return false;
   var raw = item.getAttribute("data-title") || "";
   if (!raw) return false;
   if (item.classList.contains("fpd-category")) return !categoryAllowedFor(process, raw);
   return !materialAllowedFor(process, materialCategoryOf(raw), raw);
  }
  function decorateLockedMaterialTiles(moduleEl) {
   var label = "nur mit " + processLabel("handcraft");
   moduleEl.querySelectorAll(".fpd-item").forEach(function(item) {
    var locked = materialTileLocked(item);
    if (item.classList.contains("dh-locked-tile") !== locked) item.classList.toggle("dh-locked-tile", locked);
    var badge = item.querySelector(".dh-lock-badge");
    if (locked && !badge) {
     badge = document.createElement("b");
     badge.className = "dh-lock-badge";
     badge.textContent = label;
     item.appendChild(badge);
    } else if (!locked && badge && badge.parentNode) {
     badge.parentNode.removeChild(badge);
    }
   });
  }
  function lockedCategoryTitles() {
   if (!processChosen()) return [];
   return getMaterialCategoryTitles().filter(function(c) {
    return !categoryAllowedFor(process, c);
   });
  }
  function joinDe(list) {
   if (!list.length) return "";
   if (list.length === 1) return list[0];
   return list.slice(0, -1).join(", ") + " und " + list[list.length - 1];
  }
  function mountLockHintBelowList() {
   try {
    var m = getModules().material[0];
    if (!m) return false;
    try {
     var outer = m.closest ? m.closest(MATERIAL_WRAPPER_SELECTOR) : null;
     if (outer && outer.contains(m)) m = outer;
    } catch (eO) {}
    if (!m.parentNode) return false;
    if (materialLockHint.previousElementSibling !== m || materialLockHint.parentNode !== m.parentNode) {
     m.parentNode.insertBefore(materialLockHint, m.nextSibling);
    }
    return true;
   } catch (e) {
    return false;
   }
  }
  function updateMaterialHints() {
   var locked = lockedCategoryTitles();
   if (locked.length && currentStep === STEP.material) {
    var plus = processSurcharge();
    var lockTxt = joinDe(locked) + " gibt es nur mit " + processLabel("handcraft") + (plus > 0 ? " (+ " + formatMoney(plus) + ")" : "") + ".";
    if (materialLockText.textContent !== lockTxt) materialLockText.textContent = lockTxt;
    mountLockHintBelowList();
    if (materialLockHint.style.display !== "block") materialLockHint.style.display = "block";
   } else {
    if (materialLockHint.style.display !== "none") materialLockHint.style.display = "none";
   }
   if (materialInvalidNote && materialStepSatisfied()) materialInvalidNote = false;
   if (materialInvalidNote) {
    var invTxt = "Dein bisheriges Material ist bei " + processLabel(process) + " nicht möglich — bitte wähle ein neues Material.";
    if (materialInvalidHint.textContent !== invTxt) materialInvalidHint.textContent = invTxt;
    if (materialInvalidHint.style.display !== "block") materialInvalidHint.style.display = "block";
   } else {
    materialInvalidHint.style.display = "none";
   }
  }
  function flashLockHint() {
   updateMaterialHints();
  }
  function purgeLockedMaterials() {
   if (!processChosen()) return false;
   var purged = false;
   try {
    getAllMaterialElements().forEach(function(el) {
     if (!materialElementAllowed(el)) {
      removeElementSafe(el);
      purged = true;
     }
    });
   } catch (e) {}
   if (purged) {
    syncShapeVisibility();
    applyAutoDesignColor();
    renderAllViews();
    fpd.viewInstances.forEach(function(v, i) {
     thumbsDirty[i] = true;
    });
    updateThumbnails();
   }
   return purged;
  }
  function lockedTileFromEvent(ev) {
   var item = ev.target && ev.target.closest ? ev.target.closest(".fpd-item") : null;
   if (!item || !item.classList.contains("dh-locked-tile")) return null;
   if (!item.closest(MATERIAL_MODULE_SELECTOR)) return null;
   return item;
  }
  [ "pointerdown", "pointerup", "mousedown", "mouseup", "touchstart", "touchend" ].forEach(function(type) {
   document.addEventListener(type, function(ev) {
    if (lockedTileFromEvent(ev)) {
     ev.stopPropagation();
     ev.stopImmediatePropagation();
    }
   }, true);
  });
  document.addEventListener("click", function(ev) {
   if (!lockedTileFromEvent(ev)) return;
   ev.preventDefault();
   ev.stopPropagation();
   ev.stopImmediatePropagation();
   flashLockHint();
  }, true);
  function findCompareRow() {
   try {
    var cands = document.querySelectorAll("td, th, div, span, p, strong, b, li, dt, h2, h3, h4");
    var i, n, t;
    for (i = 0; i < cands.length; i++) {
     n = cands[i];
     if (n.children.length > 1 || stepper.contains(n)) continue;
     t = (n.textContent || "").trim();
     if (/^Materialauswahl:?$/i.test(t)) return n.closest("tr, li") || n.parentElement || n;
    }
    for (i = 0; i < cands.length; i++) {
     n = cands[i];
     if (n.children.length > 1 || stepper.contains(n)) continue;
     t = (n.textContent || "").trim();
     if (/^Wichtig zu wissen/i.test(t)) return n.closest("div, section, tr, li") || n;
    }
   } catch (e) {}
   return null;
  }
  function scrollToCompare() {
   var row = findCompareRow();
   if (!row) return false;
   try {
    row.scrollIntoView({
     behavior: "smooth",
     block: "center"
    });
   } catch (e) {}
   row.classList.remove("dh-compare-flash");
   void row.offsetWidth;
   row.classList.add("dh-compare-flash");
   setTimeout(function() {
    row.classList.remove("dh-compare-flash");
   }, 2600);
   return true;
  }
  function refreshCompareLinks() {
   compareAvailable = !!findCompareRow();
   document.querySelectorAll(".dh-compare-link").forEach(function(l) {
    l.hidden = !compareAvailable;
   });
  }
  document.addEventListener("click", function(ev) {
   var l = ev.target && ev.target.closest ? ev.target.closest(".dh-compare-link") : null;
   if (!l) return;
   ev.preventDefault();
   if (!scrollToCompare()) refreshCompareLinks();
  });
  function updatePriceLine() {
   var v = currentVariant();
   var cfg = formConfig[selectedFormIndex];
   if (!v || !cfg) {
    formPriceLine.hidden = true;
    return;
   }
   var txt = "Auswahl: " + cfg.label + " · " + processLabel(process) + " · " + formatMoney(v.price) + (cfg.formClass === "sonder" ? " (Sondermarke)" : "");
   if (formPriceLine.textContent !== txt) formPriceLine.textContent = txt;
   formPriceLine.hidden = false;
  }
  function logProcessSetup() {
   try {
    var parts = [];
    PROCESS_KEYS.forEach(function(p) {
     [ "standard", "sonder" ].forEach(function(fc) {
      var v = variantFor(p, fc);
      parts.push(p + "·" + fc + "=" + (v ? v.id + " " + formatMoney(v.price) + (v.available === false ? " (nicht verfügbar)" : "") : "FEHLT"));
     });
    });
    if (PRODUCT_VARIANTS.length < 2) {
     console.warn("[dh-stepper] " + STEPPER_VERSION + " Varianten: nur " + PRODUCT_VARIANTS.length + " am Produkt — Preise/Varianten können nicht gesteuert werden");
    } else {
     console.log("[dh-stepper] " + STEPPER_VERSION + " Varianten: " + parts.join(" | "));
    }
    var cats = getMaterialCategoryTitles();
    console.log("[dh-stepper] " + STEPPER_VERSION + " Materialarten bei UV: " + (cats.length ? cats.map(function(c) {
     return c + "=" + (categoryAllowedFor("uv", c) ? "erlaubt" : "gesperrt");
    }).join(", ") : "keine Kategorien gefunden") + " | Materialindex: " + Object.keys(buildMaterialCategoryIndex()).length + " Titel");
    console.log("[dh-stepper] " + STEPPER_VERSION + " Formklassen: " + formConfig.map(function(c) {
     return c.productTitle + "=" + c.formClass;
    }).join(", "));
   } catch (e) {}
  }
  function getAssignedProducts() {
   return (fpd.products && fpd.products.length ? fpd.products : []) || [];
  }
  function productTitle(p) {
   if (!p) return "";
   if (typeof p.title === "string" && p.title) return p.title;
   if (typeof p.name === "string" && p.name) return p.name;
   var views = Array.isArray(p) ? p : p.views || p.product || null;
   if (views && views[0]) {
    var v = views[0];
    return v.productTitle || v.product_title || v.options && v.options.productTitle || "";
   }
   return "";
  }
  function findShapeImage(p) {
   var views = Array.isArray(p) ? p : p && (p.views || p.product) || [];
   for (var i = 0; i < views.length; i++) {
    var els = views[i] && views[i].elements || [];
    for (var j = 0; j < els.length; j++) {
     var el = els[j];
     if (el && el.title === SHAPE_ELEMENT_TITLE) {
      return el.source || el.src || el.parameters && el.parameters.source || "";
     }
    }
   }
   return "";
  }
  function updateFormTileImages() {
   formTiles.forEach(function(tile, i) {
    var img = tile.querySelector("img");
    if (!img || img.getAttribute("src")) return;
    var cfg = formConfig[i];
    if (!cfg) return;
    var p = getAssignedProducts()[cfg.productIndex];
    var src = p ? findShapeImage(p) : "";
    if (src) {
     img.src = src;
     img.style.display = "block";
    }
   });
  }
  function switchForm(i) {
   var cfg = formConfig[i];
   if (!cfg) return;
   var pIdx = cfg.productIndex;
   if (pIdx < 0 || pIdx >= getAssignedProducts().length) {
    console.warn('[dh-stepper] Customization "' + cfg.productTitle + '" no longer available. Rebuilding grid.');
    formGridSig = null;
    render();
    return;
   }
   try {
    if (typeof fpd.selectProduct === "function") {
     fpd.selectProduct(pIdx);
    } else if (typeof fpd.loadProduct === "function") {
     fpd.loadProduct(getAssignedProducts()[pIdx]);
    } else {
     console.warn("[dh-stepper] No product switching API available on this FPD instance.");
     return;
    }
    selectedFormIndex = i;
    formTab = cfg.formClass || formTab;
    driveVariant();
    render();
   } catch (e) {
    console.warn("[dh-stepper] Shape switch failed:", e);
   }
  }
  var initialFormEnsured = false;
  function ensureInitialForm() {
   if (initialFormEnsured || !formConfig.length) return;
   initialFormEnsured = true;
   try {
    var startIdx = 0;
    for (var k = 0; k < formConfig.length; k++) {
     if (formConfig[k].formClass === "standard") {
      startIdx = k;
      break;
     }
    }
    var currentTitle = "";
    try {
     var p = fpd.getProduct();
     currentTitle = p && p[0] && (p[0].productTitle || p[0].product_title) || "";
    } catch (e0) {}
    if (currentTitle && formConfig[startIdx].productTitle === currentTitle) {
     selectedFormIndex = startIdx;
     return;
    }
    switchForm(startIdx);
   } catch (e) {}
  }
  setTimeout(function() {
   var prods = getAssignedProducts();
   var titles = prods.map(function(p) {
    return productTitle(p) || "(untitled)";
   });
   console.log("[dh-stepper] Assigned FPD customizations:", titles.length, titles, "| selectProduct:", typeof fpd.selectProduct, "| loadProduct:", typeof fpd.loadProduct);
   if (prods[0]) {
    console.log("[dh-stepper] First product entry structure:", Array.isArray(prods[0]) ? "Array of " + prods[0].length + " view(s)" : "Object with keys: " + Object.keys(prods[0]).join(", "), prods[0]);
   }
   logProcessSetup();
   refreshProcessCardsIfNeeded();
   refreshCompareLinks();
  }, 3e3);
  try {
   fpd.addEventListener("productCreate", function() {
    setTimeout(function() {
     try {
      maskCache = {};
      overhangState = {};
      updateOverhangOverlay();
      updateOverhangNote();
     } catch (eM) {}
     ensureDefaultMaterialReplace();
     syncShapeVisibility();
     purgeNoDesignElements();
     setTextByTitle(fpd, NAME_ELEMENT_TITLE, nameValue.length ? nameValue : NAME_PLACEHOLDER);
     customTextBaseFontSize = 0;
     customTextCenterRef = null;
     nameBaseFontSize = 0;
     reconcileCustomTextToLimit();
     applyNameAutoSize();
     applyTextElementPolicy();
     attachNameDragHandlers();
     enforceStageScale();
     collapseStageRatioBox();
     if (selectedFont) applyFont(selectedFont);
     applyAutoDesignColor();
     refreshSizeOptions();
     ensureMiniStageObserver();
     scheduleMiniDraw();
     render();
    }, 200);
   });
  } catch (e) {}
  var glowTitleSet = null;
  function glowTitles() {
   if (glowTitleSet) return glowTitleSet;
   var set = {}, found = false;
   try {
    (fpd.mainOptions && fpd.mainOptions.designsJSON || []).forEach(function(c) {
     if (!GLOW_MATERIAL_REGEX.test(String(c.title || ""))) return;
     found = true;
     (c.designs || []).forEach(function(d) {
      var t = String(d.title || "").trim().toLowerCase();
      if (t) set[t] = true;
     });
    });
   } catch (e) {}
   if (found) glowTitleSet = set;
   return set;
  }
  function currentMaterialIsGlow() {
   var glow = false, set = glowTitles();
   getMaterialElements().forEach(function(el) {
    var t = String(el.title || "");
    if (GLOW_MATERIAL_REGEX.test(t) || set[t.trim().toLowerCase()]) glow = true;
   });
   return glow;
  }
  function makeGlowShadow(color, blur) {
   try {
    if (window.fabric && window.fabric.Shadow) {
     return new window.fabric.Shadow({
      color: color,
      blur: blur,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true
     });
    }
   } catch (e) {}
   return null;
  }
  function glowBackground() {
   var st = getStageSize();
   try {
    if (window.fabric && window.fabric.Gradient) {
     return new window.fabric.Gradient({
      type: "radial",
      gradientUnits: "pixels",
      coords: {
       x1: st.w / 2,
       y1: st.h / 2,
       r1: st.h * .3,
       x2: st.w / 2,
       y2: st.h / 2,
       r2: st.h * .62
      },
      colorStops: [ {
       offset: 0,
       color: GLOW_BG_BLOOM
      }, {
       offset: .55,
       color: GLOW_BG_BLOOM_MID
      }, {
       offset: 1,
       color: GLOW_BG_DARK
      } ]
     });
    }
   } catch (e) {}
   return GLOW_BG_DARK;
  }
  function setElementGlow(obj, on, color, blur) {
   if (!obj || typeof obj.set !== "function") return false;
   if (!!obj.__dhGlowOn === !!on) return false;
   obj.__dhGlowOn = !!on;
   try {
    obj.set("shadow", on ? makeGlowShadow(color, blur) : null);
   } catch (e) {}
   return true;
  }
  function applyGlowScene(glow) {
   var changed = false;
   try {
    fpd.viewInstances.forEach(function(v) {
     var c = v && v.fabricCanvas;
     if (!c) return;
     if (c.__dhBgOrig === undefined) c.__dhBgOrig = c.backgroundColor || "";
     if (!!c.__dhGlowBg === !!glow) return;
     c.__dhGlowBg = !!glow;
     try {
      c.set("backgroundColor", glow ? glowBackground() : c.__dhBgOrig);
     } catch (eB) {
      c.backgroundColor = glow ? GLOW_BG_DARK : c.__dhBgOrig;
     }
     changed = true;
    });
   } catch (e) {}
   return changed;
  }
  function applyAutoDesignColor() {
   var glow = currentMaterialIsGlow();
   var color = glow ? DESIGN_COLOR_GLOW : DESIGN_COLOR_DEFAULT;
   var changed = applyGlowScene(glow);
   function setFill(obj) {
    if (obj.fill === color) return false;
    obj.set("fill", color);
    changed = true;
    return true;
   }
   try {
    getMotifElements().forEach(function(el) {
     var elChanged = false;
     if (el.getObjects) {
      el.getObjects().forEach(function(p) {
       if (setFill(p)) elChanged = true;
      });
     } else {
      elChanged = setFill(el);
     }
     if (setElementGlow(el, glow, GLOW_INK_HALO, GLOW_INK_BLUR)) {
      elChanged = true;
      changed = true;
     }
     if (elChanged && el.fire) el.fire("changed");
    });
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title !== NAME_ELEMENT_TITLE && e.title !== CUSTOM_TEXT_ELEMENT_TITLE) return;
     var eChanged = setFill(e);
     if (setElementGlow(e, glow, GLOW_INK_HALO, GLOW_INK_BLUR)) {
      eChanged = true;
      changed = true;
     }
     if (eChanged && e.fire) e.fire("changed");
    });
    if (changed) {
     fpd.viewInstances.forEach(function(v) {
      v.fabricCanvas.renderAll();
     });
     updateThumbnails();
    }
   } catch (e) {}
  }
  function getMaterialCategoryNames() {
   try {
    var dd = fpd.mainOptions.dynamicDesigns;
    var out = [];
    Object.keys(dd || {}).forEach(function(k) {
     (dd[k].categories || []).forEach(function(c) {
      out.push(String(c).trim().toLowerCase());
     });
    });
    return out;
   } catch (e) {
    return [];
   }
  }
  function hideMaterialCategoryTiles(moduleEl) {
   var names = getMaterialCategoryNames();
   if (!names.length) return;
   moduleEl.querySelectorAll(".fpd-category[data-title]").forEach(function(tile) {
    var t = (tile.getAttribute("data-title") || "").trim().toLowerCase();
    if (names.indexOf(t) !== -1) tile.style.setProperty("display", "none", "important");
   });
   moduleEl.querySelectorAll("*").forEach(function(n) {
    if (n.children.length !== 0) return;
    var t = (n.textContent || "").trim().toLowerCase();
    if (t && names.indexOf(t) !== -1) {
     var tile = n.closest('[class*="item"], [class*="category"], picture') || n.parentElement;
     if (tile && tile !== moduleEl) tile.style.setProperty("display", "none", "important");
    }
   });
  }
  function tileSortKey(el) {
   if (el.getAttribute) {
    var dt = el.getAttribute("data-title") || el.getAttribute("aria-label");
    if (dt) return dt.toLowerCase();
   }
   return (el.textContent || "").trim().toLowerCase();
  }
  function sortModuleTiles(moduleEl, glowLast) {
   var grids = moduleEl.querySelectorAll('.fpd-grid, [class*="grid"]');
   grids.forEach(function(g) {
    var kids = Array.prototype.slice.call(g.children);
    if (kids.length < 3) return;
    var sorted = kids.slice().sort(function(a, b) {
     var an = isNoDesignTile(a) ? 0 : 1;
     var bn = isNoDesignTile(b) ? 0 : 1;
     if (an !== bn) return an - bn;
     if (glowLast) {
      var ag = isGlowTitle(a.getAttribute && a.getAttribute("data-title")) ? 1 : 0;
      var bg = isGlowTitle(b.getAttribute && b.getAttribute("data-title")) ? 1 : 0;
      if (ag !== bg) return ag - bg;
     }
     return tileSortKey(a).localeCompare(tileSortKey(b), "de");
    });
    var changed = sorted.some(function(el, i) {
     return el !== kids[i];
    });
    if (changed) sorted.forEach(function(el) {
     g.appendChild(el);
    });
   });
  }
  function prettifyTileTitle(raw) {
   var t = String(raw || "").replace(/\.(png|jpe?g|svg|webp)$/i, "").replace(/_/g, " ").trim();
   var base = t;
   var low = t.toLowerCase();
   getMaterialCategoryNames().forEach(function(cat) {
    if (cat && low.indexOf(cat) === 0) {
     t = t.slice(cat.length).trim();
     low = t.toLowerCase();
    }
   });
   return t || base;
  }
  function labelModuleTiles(moduleEl, isMaterial) {
   moduleEl.querySelectorAll(".fpd-item").forEach(function(item) {
    var raw = item.getAttribute("data-title") || item.getAttribute("aria-label") || "";
    if (!raw) return;
    var isCat = item.classList.contains("fpd-category");
    var desired = isCat ? (isMaterial ? "Materialart: " : "") + raw : prettifyTileTitle(raw);
    var span = item.querySelector("span.dh-tile-label");
    if (!span) {
     var foreign = item.querySelector("span");
     if (foreign) {
      if (isCat && foreign.textContent !== desired) foreign.textContent = desired;
      return;
     }
     span = document.createElement("span");
     span.className = "dh-tile-label";
     item.appendChild(span);
    }
    if (span.textContent !== desired) span.textContent = desired;
   });
  }
  function isGlowTitle(raw) {
   var t = String(raw || "").trim();
   if (!t) return false;
   if (GLOW_MATERIAL_REGEX.test(t)) return true;
   return !!glowTitles()[t.toLowerCase()];
  }
  function decorateGlowTiles(moduleEl) {
   moduleEl.querySelectorAll(".fpd-item").forEach(function(item) {
    var on = isGlowTitle(item.getAttribute("data-title"));
    if (item.classList.contains("dh-glow-tile") !== on) {
     item.classList.toggle("dh-glow-tile", on);
    }
   });
  }
  function decorateNoDesignTiles(moduleEl) {
   moduleEl.querySelectorAll(".fpd-item").forEach(function(item) {
    if (item.classList.contains("fpd-category")) return;
    var isND = isNoDesignTile(item);
    item.classList.toggle("dh-no-design-tile", isND);
    if (isND) item.classList.toggle("is-selected", noDesignChosen);
   });
  }
  function enforceTileLayout(moduleEl, isMotifModule) {
   moduleEl.querySelectorAll(".fpd-grid").forEach(function(g) {
    g.style.setProperty("height", "auto", "important");
    g.style.setProperty("max-height", "none", "important");
   });
   moduleEl.querySelectorAll(".fpd-item").forEach(function(item) {
    if (HOVER_KILL.removeClass && item.classList.contains("fpd-hover-thumbnail")) {
     item.classList.remove("fpd-hover-thumbnail");
     hoverClassKills++;
    }
    if (item.classList.contains("fpd-hidden")) return;
    item.style.setProperty("position", "relative", "important");
    item.style.setProperty("top", "auto", "important");
    item.style.setProperty("left", "auto", "important");
    item.style.setProperty("height", "auto", "important");
    item.style.setProperty("max-height", "none", "important");
    item.style.setProperty("min-height", "0", "important");
    item.style.setProperty("overflow", "visible", "important");
    var pic = item.querySelector("picture, img");
    if (pic) {
     if (pic.tagName === "IMG" && pic.getAttribute("draggable") !== "false") pic.setAttribute("draggable", "false");
     pic.style.setProperty("position", "static", "important");
     pic.style.setProperty("width", "100%", "important");
     pic.style.setProperty("height", "112px", "important");
     pic.style.setProperty("max-height", "112px", "important");
     pic.style.setProperty("padding", "0", "important");
     pic.style.setProperty("margin", "0", "important");
     pic.style.setProperty("transform", "none", "important");
     if (isMotifModule) {
      pic.style.setProperty("object-fit", "contain", "important");
      pic.style.setProperty("background-size", "contain", "important");
      pic.style.setProperty("background-repeat", "no-repeat", "important");
      pic.style.setProperty("background-position", "center", "important");
      var innerImg = pic.tagName === "PICTURE" ? pic.querySelector("img") : null;
      if (innerImg) {
       if (innerImg.getAttribute("draggable") !== "false") innerImg.setAttribute("draggable", "false");
       innerImg.style.setProperty("width", "100%", "important");
       innerImg.style.setProperty("height", "100%", "important");
       innerImg.style.setProperty("object-fit", "contain", "important");
       innerImg.style.setProperty("background-size", "contain", "important");
       innerImg.style.setProperty("background-repeat", "no-repeat", "important");
       innerImg.style.setProperty("background-position", "center", "important");
      }
     }
    }
   });
  }
  function designsForCategory(title) {
   try {
    var dj = fpd.mainOptions.designsJSON || [];
    for (var i = 0; i < dj.length; i++) {
     if (String(dj[i].title || "").toLowerCase() === String(title || "").toLowerCase()) {
      return dj[i].designs || [];
     }
    }
   } catch (e) {}
   return [];
  }
  function mosaicCategoryTiles(moduleEl, isMotifModule) {
   moduleEl.querySelectorAll(".fpd-category.fpd-item").forEach(function(tile) {
    if (tile.classList.contains("fpd-hidden")) return;
    if (tile.__dhMosaicDone) return;
    var designs = designsForCategory(tile.getAttribute("data-title"));
    var imgs = [], total = 0;
    designs.forEach(function(d) {
     var img = d.thumbnail || d.image || d.source || "";
     if (!img || isNoDesignName(d.title) || isNoDesignSource(img)) return;
     total++;
     if (imgs.length < 4) imgs.push(img);
    });
    if (!imgs.length) return;
    var host = tile.querySelector("picture, img");
    if (!host) return;
    tile.__dhMosaicDone = true;
    var grid = document.createElement("div");
    grid.className = "dh-cat-mosaic dh-cat-mosaic-" + imgs.length + (isMotifModule ? " dh-cat-mosaic--contain" : "");
    imgs.forEach(function(u) {
     var cell = document.createElement("i");
     cell.style.backgroundImage = 'url("' + u.replace(/"/g, "%22") + '")';
     grid.appendChild(cell);
    });
    if (total > 4) {
     var more = document.createElement("b");
     more.className = "dh-cat-mosaic-more";
     more.textContent = "+" + (total - 4);
     grid.appendChild(more);
    }
    grid.style.position = "absolute";
    grid.style.left = "0";
    grid.style.right = "0";
    grid.style.top = host.offsetTop + "px";
    grid.style.height = "112px";
    grid.style.setProperty("pointer-events", "none", "important");
    host.style.setProperty("visibility", "hidden", "important");
    tile.appendChild(grid);
   });
  }
  function syncShapeVisibility() {
   try {
    var canvasesWithMaterial = [];
    getAllMaterialElements().forEach(function(el) {
     if (el.canvas && canvasesWithMaterial.indexOf(el.canvas) === -1) {
      canvasesWithMaterial.push(el.canvas);
     }
    });
    var changed = false;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title !== SHAPE_ELEMENT_TITLE) return;
     var want = e.canvas && canvasesWithMaterial.indexOf(e.canvas) !== -1 ? 0 : stageEmpty() ? 0 : 1;
     if (e.opacity !== want) {
      if (typeof e.set === "function") e.set("opacity", want); else e.opacity = want;
      changed = true;
     }
    });
    if (changed) {
     fpd.viewInstances.forEach(function(v) {
      try {
       v.fabricCanvas.renderAll();
      } catch (e2) {}
     });
    }
   } catch (e) {}
  }
  var DEFAULT_MATERIAL_TITLE = "Perlmuttviolett";
  function ensureDefaultMaterialReplace() {
   try {
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === DEFAULT_MATERIAL_TITLE && !e.replace) e.replace = REPLACE_MATERIAL;
    });
   } catch (e) {}
  }
  var VIEW_SIZE = 600;
  function centerOnShape(el) {
   try {
    var c = el && el.canvas;
    var shape = null;
    if (c) c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
    var p = null;
    if (shape && typeof shape.getCenterPoint === "function") p = shape.getCenterPoint();
    if (!p || !isFinite(p.x) || !isFinite(p.y)) {
     var st = getStageSize();
     p = {
      x: st.w / 2,
      y: st.h / 2
     };
    }
    if (typeof el.setPositionByOrigin === "function") {
     el.setPositionByOrigin(p, "center", "center");
    } else {
     el.left = p.x;
     el.top = p.y;
    }
    if (typeof el.setCoords === "function") el.setCoords();
   } catch (e) {}
  }
  function enforceMaterialPlacement() {
   getMaterialElements().forEach(function(el) {
    try {
     el.lockMovementX = true;
     el.lockMovementY = true;
     el.hasControls = false;
     el.selectable = false;
     el.evented = false;
     if (typeof el.getScaledWidth === "function") {
      var w = el.getScaledWidth(), h = el.getScaledHeight();
      if (w > 0 && h > 0) {
       var s = Math.max(VIEW_SIZE / w, VIEW_SIZE / h);
       if (s > 1.001) {
        el.scaleX = (el.scaleX || 1) * s;
        el.scaleY = (el.scaleY || 1) * s;
        el.__dhMaterialCentered = false;
       }
      }
     }
     if (!el.__dhMaterialCentered) {
      el.__dhMaterialCentered = true;
      centerOnShape(el);
     }
     var c = el.canvas;
     if (c && typeof c.moveTo === "function") {
      var shapeIdx = -1;
      c.getObjects().forEach(function(o, i) {
       if (o.title === SHAPE_ELEMENT_TITLE) shapeIdx = i;
      });
      if (shapeIdx >= 0) c.moveTo(el, shapeIdx + 1);
     }
    } catch (e) {}
   });
   fpd.viewInstances.forEach(function(v) {
    try {
     v.fabricCanvas.renderAll();
    } catch (e) {}
   });
  }
  var materialSyncBusy = false;
  var materialSyncAttempts = 0;
  var materialSyncGaveUp = false;
  var syncOverlay = document.createElement("div");
  syncOverlay.className = "dh-sync-overlay";
  syncOverlay.innerHTML = '<span class="dh-spinner"></span>Material wird auf beide Seiten übertragen …';
  function showSyncOverlay() {
   var host = findStageHost();
   if (!host) return;
   try {
    if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
    host.appendChild(syncOverlay);
   } catch (e) {}
  }
  function hideSyncOverlay() {
   try {
    if (syncOverlay.parentNode) syncOverlay.parentNode.removeChild(syncOverlay);
   } catch (e) {}
  }
  function syncMaterialToEmptyViews() {
   if (materialSyncBusy) return;
   try {
    var mats = getAllMaterialElements();
    if (!mats.length) return;
    var lacking = [];
    fpd.viewInstances.forEach(function(v, i) {
     var has = mats.some(function(m) {
      return m.canvas === v.fabricCanvas;
     });
     if (!has) lacking.push(i);
    });
    if (!lacking.length) return;
    var title = String(mats[0].title || "").trim().toLowerCase();
    if (!title) return;
    var tile = null;
    getModules().material.forEach(function(m) {
     m.querySelectorAll(".fpd-item[data-title]").forEach(function(t) {
      if (t.classList.contains("fpd-category")) return;
      var dt = String(t.getAttribute("data-title") || "").trim().toLowerCase();
      if (dt === title) tile = t;
     });
    });
    if (!tile) return;
    if (materialSyncAttempts >= 3) {
     if (!materialSyncGaveUp) {
      materialSyncGaveUp = true;
      console.warn("[dh-stepper] " + STEPPER_VERSION + ": Material konnte nach 3 Versuchen nicht auf alle Ansichten uebertragen werden (Ansicht " + lacking.join(", ") + ").");
     }
     return;
    }
    materialSyncAttempts++;
    if (materialSyncAttempts > 1) {
     console.log("[dh-stepper] " + STEPPER_VERSION + ": Material fehlt auf Ansicht " + lacking.join(", ") + " — Nachtrag-Versuch " + materialSyncAttempts + ".");
    }
    materialSyncBusy = true;
    showSyncOverlay();
    var prevView = fpd.currentViewIndex;
    var idx = 0;
    (function next() {
     if (idx >= lacking.length) {
      fpd.selectView(prevView);
      materialSyncBusy = false;
      hideSyncOverlay();
      try {
       render();
      } catch (e) {}
      return;
     }
     fpd.selectView(lacking[idx++]);
     setTimeout(function() {
      try {
       tile.click();
      } catch (e) {}
      setTimeout(next, 180);
     }, 60);
    })();
   } catch (e) {
    materialSyncBusy = false;
    hideSyncOverlay();
   }
  }
  var MASK_RES = 200;
  var OVERHANG_NOISE = .01;
  var OVERHANG_MIN_PIXELS = 4;
  var OVERHANG_BLOCKING = true;
  var OVERHANG_BLOCK_KEYS = [ "motiv", "name" ];
  function overhangBlocked() {
   return OVERHANG_BLOCKING && anyOverhang(OVERHANG_BLOCK_KEYS);
  }
  var MASK_FIT_TARGET = .9;
  var maskCache = {};
  var maskUnavailable = false;
  var overhangState = {};
  function chamfer(grid, w, h) {
   var INF = 1e9, d = new Float32Array(w * h), i, x, y;
   for (i = 0; i < w * h; i++) d[i] = grid[i] ? 0 : INF;
   for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
    i = y * w + x;
    if (x > 0) d[i] = Math.min(d[i], d[i - 1] + 1);
    if (y > 0) d[i] = Math.min(d[i], d[i - w] + 1);
    if (x > 0 && y > 0) d[i] = Math.min(d[i], d[i - w - 1] + 1.4);
    if (x < w - 1 && y > 0) d[i] = Math.min(d[i], d[i - w + 1] + 1.4);
   }
   for (y = h - 1; y >= 0; y--) for (x = w - 1; x >= 0; x--) {
    i = y * w + x;
    if (x < w - 1) d[i] = Math.min(d[i], d[i + 1] + 1);
    if (y < h - 1) d[i] = Math.min(d[i], d[i + w] + 1);
    if (x < w - 1 && y < h - 1) d[i] = Math.min(d[i], d[i + w + 1] + 1.4);
    if (x > 0 && y < h - 1) d[i] = Math.min(d[i], d[i + w - 1] + 1.4);
   }
   return d;
  }
  function fillInteriorHoles(grid, w, h) {
   var n = w * h;
   var seen = new Uint8Array(n);
   var stack = new Int32Array(n);
   var sp = 0, i, x, y;
   function push(idx) {
    if (seen[idx] || grid[idx]) return;
    seen[idx] = 1;
    stack[sp++] = idx;
   }
   for (x = 0; x < w; x++) {
    push(x);
    push((h - 1) * w + x);
   }
   for (y = 0; y < h; y++) {
    push(y * w);
    push(y * w + w - 1);
   }
   while (sp > 0) {
    i = stack[--sp];
    x = i % w;
    y = (i / w) | 0;
    if (x > 0) push(i - 1);
    if (x < w - 1) push(i + 1);
    if (y > 0) push(i - w);
    if (y < h - 1) push(i + w);
   }
   var filled = 0;
   for (i = 0; i < n; i++) {
    if (!grid[i] && !seen[i]) {
     grid[i] = 1;
     filled++;
    }
   }
   return filled;
  }
  function maskDistanceAt(mask, gx, gy, allowHoles) {
   var field = allowHoles && mask.distFilled ? mask.distFilled : mask.dist;
   var cx = Math.min(mask.w - 1, Math.max(0, Math.round(gx)));
   var cy = Math.min(mask.h - 1, Math.max(0, Math.round(gy)));
   var base = field[cy * mask.w + cx];
   var dx = gx - cx, dy = gy - cy;
   return base + Math.sqrt(dx * dx + dy * dy);
  }
  var clipCaptureLogged = false;
  function withoutClip(el, fn) {
   var cp = null, had = false;
   try {
    if (el.clipPath) {
     cp = el.clipPath;
     had = true;
     if (typeof el.set === "function") el.set("clipPath", null); else el.clipPath = null;
     el.dirty = true;
     if (!clipCaptureLogged) {
      clipCaptureLogged = true;
      console.log("[dh-stepper] " + STEPPER_VERSION + " Sprite-Aufnahme ohne FPD-Clip (" + (cp.type || "clipPath") + (cp.absolutePositioned ? ", absolut" : "") + ") für " + (el.title || el.type || "Element"));
     }
    }
   } catch (eC) {}
   try {
    return fn();
   } finally {
    if (had) {
     try {
      if (typeof el.set === "function") el.set("clipPath", cp); else el.clipPath = cp;
      el.dirty = true;
     } catch (eR) {}
    }
   }
  }
  function captureElement(el, maxEdge, cb, allowUpscale) {
   var bbox, mult;
   try {
    bbox = el.getBoundingRect(true, true);
    mult = maxEdge / Math.max(1, Math.max(bbox.width, bbox.height));
    if (!allowUpscale) mult = Math.min(1, mult);
    mult = Math.min(4, mult);
   } catch (e0) {
    cb(null, null);
    return;
   }
   try {
    if (typeof el.toCanvasElement === "function") {
     cb(withoutClip(el, function() {
      return el.toCanvasElement({
       multiplier: mult
      });
     }), bbox);
     return;
    }
   } catch (e1) {}
   try {
    var url = withoutClip(el, function() {
     return el.toDataURL({
      format: "png",
      multiplier: mult
     });
    });
    var img = new Image;
    img.onload = function() {
     try {
      var cv = document.createElement("canvas");
      cv.width = img.width;
      cv.height = img.height;
      cv.getContext("2d").drawImage(img, 0, 0);
      cb(cv, bbox);
     } catch (e2) {
      cb(null, null);
     }
    };
    img.onerror = function() {
     cb(null, null);
    };
    img.src = url;
   } catch (e3) {
    cb(null, null);
   }
  }
  function opaquePoints(cv, bbox) {
   var w = cv.width, h = cv.height;
   var data = cv.getContext("2d").getImageData(0, 0, w, h).data;
   var sx = bbox.width / w, sy = bbox.height / h;
   var pts = [];
   for (var y = 0; y < h; y++) {
    for (var x = 0; x < w; x++) {
     if (data[(y * w + x) * 4 + 3] > 16) {
      pts.push({
       x: bbox.left + (x + .5) * sx,
       y: bbox.top + (y + .5) * sy
      });
     }
    }
   }
   return pts;
  }
  function findShapeOnView(viewIndex) {
   try {
    var c = fpd.viewInstances[viewIndex].fabricCanvas;
    var shape = null;
    c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
    return shape;
   } catch (e) {
    return null;
   }
  }
  function withMask(viewIndex, done) {
   var shape = findShapeOnView(viewIndex);
   if (!shape) {
    done(null);
    return;
   }
   var b;
   try {
    b = shape.getBoundingRect(true, true);
   } catch (eB) {
    done(null);
    return;
   }
   if (!b.width || !b.height) {
    done(null);
    return;
   }
   var sig = viewIndex + ":" + Math.round(b.left) + "," + Math.round(b.top) + "," + Math.round(b.width) + "," + Math.round(b.height);
   var cached = maskCache[viewIndex];
   if (cached && cached.sig === sig) {
    done(cached);
    return;
   }
   var prevOpacity = shape.opacity;
   try {
    if (typeof shape.set === "function") shape.set("opacity", 1); else shape.opacity = 1;
   } catch (eO) {}
   captureElement(shape, MASK_RES, function(cv, bbox) {
    if (!cv || !bbox) {
     maskFail();
     done(null);
     return;
    }
    try {
     var w = cv.width, h = cv.height;
     var data = cv.getContext("2d").getImageData(0, 0, w, h).data;
     var grid = new Uint8Array(w * h);
     for (var i = 0; i < w * h; i++) grid[i] = data[i * 4 + 3] > 16 ? 1 : 0;
     var filledGrid = new Uint8Array(grid);
     var holePixels = fillInteriorHoles(filledGrid, w, h);
     var mask = {
      grid: grid,
      dist: chamfer(grid, w, h),
      distFilled: holePixels ? chamfer(filledGrid, w, h) : null,
      holePixels: holePixels,
      w: w,
      h: h,
      bbox: bbox,
      sig: sig
     };
     maskCache[viewIndex] = mask;
     console.log("[dh-stepper] Kontur-Maske Ansicht " + viewIndex + ": " + w + "x" + h + " | Lochfl\u00E4che " + holePixels + " px" + (holePixels ? " \u2014 f\u00FCr Motive freigegeben" : " \u2014 keine Aussparung erkannt"));
     done(mask);
    } catch (eC) {
     maskFail();
     done(null);
    }
   });
   try {
    if (typeof shape.set === "function") shape.set("opacity", prevOpacity); else shape.opacity = prevOpacity;
   } catch (eR) {}
  }
  function maskFail() {
   if (!maskUnavailable) {
    maskUnavailable = true;
    console.warn("[dh-stepper] v53 mask unavailable — overhang detection off, v52 behavior active");
   }
  }
  function checkElementOverhang(el, viewIndex, done, allowHoles) {
   withMask(viewIndex, function(mask) {
    if (!mask) {
     done(null);
     return;
    }
    captureElement(el, MASK_RES, function(cv, bbox) {
     if (!cv || !bbox) {
      done(null);
      return;
     }
     var data, w, h;
     try {
      w = cv.width;
      h = cv.height;
      data = cv.getContext("2d").getImageData(0, 0, w, h).data;
     } catch (eP) {
      done(null);
      return;
     }
     var sx = bbox.width / w, sy = bbox.height / h;
     var kx = mask.w / mask.bbox.width, ky = mask.h / mask.bbox.height;
     var outside = 0, maxDist = 0, x, y, gx, gy, dist;
     for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
       if (data[(y * w + x) * 4 + 3] <= 16) continue;
       gx = (bbox.left + (x + .5) * sx - mask.bbox.left) * kx;
       gy = (bbox.top + (y + .5) * sy - mask.bbox.top) * ky;
       dist = maskDistanceAt(mask, gx, gy, allowHoles);
       if (dist > .999) {
        outside++;
        if (dist > maxDist) maxDist = dist;
       }
      }
     }
     if (outside < OVERHANG_MIN_PIXELS) {
      done({
       frac: 0,
       points: [],
       bbox: bbox
      });
      return;
     }
     var maskPx2Canvas = mask.bbox.width / mask.w;
     var frac = maxDist * maskPx2Canvas / Math.max(mask.bbox.width, mask.bbox.height);
     done({
      frac: frac,
      points: [],
      bbox: bbox
     });
    });
   });
  }
  function setOverhang(key, viewIndex, result) {
   if (!result) return;
   if (result.frac > OVERHANG_NOISE) {
    overhangState[key] = {
     frac: result.frac,
     points: result.points,
     bbox: result.bbox,
     view: viewIndex
    };
   } else {
    delete overhangState[key];
   }
   scheduleOverlayDraw();
   if (dhDragActive) {
    updateOverhangNote();
    updateTopbarSummary();
    return;
   }
   render();
  }
  function anyOverhang(keys) {
   for (var i = 0; i < keys.length; i++) {
    if (overhangState[keys[i]] && overhangState[keys[i]].frac > OVERHANG_NOISE) return true;
   }
   return false;
  }
  var overlapState = {
   on: false,
   sig: ""
  };
  var overlapScratch = document.createElement("canvas");
  var overlapProbe = document.createElement("canvas");
  var OVERLAP_MIN_PROBE_PX = 6;
  function getFrontNameEl() {
   var out = null;
   try {
    var fc = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
    fpd.getElements(-1, "all", false).forEach(function(e) {
     if (e.title === NAME_ELEMENT_TITLE && e.canvas === fc) out = e;
    });
   } catch (e) {}
   return out;
  }
  function bboxIntersect(a, b) {
   return !!(a && b && a.width && b.width && a.left < b.left + b.width && b.left < a.left + a.width && a.top < b.top + b.height && b.top < a.top + a.height);
  }
  function overlapPair() {
   if (!nameValue) return null;
   var n = getFrontNameEl(), m = currentFrontMotif();
   if (!n || !m) return null;
   var nb, mb;
   try {
    nb = n.getBoundingRect(true, true);
    mb = m.getBoundingRect(true, true);
   } catch (e) {
    return null;
   }
   if (!bboxIntersect(nb, mb)) return null;
   return {
    name: n,
    motif: m,
    nb: nb,
    mb: mb
   };
  }
  function compositeOverlap(pair, viewIndex) {
   var spN = elementSprite(pair.name, viewIndex), spM = elementSprite(pair.motif, viewIndex);
   if (!spN || !spM || !spN.cv.width || !spN.cv.height || !spM.cv.width) return null;
   var w = spN.cv.width, h = spN.cv.height;
   if (overlapScratch.width !== w) overlapScratch.width = w;
   if (overlapScratch.height !== h) overlapScratch.height = h;
   var sctx = overlapScratch.getContext("2d");
   sctx.save();
   sctx.globalCompositeOperation = "source-over";
   sctx.clearRect(0, 0, w, h);
   sctx.drawImage(spN.cv, 0, 0);
   sctx.globalCompositeOperation = "source-in";
   sctx.fillStyle = "rgba(255, 190, 0, .88)";
   sctx.fillRect(0, 0, w, h);
   sctx.globalCompositeOperation = "destination-in";
   var k = w / spN.bbox.width;
   sctx.drawImage(spM.cv, (spM.bbox.left - spN.bbox.left) * k, (spM.bbox.top - spN.bbox.top) * k, spM.bbox.width * k, spM.bbox.height * k);
   sctx.restore();
   return {
    cv: overlapScratch,
    bbox: spN.bbox
   };
  }
  function drawTextMotifOverlap(ctx, viewIndex) {
   if (viewIndex !== MOTIF_FRONT_VIEW_INDEX) return;
   var pair = overlapPair();
   if (!pair) return;
   var comp = compositeOverlap(pair, viewIndex);
   if (!comp) return;
   ctx.drawImage(comp.cv, 0, 0, comp.cv.width, comp.cv.height, comp.bbox.left, comp.bbox.top, comp.bbox.width, comp.bbox.height);
  }
  var overlapTimer = null;
  var overlapLastAt = 0;
  function scheduleOverlapCheck() {
   clearTimeout(overlapTimer);
   overlapTimer = setTimeout(computeOverlap, 120);
  }
  function computeOverlapNow(force) {
   var now = Date.now();
   if (!force && now - overlapLastAt < 60) return;
   overlapLastAt = now;
   clearTimeout(overlapTimer);
   computeOverlap();
  }
  function setOverlap(on) {
   if (overlapState.on === on) return;
   overlapState.on = on;
   updateOverhangNote();
   updateTopbarSummary();
   scheduleOverlayDraw();
   console.log("[dh-stepper] " + STEPPER_VERSION + " Name/Motiv-Überlappung: " + (on ? "ja (gelb markiert)" : "nein"));
  }
  function computeOverlap() {
   try {
    var pair = overlapPair();
    if (!pair) {
     overlapState.sig = "";
     setOverlap(false);
     return;
    }
    var sig = [ Math.round(pair.nb.left), Math.round(pair.nb.top), Math.round(pair.nb.width), Math.round(pair.nb.height), Math.round(pair.mb.left), Math.round(pair.mb.top), Math.round(pair.mb.width), Math.round(pair.mb.height), pair.name.text || "", pair.name.fontSize || 0 ].join(",");
    if (sig === overlapState.sig) return;
    var comp = compositeOverlap(pair, MOTIF_FRONT_VIEW_INDEX);
    if (!comp) return;
    overlapState.sig = sig;
    var pw = 96, ph = 96;
    if (overlapProbe.width !== pw) overlapProbe.width = pw;
    if (overlapProbe.height !== ph) overlapProbe.height = ph;
    var pctx = overlapProbe.getContext("2d");
    pctx.clearRect(0, 0, pw, ph);
    pctx.drawImage(comp.cv, 0, 0, comp.cv.width, comp.cv.height, 0, 0, pw, ph);
    var data = pctx.getImageData(0, 0, pw, ph).data;
    var hits = 0;
    for (var i = 3; i < data.length; i += 4) {
     if (data[i] > 24 && ++hits >= OVERLAP_MIN_PROBE_PX) break;
    }
    setOverlap(hits >= OVERLAP_MIN_PROBE_PX);
   } catch (e) {}
  }
  var overhangOverlay = document.createElement("canvas");
  overhangOverlay.className = "dh-overhang-overlay";
  overhangOverlay.style.cssText = "position:absolute;left:0;top:0;pointer-events:none;z-index:40;";
  var SPRITE_MAX_EDGE = COARSE_POINTER ? 600 : 1e3;
  var shapeSpriteCache = {};
  var overhangScratch = document.createElement("canvas");
  function stageScale(viewIndex) {
   try {
    var fc = fpd.viewInstances[viewIndex].fabricCanvas;
    var z = fc.viewportTransform && fc.viewportTransform[0] || 1;
    var r = typeof fc.getRetinaScaling === "function" ? fc.getRetinaScaling() : window.devicePixelRatio || 1;
    return Math.max(.1, z * r);
   } catch (e) {
    return 1;
   }
  }
  function spriteWithHolesFilled(cv) {
   try {
    var w = cv.width, h = cv.height;
    if (!w || !h) return null;
    var src = cv.getContext("2d").getImageData(0, 0, w, h);
    var grid = new Uint8Array(w * h), i;
    for (i = 0; i < w * h; i++) grid[i] = src.data[i * 4 + 3] > 16 ? 1 : 0;
    if (!fillInteriorHoles(grid, w, h)) return null;
    var out = document.createElement("canvas");
    out.width = w;
    out.height = h;
    var octx = out.getContext("2d");
    octx.drawImage(cv, 0, 0);
    var dst = octx.getImageData(0, 0, w, h);
    for (i = 0; i < w * h; i++) {
     if (grid[i] && dst.data[i * 4 + 3] <= 16) dst.data[i * 4 + 3] = 255;
    }
    octx.putImageData(dst, 0, 0);
    return out;
   } catch (e) {
    return null;
   }
  }
  function shapeSpriteFor(viewIndex) {
   var shape = findShapeOnView(viewIndex);
   if (!shape) return null;
   var b;
   try {
    b = shape.getBoundingRect(true, true);
   } catch (eB) {
    return null;
   }
   if (!b.width || !b.height) return null;
   var sig = Math.round(b.left) + "," + Math.round(b.top) + "," + Math.round(b.width) + "," + Math.round(b.height);
   var cached = shapeSpriteCache[viewIndex];
   if (cached && cached.sig === sig) return cached;
   var prevOpacity = shape.opacity;
   try {
    if (typeof shape.set === "function") shape.set("opacity", 1); else shape.opacity = 1;
   } catch (eO) {}
   var edge = Math.min(SPRITE_MAX_EDGE, Math.max(b.width, b.height) * stageScale(viewIndex));
   captureElement(shape, edge, function(cv, bbox) {
    if (cv && bbox) shapeSpriteCache[viewIndex] = {
     cv: cv,
     cvFilled: spriteWithHolesFilled(cv),
     bbox: bbox,
     sig: sig
    };
   }, true);
   try {
    if (typeof shape.set === "function") shape.set("opacity", prevOpacity); else shape.opacity = prevOpacity;
   } catch (eR) {}
   cached = shapeSpriteCache[viewIndex];
   return cached && cached.sig === sig ? cached : null;
  }
  function elementSprite(el, viewIndex) {
   var b;
   try {
    b = el.getBoundingRect(true, true);
   } catch (eB) {
    return null;
   }
   if (!b.width || !b.height) return null;
   var sigBase = [ el.width, el.height, el.angle || 0, el.text || "", el.fontFamily || "", el.fontSize || "", el.fill || "" ].join("|");
   var sig = sigBase + "|" + [ el.scaleX, el.scaleY, Math.round(stageScale(viewIndex) * 100) ].join("|");
   var cached = el.__dhSprite;
   if (cached && cached.sig === sig) {
    cached.bbox = b;
    return cached;
   }
   if (cached && dhDragActive && cached.sigBase === sigBase) {
    cached.bbox = b;
    return cached;
   }
   var edge = Math.min(SPRITE_MAX_EDGE, Math.max(b.width, b.height) * stageScale(viewIndex));
   captureElement(el, edge, function(cv, bbox) {
    if (cv && bbox) el.__dhSprite = {
     cv: cv,
     bbox: bbox,
     sig: sig,
     sigBase: sigBase
    };
   }, true);
   cached = el.__dhSprite;
   if (cached && cached.sig !== sig) cached.bbox = b;
   return cached || null;
  }
  function drawElementOverhang(ctx, el, viewIndex) {
   var sp = elementSprite(el, viewIndex);
   var sh = shapeSpriteFor(viewIndex);
   if (!sp || !sh || !sp.cv.width || !sp.cv.height) return;
   var w = sp.cv.width, h = sp.cv.height;
   if (overhangScratch.width < w) overhangScratch.width = w;
   if (overhangScratch.height < h) overhangScratch.height = h;
   var sctx = overhangScratch.getContext("2d");
   sctx.save();
   sctx.globalCompositeOperation = "source-over";
   sctx.clearRect(0, 0, overhangScratch.width, overhangScratch.height);
   sctx.drawImage(sp.cv, 0, 0);
   sctx.globalCompositeOperation = "source-in";
   sctx.fillStyle = "rgba(225,30,30,0.9)";
   sctx.fillRect(0, 0, w, h);
   sctx.globalCompositeOperation = "destination-out";
   var k = w / sp.bbox.width;
   var shCv = el.title !== NAME_ELEMENT_TITLE && el.title !== CUSTOM_TEXT_ELEMENT_TITLE && sh.cvFilled ? sh.cvFilled : sh.cv;
   sctx.drawImage(shCv, (sh.bbox.left - sp.bbox.left) * k, (sh.bbox.top - sp.bbox.top) * k, sh.bbox.width * k, sh.bbox.height * k);
   sctx.restore();
   ctx.drawImage(overhangScratch, 0, 0, w, h, sp.bbox.left, sp.bbox.top, sp.bbox.width, sp.bbox.height);
  }
  function overlayCandidates(viewIndex) {
   var out = [];
   function push(el) {
    if (el && out.indexOf(el) === -1) out.push(el);
   }
   try {
    var vc = (fpd.viewInstances[viewIndex] || {}).fabricCanvas;
    if (!vc) return out;
    if (viewIndex === MOTIF_FRONT_VIEW_INDEX) {
     if (overhangState.motiv) {
      getMotifElements().forEach(function(el) {
       if (el.canvas === vc) push(el);
      });
     }
     if (overhangState.name && nameValue) {
      fpd.getElements(-1, "all", false).forEach(function(e) {
       if (e.title === NAME_ELEMENT_TITLE && e.canvas === vc) push(e);
      });
     }
    }
    if (viewIndex === BACK_VIEW_INDEX && customTextValue && overhangState.wunschtext) {
     var wt = getCustomTextElement();
     if (wt && wt.canvas === vc) push(wt);
    }
   } catch (e) {}
   return out;
  }
  var overlayRafPending = false;
  var dhDragActive = false;
  var overlayHasContent = false;
  function scheduleOverlayDraw() {
   if (overlayRafPending) return;
   overlayRafPending = true;
   try {
    requestAnimationFrame(function() {
     overlayRafPending = false;
     updateOverhangOverlay();
    });
   } catch (e) {
    overlayRafPending = false;
    updateOverhangOverlay();
   }
  }
  function updateOverhangOverlay() {
   try {
    var pairLive = overlapState.on || !!overlapPair();
    var hasState = pairLive;
    for (var sk in overhangState) {
     hasState = true;
     break;
    }
    if (!hasState) {
     if (overlayHasContent) {
      try {
       var octx = overhangOverlay.getContext("2d");
       octx.setTransform(1, 0, 0, 1, 0, 0);
       octx.clearRect(0, 0, overhangOverlay.width, overhangOverlay.height);
      } catch (eC) {}
      overlayHasContent = false;
      scheduleMiniDraw();
     }
     return;
    }
    overlayHasContent = true;
    var viewIndex = fpd.currentViewIndex;
    var vi = fpd.viewInstances[viewIndex];
    var fc = vi && vi.fabricCanvas;
    var wrap = fc && fc.wrapperEl;
    if (!wrap) return;
    if (overhangOverlay.parentNode !== wrap) {
     try {
      wrap.appendChild(overhangOverlay);
     } catch (eM) {
      return;
     }
    }
    var lower = fc.lowerCanvasEl;
    var ctx = overhangOverlay.getContext("2d");
    if (lower) {
     if (overhangOverlay.width !== lower.width) overhangOverlay.width = lower.width;
     if (overhangOverlay.height !== lower.height) overhangOverlay.height = lower.height;
     if (lower.style.width && overhangOverlay.style.width !== lower.style.width) overhangOverlay.style.width = lower.style.width;
     if (lower.style.height && overhangOverlay.style.height !== lower.style.height) overhangOverlay.style.height = lower.style.height;
    } else {
     if (overhangOverlay.width !== fc.getWidth()) overhangOverlay.width = fc.getWidth();
     if (overhangOverlay.height !== fc.getHeight()) overhangOverlay.height = fc.getHeight();
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, overhangOverlay.width, overhangOverlay.height);
    var r = typeof fc.getRetinaScaling === "function" ? fc.getRetinaScaling() : window.devicePixelRatio || 1;
    var vpt = fc.viewportTransform || [ 1, 0, 0, 1, 0, 0 ];
    ctx.setTransform(r * vpt[0], r * vpt[1], r * vpt[2], r * vpt[3], r * vpt[4], r * vpt[5]);
    if (pairLive) {
     try {
      drawTextMotifOverlap(ctx, viewIndex);
     } catch (eOv) {}
    }
    overlayCandidates(viewIndex).forEach(function(el) {
     try {
      drawElementOverhang(ctx, el, viewIndex);
     } catch (eD) {}
    });
    var z = vpt[0] || 1;
    Object.keys(overhangState).forEach(function(k) {
     var s = overhangState[k];
     if (!s || s.view !== viewIndex) return;
     var el = null;
     try {
      var vc = fc;
      if (k === "motiv") {
       getMotifElements().forEach(function(m) {
        if (m.canvas === vc) el = m;
       });
      } else if (k === "name") {
       fpd.getElements(-1, "all", false).forEach(function(e) {
        if (e.title === NAME_ELEMENT_TITLE && e.canvas === vc) el = e;
       });
      } else if (k === "wunschtext") {
       var wt = getCustomTextElement();
       if (wt && wt.canvas === vc) el = wt;
      }
     } catch (eL) {}
     var bb = null;
     try {
      bb = el ? el.getBoundingRect(true, true) : s.bbox;
     } catch (eBB) {
      bb = s.bbox;
     }
     if (!bb) return;
     ctx.save();
     ctx.strokeStyle = "rgba(225,30,30,0.95)";
     ctx.lineWidth = 3 / z;
     ctx.setLineDash([ 8 / z, 5 / z ]);
     ctx.strokeRect(bb.left - 4, bb.top - 4, bb.width + 8, bb.height + 8);
     ctx.restore();
    });
    scheduleMiniDraw();
   } catch (e) {}
  }
  var stageNotes = document.createElement("div");
  stageNotes.className = "dh-stage-notes";
  var overhangNote = document.createElement("div");
  overhangNote.className = "dh-stage-note dh-overhang-note";
  var overlapNote = document.createElement("div");
  overlapNote.className = "dh-stage-note dh-overlap-note";
  overlapNote.style.display = "none";
  stageNotes.appendChild(overhangNote);
  stageNotes.appendChild(overlapNote);
  var OVERLAP_TEXT = "⚠ Name und Motiv überlappen sich – bei Bedarf verschieben.";
  var OVERHANG_LABELS = {
   motiv: "Motiv",
   name: "Name",
   wunschtext: "Wunschtext"
  };
  function overhangSubject(keys) {
   var parts = [];
   keys.forEach(function(k) {
    if (overhangState[k] && overhangState[k].frac > OVERHANG_NOISE) parts.push(OVERHANG_LABELS[k] || k);
   });
   if (!parts.length) return "";
   return parts.join(" und ") + (parts.length > 1 ? " ragen" : " ragt") + " über den Rand";
  }
  function overhangShortText(keys) {
   var subject = overhangSubject(keys);
   return subject ? "⚠ " + subject + " – bitte nach innen schieben." : "";
  }
  function updateOverhangNote() {
   if (!document.body.contains(stageNotes)) {
    var host = findStageHost();
    if (host) {
     try {
      if (window.getComputedStyle(host).position === "static") {
       host.style.position = "relative";
      }
      host.appendChild(stageNotes);
     } catch (eN) {}
    }
   }
   var txt = overhangShortText(Object.keys(OVERHANG_LABELS));
   if (!txt) {
    if (overhangNote.style.display !== "none") overhangNote.style.display = "none";
   } else {
    if (overhangNote.textContent !== txt) overhangNote.textContent = txt;
    if (overhangNote.style.display !== "block") overhangNote.style.display = "block";
   }
   var showOverlap = overlapState.on && fpd.currentViewIndex === MOTIF_FRONT_VIEW_INDEX;
   if (showOverlap) {
    if (overlapNote.textContent !== OVERLAP_TEXT) overlapNote.textContent = OVERLAP_TEXT;
    if (overlapNote.style.display !== "block") overlapNote.style.display = "block";
   } else if (overlapNote.style.display !== "none") overlapNote.style.display = "none";
  }
  function flashOverhangNote() {
   updateOverhangNote();
   updateTopbarSummary();
   try {
    var host = findStageHost();
    if (host && typeof host.scrollIntoView === "function") host.scrollIntoView({
     behavior: "smooth",
     block: "center"
    });
   } catch (eS) {}
   [ overhangNote ].forEach(function(el) {
    if (!el || !el.parentNode || el.style.display === "none") return;
    el.classList.remove("dh-overhang-note-flash");
    void el.offsetWidth;
    el.classList.add("dh-overhang-note-flash");
   });
  }
  var nameCheckTimer = null;
  function scheduleNameCheck() {
   clearTimeout(nameCheckTimer);
   nameCheckTimer = setTimeout(function() {
    try {
     var frontCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
     var nameEl = null;
     fpd.getElements(-1, "all", false).forEach(function(e) {
      if (e.title === NAME_ELEMENT_TITLE && e.canvas === frontCanvas) nameEl = e;
     });
     if (!nameEl || !nameValue) {
      setOverhang("name", MOTIF_FRONT_VIEW_INDEX, {
       frac: 0,
       points: []
      });
      return;
     }
     checkFrontElement(nameEl);
    } catch (e) {}
   }, 350);
  }
  var wtCheckTimer = null;
  function scheduleWunschtextCheck() {
   clearTimeout(wtCheckTimer);
   wtCheckTimer = setTimeout(function() {
    var wt = getCustomTextElement();
    if (!wt || !customTextValue) {
     setOverhang("wunschtext", BACK_VIEW_INDEX, {
      frac: 0,
      points: []
     });
     return;
    }
    checkElementOverhang(wt, BACK_VIEW_INDEX, function(res) {
     setOverhang("wunschtext", BACK_VIEW_INDEX, res);
    });
   }, 300);
  }
  function checkFrontElement(el) {
   if (!el) return;
   scheduleOverlapCheck();
   if (el.title === NAME_ELEMENT_TITLE) {
    checkElementOverhang(el, MOTIF_FRONT_VIEW_INDEX, function(res) {
     setOverhang("name", MOTIF_FRONT_VIEW_INDEX, res);
    });
   } else if (isOursElement(el)) {
    checkElementOverhang(el, MOTIF_FRONT_VIEW_INDEX, function(res) {
     setOverhang("motiv", MOTIF_FRONT_VIEW_INDEX, res);
    }, true);
   }
  }
  var overhangTick = 0;
  function periodicOverhangRecheck() {
   if (maskUnavailable) return;
   if (++overhangTick % 3 !== 0) return;
   try {
    var frontCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
    getMotifElements().forEach(function(el) {
     if (el.canvas === frontCanvas) checkFrontElement(el);
    });
    if (nameValue) {
     fpd.getElements(-1, "all", false).forEach(function(e) {
      if (e.title === NAME_ELEMENT_TITLE && e.canvas === frontCanvas) checkFrontElement(e);
     });
    }
    if (customTextValue) scheduleWunschtextCheck();
   } catch (e) {}
  }
  function maskFitMotif(el) {
   if (el.__dhMaskFitDone || el.__dhMotifDragged || el.__dhMotifScaled) return;
   withMask(MOTIF_FRONT_VIEW_INDEX, function(mask) {
    if (!mask || el.__dhMaskFitDone || el.__dhMotifDragged || el.__dhMotifScaled) return;
    captureElement(el, MASK_RES, function(cv, bbox) {
     if (!cv || !bbox) return;
     var pts;
     try {
      pts = opaquePoints(cv, bbox);
     } catch (eP) {
      return;
     }
     if (!pts.length) return;
     var cx = bbox.left + bbox.width / 2, cy = bbox.top + bbox.height / 2;
     var tx = mask.bbox.left + mask.bbox.width / 2, ty = mask.bbox.top + mask.bbox.height / 2;
     function fits(s) {
      for (var i = 0; i < pts.length; i++) {
       var gx = (tx + (pts[i].x - cx) * s - mask.bbox.left) * mask.w / mask.bbox.width;
       var gy = (ty + (pts[i].y - cy) * s - mask.bbox.top) * mask.h / mask.bbox.height;
       if (maskDistanceAt(mask, gx, gy, true) > .999) return false;
      }
      return true;
     }
     var lo = .05, hi = 2;
     if (!fits(lo)) return;
     for (var it = 0; it < 14; it++) {
      var mid = (lo + hi) / 2;
      if (fits(mid)) lo = mid; else hi = mid;
     }
     var target = lo * MASK_FIT_TARGET;
     el.__dhMaskFitDone = true;
     if (el.__dhMotifDragged || el.__dhMotifScaled) return;
     if (Math.abs(target - 1) < .03) return;
     try {
      el.scaleX = (el.scaleX || 1) * target;
      el.scaleY = (el.scaleY || 1) * target;
      el.__dhScaleBase = el.scaleX;
      el.__dhScaleBaseY = el.scaleY;
      centerOnShape(el);
      if (typeof el.setCoords === "function") el.setCoords();
      if (el.canvas) el.canvas.renderAll();
      updateThumbnails();
      checkFrontElement(el);
     } catch (eA) {}
    });
   });
  }
  var MOTIF_MAX_FILL = .95;
  var MOTIF_TARGET_FILL = .8;
  function fitMotifIntoShape(el) {
   try {
    if (el.__dhMotifFitDone) return;
    var c = el.canvas;
    if (!c) return;
    var shape = null;
    c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
    if (!shape) return;
    var sb = shape.getBoundingRect(true, true);
    if (!sb.width || !sb.height) return;
    var eb = el.getBoundingRect(true, true);
    if (!eb.width || !eb.height) return;
    el.__dhMotifFitDone = true;
    var rel = Math.max(eb.width / sb.width, eb.height / sb.height);
    if (rel < MOTIF_MAX_FILL) return;
    var s = MOTIF_TARGET_FILL / rel;
    el.scaleX = (el.scaleX || 1) * s;
    el.scaleY = (el.scaleY || 1) * s;
    if (typeof el.setCoords === "function") el.setCoords();
   } catch (e) {}
  }
  function enforceMotifPlacement() {
   try {
    var motifCanvases = [];
    getMotifElements().forEach(function(el) {
     if (!el.canvas) return;
     var entry = null;
     motifCanvases.forEach(function(m) {
      if (m.canvas === el.canvas) entry = m;
     });
     if (!entry) {
      entry = {
       canvas: el.canvas,
       motifs: []
      };
      motifCanvases.push(entry);
     }
     entry.motifs.push(el);
    });
    motifCanvases.forEach(function(m) {
     if (m.motifs.length < 2) return;
     console.warn("[dh-stepper] " + m.motifs.length + " motifs on one view — replace " + "group misconfigured for this category? Keeping only the newest.");
     m.motifs.slice(0, -1).forEach(removeElementSafe);
    });
   } catch (e) {}
   getMotifElements().forEach(function(el) {
    try {
     if (!el.__dhMotifPlaced) {
      el.__dhMotifPlaced = true;
      fitMotifIntoShape(el);
      centerOnShape(el);
      if (typeof el.setCoords === "function") el.setCoords();
      ensureMotifBase(el);
      maskFitMotif(el);
      checkFrontElement(el);
     }
     el.selectable = true;
     el.evented = true;
     el.lockMovementX = false;
     el.lockMovementY = false;
     el.hasControls = true;
     el.lockRotation = true;
     el.lockScalingX = false;
     el.lockScalingY = false;
     el.lockScalingFlip = true;
     el.minScaleLimit = (el.__dhScaleBase || 1) * MOTIF_PCT_MIN / 100;
     el.transparentCorners = false;
     el.cornerStyle = "circle";
     el.cornerColor = "#ffffff";
     el.cornerStrokeColor = "#333333";
     el.cornerSize = 14;
     el.borderColor = "#ffffff";
     el.borderScaleFactor = 2;
     lockControls(el, [ "tl", "tr", "bl", "br" ]);
    } catch (e) {}
   });
   fpd.viewInstances.forEach(function(v) {
    try {
     v.fabricCanvas.renderAll();
    } catch (e) {}
   });
  }
  try {
   fpd.addEventListener("elementAdd", function() {
    setTimeout(function() {
     purgeMisplacedMotifs();
     if (!purgeNoDesignElements() && getMotifElements().length > 0) {
      noDesignChosen = false;
     }
     enforceMotifPlacement();
     forgetOursCache();
     enforceMaterialPlacement();
     materialSyncAttempts = 0;
     materialSyncGaveUp = false;
     syncMaterialToEmptyViews();
     syncShapeVisibility();
     applyAutoDesignColor();
     render();
     maybeShowCoach();
     scrollToNewMotif();
    }, 150);
   });
  } catch (e) {}
  setInterval(function() {
   if (document.hidden) return;
   if (dhDragActive) {
    if (Date.now() - dhDragAt < DRAG_IDLE_MS) return;
    dhDragActive = false;
   }
   enforceStageScale();
   collapseStageRatioBox();
   fixTextBaselines();
   purgeNoDesignElements();
   purgeMisplacedMotifs();
   purgeLockedMaterials();
   syncMaterialToEmptyViews();
   syncShapeVisibility();
   applyTextElementPolicy();
   applyAutoDesignColor();
   periodicOverhangRecheck();
   updateThumbnails();
   render();
   maybeShowCoach();
  }, 800);
  function runModuleTreatments() {
   var mods = getModules();
   mods.material.forEach(function(m) {
    labelModuleTiles(m, true);
    sortModuleTiles(m, true);
    enforceTileLayout(m, false);
    mosaicCategoryTiles(m, false);
    decorateGlowTiles(m);
    decorateLockedMaterialTiles(m);
   });
   mods.motiv.concat(mods.unknown).forEach(function(m) {
    hideMaterialCategoryTiles(m);
    labelModuleTiles(m, false);
    decorateNoDesignTiles(m);
    sortModuleTiles(m);
    enforceTileLayout(m, true);
    mosaicCategoryTiles(m, true);
   });
   if (hoverClassKills && !hoverClassLogged) {
    hoverClassLogged = true;
    console.log("[dh-stepper] " + STEPPER_VERSION + " Hover-Vorschau: fpd-hover-thumbnail von " + hoverClassKills + " Kacheln entfernt.");
   }
   reassertGhostKills();
   hideFpdToolbars();
   probeTileBlocker();
  }
  function computeNamePos() {
   try {
    if (!nameValue) return "";
    var vi = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
    var c = vi && vi.fabricCanvas;
    if (!c) return "";
    var shape = null, nameEl = null;
    c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
     if (o.title === NAME_ELEMENT_TITLE) nameEl = o;
    });
    if (!shape || !nameEl) return "";
    var sb = shape.getBoundingRect(true, true);
    if (!sb.width || !sb.height) return "";
    var eb = nameEl.getBoundingRect(true, true);
    var x = (eb.left + eb.width / 2 - sb.left) / sb.width;
    var y = (eb.top + eb.height / 2 - sb.top) / sb.height;
    return x.toFixed(3) + "," + y.toFixed(3);
   } catch (e) {
    return "";
   }
  }
  function computeDesignMetrics() {
   try {
    if (noDesignChosen) return null;
    var vi = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
    var c = vi && vi.fabricCanvas;
    if (!c) return null;
    var shape = null;
    c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
    });
    if (!shape) return null;
    var motif = null;
    getMotifElements().forEach(function(el) {
     if (el.canvas === c) motif = el;
    });
    if (!motif) return null;
    var sb = shape.getBoundingRect(true, true);
    if (!sb.width || !sb.height) return null;
    var eb = motif.getBoundingRect(true, true);
    var x = (eb.left + eb.width / 2 - sb.left) / sb.width;
    var y = (eb.top + eb.height / 2 - sb.top) / sb.height;
    return {
     pos: x.toFixed(3) + "," + y.toFixed(3),
     size: (eb.width / sb.width).toFixed(3) + "," + (eb.height / sb.height).toFixed(3)
    };
   } catch (e) {
    return null;
   }
  }
  var BACK_VIEW_INDEX = 1;
  function computeBackMetrics() {
   try {
    var vi = fpd.viewInstances[BACK_VIEW_INDEX];
    var c = vi && vi.fabricCanvas;
    if (!c) return null;
    var shape = null, wt = null;
    c.getObjects().forEach(function(o) {
     if (o.title === SHAPE_ELEMENT_TITLE) shape = o;
     if (o.title === CUSTOM_TEXT_ELEMENT_TITLE) wt = o;
    });
    if (!shape) return null;
    var sb = shape.getBoundingRect(true, true);
    if (!sb.width || !sb.height) return null;
    var out = {
     shapePx: Math.round(sb.width) + "," + Math.round(sb.height)
    };
    if (wt && customTextValue) {
     var eb = wt.getBoundingRect(true, true);
     var x = (eb.left + eb.width / 2 - sb.left) / sb.width;
     var y = (eb.top + eb.height / 2 - sb.top) / sb.height;
     out.textPos = x.toFixed(3) + "," + y.toFixed(3);
    }
    return out;
   } catch (e) {
    return null;
   }
  }
  function dataUrlToBlob(dataUrl) {
   var parts = dataUrl.split(",");
   var mime = (parts[0].match(/data:([^;]+)/) || [])[1] || "image/png";
   var bin = atob(parts[1]);
   var arr = new Uint8Array(bin.length);
   for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
   return new Blob([ arr ], {
    type: mime
   });
  }
  function makeBackViewKey() {
   var uuid = "";
   try {
    uuid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : "";
   } catch (e) {}
   if (!uuid) {
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
     var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
     return v.toString(16);
    });
   }
   return "back-views/" + uuid + ".png";
  }
  function startBackViewUpload() {
   backViewUploadKey = "";
   if (!BACK_VIEW_UPLOAD.ticketEndpoint) return;
   if (typeof window.fetch !== "function" || typeof window.FormData !== "function") return;
   var vi = fpd.viewInstances[BACK_VIEW_INDEX];
   if (!vi || !vi.fabricCanvas) return;
   var dataUrl;
   try {
    dataUrl = vi.fabricCanvas.toDataURL({
     format: "png",
     multiplier: BACK_VIEW_UPLOAD.multiplier
    });
   } catch (e) {
    console.warn("[dh-stepper] back-view capture failed (order proceeds without back preview):", e);
    return;
   }
   var blob;
   try {
    blob = dataUrlToBlob(dataUrl);
   } catch (e) {
    return;
   }
   if (!blob.size || blob.size > BACK_VIEW_UPLOAD.maxBytes) {
    console.warn("[dh-stepper] back-view PNG size out of bounds (" + blob.size + " bytes) – skipping upload");
    return;
   }
   var key = makeBackViewKey();
   backViewUploadKey = key;
   fetch(BACK_VIEW_UPLOAD.ticketEndpoint, {
    method: "POST",
    headers: {
     "Content-Type": "application/json"
    },
    body: JSON.stringify({
     key: key,
     content_type: "image/png",
     size: blob.size
    })
   }).then(function(r) {
    if (!r.ok) throw new Error("ticket endpoint HTTP " + r.status);
    return r.json();
   }).then(function(ticket) {
    if (!ticket || !ticket.url || !ticket.fields) throw new Error("ticket response malformed");
    var fd = new FormData;
    Object.keys(ticket.fields).forEach(function(k) {
     fd.append(k, ticket.fields[k]);
    });
    fd.append("file", blob, "back-view.png");
    return fetch(ticket.url, {
     method: "POST",
     body: fd
    });
   }).then(function(r) {
    if (!(r.status === 204 || r.status === 201 || r.ok)) throw new Error("bucket upload HTTP " + r.status);
    console.log("[dh-stepper] back-view uploaded:", key);
   }).catch(function(e) {
    console.warn("[dh-stepper] back-view upload failed (order proceeds; tool falls back to front preview):", e);
   });
  }
  function designFileBase(url) {
   return String(url || "").split("?")[0].split("#")[0].split("/").pop().replace(/\.(png|jpe?g|svg|webp)$/i, "").trim().toLowerCase();
  }
  function lookupDesignSkuFromJson(el) {
   try {
    var elSrc = designFileBase(el.source || el.src || el.parameters && el.parameters.source || "");
    var elTitle = String(el.title || "").trim().toLowerCase();
    var dj = fpd.mainOptions && fpd.mainOptions.designsJSON || [];
    var titleHit = "";
    for (var i = 0; i < dj.length; i++) {
     var designs = dj[i].designs || [];
     for (var j = 0; j < designs.length; j++) {
      var d = designs[j];
      var sku = d.sku != null && String(d.sku).trim() ? String(d.sku).trim() : d.parameters && d.parameters.sku != null ? String(d.parameters.sku).trim() : "";
      if (!sku) continue;
      var dSrc = designFileBase(d.source || d.image || d.thumbnail || "");
      if (elSrc && dSrc && elSrc === dSrc) return sku;
      var dTitle = String(d.title || "").trim().toLowerCase();
      if (!titleHit && elTitle && dTitle && elTitle === dTitle) titleHit = sku;
     }
    }
    return titleHit;
   } catch (e) {
    return "";
   }
  }
  buildOrderProperties = function() {
   var props = {};
   try {
    var np = computeNamePos();
    if (np) props[ORDER_PROP.namePos] = np;
    if (nameValue) {
     var nf = 0;
     try {
      fpd.getElements(-1, "all", false).forEach(function(e) {
       if (e.title === NAME_ELEMENT_TITLE && e.fontSize) nf = e.fontSize;
      });
     } catch (eN) {}
     if (nf) props[ORDER_PROP.nameFontSize] = String(Math.round(nf));
    }
    var dm = computeDesignMetrics();
    if (dm) {
     props[ORDER_PROP.designPos] = dm.pos;
     props[ORDER_PROP.designSize] = dm.size;
     try {
      var skuVi = fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX];
      var skuCanvas = skuVi && skuVi.fabricCanvas;
      var skuMotif = null;
      if (skuCanvas) {
       getMotifElements().forEach(function(el) {
        if (el.canvas === skuCanvas) skuMotif = el;
       });
      }
      var dsku = "";
      if (skuMotif && skuMotif.sku != null) dsku = String(skuMotif.sku).trim();
      if (!dsku && skuMotif && skuMotif.parameters && skuMotif.parameters.sku != null) {
       dsku = String(skuMotif.parameters.sku).trim();
      }
      if (!dsku && skuMotif) dsku = lookupDesignSkuFromJson(skuMotif);
      if (dsku) props[ORDER_PROP.designSku] = dsku;
      if (skuMotif) {
       var srcUrl = skuMotif.source || skuMotif.src || skuMotif.parameters && skuMotif.parameters.source || "";
       var srcFile = String(srcUrl).split("?")[0].split("#")[0].split("/").pop();
       try {
        srcFile = decodeURIComponent(srcFile);
       } catch (eD) {}
       if (srcFile) props[ORDER_PROP.designFile] = srcFile;
      }
     } catch (eS) {}
    }
    var bm = computeBackMetrics();
    if (bm) {
     props[ORDER_PROP.shapePx] = bm.shapePx;
     if (bm.textPos) props[ORDER_PROP.customTextPos] = bm.textPos;
    }
    if (customTextValue) {
     var ct = getCustomTextElement();
     if (ct) {
      var lines = ct.textLines && ct.textLines.length || String(ct.text || "").split("\n").length;
      props[ORDER_PROP.customTextLines] = String(lines);
      if (ct.fontSize) props[ORDER_PROP.customTextFontSize] = String(Math.round(ct.fontSize));
     }
    }
    if (backViewUploadKey) props[ORDER_PROP.backViewKey] = backViewUploadKey;
    if (processChosen()) props[ORDER_PROP.process] = processLabel(process);
    try {
     var fontFront = "", fontBack = "";
     var ffCanvas = (fpd.viewInstances[MOTIF_FRONT_VIEW_INDEX] || {}).fabricCanvas;
     fpd.getElements(-1, "all", false).forEach(function(e) {
      if (e.title === NAME_ELEMENT_TITLE && e.canvas === ffCanvas && e.fontFamily) fontFront = e.fontFamily;
      if (e.title === CUSTOM_TEXT_ELEMENT_TITLE && e.fontFamily) fontBack = e.fontFamily;
     });
     if (fontFront) props[ORDER_PROP.nameFont] = String(fontFront);
     if (fontBack) props[ORDER_PROP.customTextFont] = String(fontBack);
    } catch (eF) {}
    try {
     var ovPairs = [];
     [ "motiv", "name", "wunschtext" ].forEach(function(k) {
      var s = overhangState[k];
      if (s && s.frac > OVERHANG_NOISE) ovPairs.push(k + ":" + s.frac.toFixed(3));
     });
     if (ovPairs.length) props[ORDER_PROP.overhang] = ovPairs.join(",");
    } catch (eOv) {}
   } catch (e) {
    console.warn("[dh-stepper] buildOrderProperties failed:", e);
   }
   Object.keys(props).forEach(function(k) {
    if (props[k] == null || props[k] === "") delete props[k];
   });
   return props;
  };
  var orderPropsSig = null;
  function syncOrderPropertyInputs() {
   if (!atcForm || typeof buildOrderProperties !== "function") return;
   var props;
   try {
    props = buildOrderProperties();
   } catch (e) {
    return;
   }
   var sig = JSON.stringify(props);
   if (sig === orderPropsSig) return;
   orderPropsSig = sig;
   atcForm.querySelectorAll("input.dh-order-prop").forEach(function(n) {
    if (n.parentNode) n.parentNode.removeChild(n);
   });
   Object.keys(props).forEach(function(k) {
    var inp = document.createElement("input");
    inp.type = "hidden";
    inp.className = "dh-order-prop";
    inp.name = "properties[" + k + "]";
    inp.value = props[k];
    atcForm.appendChild(inp);
   });
  }
  function render() {
   var steps = nav.children;
   for (var i = 0; i < steps.length; i++) {
    steps[i].classList.toggle("is-active", i === currentStep);
    steps[i].classList.toggle("is-done", i < currentStep || i <= unlocked && i !== currentStep);
    var num = steps[i].querySelector(".dh-step-num");
    var isDone = steps[i].classList.contains("is-done");
    num.innerHTML = isDone ? "✓" : String(i + 1);
   }
   panels.forEach(function(p, i) {
    p.classList.toggle("fpd-step-hidden", i !== currentStep);
   });
   var mods = getModules();
   mods.material.forEach(function(m) {
    m.classList.toggle("fpd-step-hidden", currentStep !== STEP.material);
   });
   mods.motiv.forEach(function(m) {
    m.classList.toggle("fpd-step-hidden", currentStep !== STEP.design);
   });
   mods.unknown.forEach(function(m) {
    m.classList.toggle("fpd-step-hidden", currentStep !== STEP.design);
   });
   runModuleTreatments();
   rebuildFormGrid();
   ensureInitialForm();
   populateFontSelect();
   formTiles.forEach(function(t, i) {
    t.classList.toggle("is-selected", i === selectedFormIndex);
   });
   updateFormTileImages();
   applyFormTab();
   driveVariant();
   updateProcessCards();
   updatePriceLine();
   updateMaterialHints();
   if (getMotifElements().length === 0 && overhangState.motiv) {
    delete overhangState.motiv;
    updateOverhangOverlay();
   }
   if (getMotifElements().length === 0 && overlapState.on) setOverlap(false);
   scheduleOverlapCheck();
   designNextBtn.disabled = !designStepSatisfied() || overhangBlocked();
   materialNextBtn.disabled = !materialStepSatisfied();
   updateOverhangNote();
   syncMotifSizeSlider();
   if (currentStep === STEP.form) scheduleFormArc();
   var customTextInput = document.getElementById("custom-text-input");
   if (customTextInput) {
    var lim = getCustomTextCharLimit();
    if (parseInt(customTextInput.getAttribute("maxlength") || "0", 10) !== lim) {
     customTextInput.setAttribute("maxlength", String(lim));
    }
    var lineLim = customTextLineLimit();
    if (parseInt(customTextInput.getAttribute("rows") || "0", 10) !== lineLim) {
     customTextInput.setAttribute("rows", String(lineLim));
    }
    var ph = CUSTOM_TEXT_PLACEHOLDERS.slice(0, lineLim).join("\n");
    if (customTextInput.getAttribute("placeholder") !== ph) {
     customTextInput.setAttribute("placeholder", ph);
    }
   }
   if (atcForm) atcForm.classList.toggle("fpd-step-hidden", currentStep !== STEP.text);
   var orderable = variantOrderable();
   if (atcButton) atcButton.disabled = !(processChosen() && materialStepSatisfied() && designStepSatisfied()) || overhangBlocked() || !orderable;
   if (!variantBlockHint.parentNode) panelLabeling.appendChild(variantBlockHint);
   if (!orderable) {
    variantBlockHint.textContent = "Diese Kombination aus Herstellung und Form ist gerade nicht bestellbar.";
    variantBlockHint.style.display = "block";
   } else {
    variantBlockHint.style.display = "none";
   }
   updateStepHint();
   applyStageVisibility();
   updateTopbarSummary();
   updateViewBadge();
   updateOverhangOverlay();
   updateThumbnails();
   ensureMiniStageObserver();
   syncOrderPropertyInputs();
  }
  var treatScheduled = false;
  var moduleObserver = new MutationObserver(function() {
   scheduleModuleTreatments();
  });
  function scheduleModuleTreatments() {
   if (treatScheduled) return;
   treatScheduled = true;
   requestAnimationFrame(function() {
    treatScheduled = false;
    moduleObserver.disconnect();
    try {
     runModuleTreatments();
    } catch (e) {}
    try {
     moduleObserver.observe(document.body, {
      childList: true,
      subtree: true
     });
    } catch (e) {}
   });
  }
  try {
   moduleObserver.observe(document.body, {
    childList: true,
    subtree: true
   });
  } catch (e) {}
  var atcConfirmedUntil = 0;
  var confirmModal = null;
  function buildConfirmModal() {
   if (confirmModal) return confirmModal;
   confirmModal = document.createElement("div");
   confirmModal.className = "dh-modal-backdrop";
   confirmModal.innerHTML = '<div class="dh-modal" role="dialog" aria-modal="true" aria-label="Marke prüfen">' + "<h3>Bitte prüfe deine Marke</h3>" + '<div class="dh-modal-views">' + '<figure><img class="dh-modal-front" alt="Vorderseite deiner Marke" draggable="false"><figcaption>Vorderseite</figcaption></figure>' + '<figure><img class="dh-modal-back" alt="Rückseite deiner Marke" draggable="false"><figcaption>Rückseite</figcaption></figure>' + "</div>" + "<p>Deine Marke wird individuell für dich gefertigt und ist daher " + "<strong>von Umtausch und Rückgabe ausgeschlossen</strong>. " + "Bitte prüfe Form, Material, Design und Beschriftung genau – " + "gefertigt wird exakt das, was du hier siehst.</p>" + '<div class="dh-modal-warn" hidden>⚠ Name und Motiv überlappen sich (gelb markiert). Gefertigt wird genau so – wenn das nicht gewollt ist, bitte „Noch etwas ändern“ und Name oder Motiv verschieben.</div>' + '<div class="dh-modal-actions">' + '<button type="button" class="dh-back dh-modal-cancel">Noch etwas ändern</button>' + '<button type="button" class="dh-next dh-modal-ok">Passt – in den Warenkorb</button>' + "</div>" + "</div>";
   document.body.appendChild(confirmModal);
   confirmModal.querySelector(".dh-modal-cancel").addEventListener("click", closeConfirmModal);
   confirmModal.addEventListener("click", function(ev) {
    if (ev.target === confirmModal) closeConfirmModal();
   });
   confirmModal.querySelector(".dh-modal-ok").addEventListener("click", function() {
    closeConfirmModal();
    if (overhangBlocked()) {
     flashOverhangNote();
     return;
    }
    try {
     startBackViewUpload();
    } catch (e) {}
    try {
     orderPropsSig = null;
     syncOrderPropertyInputs();
    } catch (e) {}
    atcConfirmedUntil = Date.now() + 12e3;
    try {
     if (atcButton) atcButton.click(); else if (typeof atcForm.requestSubmit === "function") atcForm.requestSubmit(); else atcForm.submit();
    } catch (e) {
     try {
      atcForm.submit();
     } catch (e2) {}
    }
   });
   return confirmModal;
  }
  function openConfirmModal() {
   var m = buildConfirmModal();
   try {
    var f = m.querySelector(".dh-modal-front");
    var b = m.querySelector(".dh-modal-back");
    if (fpd.viewInstances[0]) f.src = captureCanvas(fpd.viewInstances[0].fabricCanvas, .5);
    if (fpd.viewInstances[1]) b.src = captureCanvas(fpd.viewInstances[1].fabricCanvas, .5);
   } catch (e) {}
   try {
    computeOverlap();
    var mw = m.querySelector(".dh-modal-warn");
    if (mw) mw.hidden = !overlapState.on;
   } catch (eW) {}
   m.classList.add("is-open");
   applyMiniVisibility();
  }
  function closeConfirmModal() {
   if (confirmModal) confirmModal.classList.remove("is-open");
   applyMiniVisibility();
  }
  function interceptAtcActivation(ev) {
   if (Date.now() < atcConfirmedUntil) return;
   ev.preventDefault();
   ev.stopPropagation();
   ev.stopImmediatePropagation();
   if (overhangBlocked()) {
    flashOverhangNote();
    return;
   }
   openConfirmModal();
  }
  if (atcForm) {
   atcForm.addEventListener("submit", interceptAtcActivation, true);
   document.addEventListener("click", function(ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]') : null;
    if (!btn) return;
    interceptAtcActivation(ev);
   }, true);
  }
  var anchor = fpdViewsWrapper || atcForm;
  if (anchor && anchor.parentNode) {
   anchor.parentNode.insertBefore(viewsBox, anchor);
   anchor.parentNode.insertBefore(stepper, viewsBox.nextSibling);
  }
  try {
   var headScope = anchor && anchor.parentNode ? anchor.parentNode : document;
   var headCands = headScope.querySelectorAll("p, strong, b, h1, h2, h3, h4, h5, h6, div, span");
   for (var hci = 0; hci < headCands.length; hci++) {
    var hn = headCands[hci];
    if (hn.children.length > 1) continue;
    if (viewsBox.contains(hn) || stepper.contains(hn)) continue;
    if (/^Aktuelle Live-Ansicht:?$/i.test((hn.textContent || "").trim())) {
     hn.style.display = "none";
     break;
    }
   }
  } catch (eLH) {}
  try {
   if (window.matchMedia && window.matchMedia("(min-width: 990px)").matches) {
    var stickyBase = findStageHost();
    if (stickyBase) {
     var walkNode = stickyBase, walkPrev = null;
     var hops = 0;
     while (walkNode && walkNode.parentElement && hops < 12) {
      if (walkNode.parentElement.contains(stepper) && !walkNode.contains(stepper)) break;
      walkPrev = walkNode;
      walkNode = walkNode.parentElement;
      hops++;
     }
     var pinCol = walkNode;
     var pinTarget = walkPrev || walkNode;
     if (pinTarget && pinCol && pinCol !== pinTarget.ownerDocument.body && !pinTarget.contains(stepper)) {
      var PIN_TOP_GAP = 20;
      var pinAppliedY = 0;
      function updateStagePin() {
       try {
        var rect = pinTarget.getBoundingClientRect();
        var colRect = pinCol.getBoundingClientRect();
        var restTop = rect.top - pinAppliedY;
        var maxShift = colRect.top + colRect.height - restTop - pinTarget.offsetHeight;
        if (maxShift < 0) maxShift = 0;
        var y = PIN_TOP_GAP - restTop;
        y = Math.max(0, Math.min(y, maxShift));
        if (Math.abs(y - pinAppliedY) > .5) {
         pinAppliedY = y;
         pinTarget.style.transform = y > .5 ? "translateY(" + y.toFixed(1) + "px)" : "";
        }
       } catch (eU) {}
      }
      var pinRaf = false;
      function schedulePin() {
       if (pinRaf) return;
       pinRaf = true;
       try {
        requestAnimationFrame(function() {
         pinRaf = false;
         updateStagePin();
        });
       } catch (eR) {
        pinRaf = false;
        updateStagePin();
       }
      }
      pinTarget.style.willChange = "transform";
      window.addEventListener("scroll", schedulePin, {
       passive: true
      });
      window.addEventListener("resize", schedulePin);
      setInterval(schedulePin, 800);
      schedulePin();
      console.log("[dh-stepper] v54h stage pinning:", pinTarget.tagName, (pinTarget.className || "").toString().slice(0, 60), "| column:", pinCol.tagName, (pinCol.className || "").toString().slice(0, 60));
     }
    }
   }
  } catch (eSt) {}
  var COACH_KEY = "dh-coach-motif";
  var coachEl = null, coachShown = false, coachDone = false, coachDismissArmed = false;
  var COACH_SVG = '<svg viewBox="0 0 160 160" aria-hidden="true" focusable="false">' + '<g class="dh-coach-g">' + '<rect x="30" y="30" width="100" height="100" rx="5" fill="rgba(74,93,58,.06)" stroke="#333" stroke-width="2" stroke-dasharray="7 5"></rect>' + '<path d="M80 46l10.3 21.3 23.4 3.4-16.9 16.5 4 23.3L80 99.5l-20.8 11 4-23.3-16.9-16.5 23.4-3.4z" fill="#4a5d3a"></path>' + '<circle cx="30" cy="130" r="8" fill="#fff" stroke="#333" stroke-width="2.5"></circle>' + "</g>" + '<g class="dh-coach-finger"><circle r="15" fill="rgba(74,93,58,.16)"></circle><circle r="7.5" fill="#333"></circle></g>' + "</svg>";
  function coachSeen() {
   return coachDone;
  }
  function markCoachSeen() {
   coachDone = true;
   try {
    localStorage.removeItem(COACH_KEY);
   } catch (e) {}
  }
  function buildCoach() {
   if (coachEl) return coachEl;
   coachEl = document.createElement("div");
   coachEl.className = "dh-coach";
   coachEl.setAttribute("role", "dialog");
   coachEl.setAttribute("aria-label", "So passt du dein Motiv an");
   coachEl.innerHTML = '<div class="dh-coach-box"><span class="dh-coach-i" aria-hidden="true">i</span>' + '<div class="dh-coach-head">Motiv anpassen</div>' + COACH_SVG + '<div class="dh-coach-text">Ecke ziehen = Gr\u00F6\u00DFe<br>Mitte ziehen = verschieben</div>' + '<button type="button" class="dh-coach-ok">Verstanden</button></div>';
   coachEl.querySelector(".dh-coach-ok").addEventListener("click", function(ev) {
    ev.preventDefault();
    hideCoach();
   });
   coachEl.addEventListener("click", function(ev) {
    if (ev.target === coachEl) hideCoach();
   });
   function coachBlock(ev) {
    if (!coachShown) return;
    var t = ev.target;
    if (t && t.closest && t.closest(".dh-coach-box")) return;
    ev.preventDefault();
   }
   coachEl.addEventListener("touchmove", coachBlock, {
    passive: false
   });
   coachEl.addEventListener("wheel", coachBlock, {
    passive: false
   });
   return coachEl;
  }
  var COACH_SCROLL_KEYS = [ "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " ", "Spacebar" ];
  function armCoachDismiss() {
   if (coachDismissArmed) return;
   coachDismissArmed = true;
   document.addEventListener("keydown", function(ev) {
    if (!coachShown) return;
    if (ev.key === "Escape" || ev.key === "Esc") {
     hideCoach();
     return;
    }
    if (COACH_SCROLL_KEYS.indexOf(ev.key) !== -1) ev.preventDefault();
   }, true);
   window.addEventListener("scroll", scheduleCoachPos, {
    passive: true
   });
   window.addEventListener("resize", scheduleCoachPos);
   window.addEventListener("orientationchange", scheduleCoachPos);
  }
  var coachPosRaf = false;
  function positionCoach() {
   coachPosRaf = false;
   if (!coachShown || !coachEl) return;
   var box = coachEl.querySelector(".dh-coach-box");
   if (!box) return;
   var vw = window.innerWidth, vh = window.innerHeight;
   var cx = vw / 2, cy = vh / 2;
   try {
    var host = findStageHost();
    var r = host && host.getBoundingClientRect();
    if (r && r.width > 40 && r.height > 40) {
     cx = r.left + r.width / 2;
     cy = r.top + r.height / 2;
    }
   } catch (e) {}
   var bw = box.offsetWidth || 300, bh = box.offsetHeight || 380, m = 8;
   cx = Math.max(m + bw / 2, Math.min(vw - m - bw / 2, cx));
   cy = Math.max(m + bh / 2, Math.min(vh - m - bh / 2, cy));
   var left = Math.round(cx - bw / 2), top = Math.round(cy - bh / 2);
   if (!box.classList.contains("is-placed")) box.classList.add("is-placed");
   if (box.style.left !== left + "px") box.style.left = left + "px";
   if (box.style.top !== top + "px") box.style.top = top + "px";
  }
  function scheduleCoachPos() {
   if (!coachShown || coachPosRaf) return;
   coachPosRaf = true;
   requestAnimationFrame(positionCoach);
  }
  function showCoach() {
   var host = findStageHost();
   if (!host) return false;
   var el = buildCoach();
   if (el.parentNode !== document.body) document.body.appendChild(el);
   el.classList.add("is-open");
   coachShown = true;
   armCoachDismiss();
   if (window.innerWidth < MINI_BREAKPOINT) scrollToStage();
   positionCoach();
   setTimeout(scheduleCoachPos, 120);
   setTimeout(scheduleCoachPos, 500);
   console.log("[dh-stepper] " + STEPPER_VERSION + " Motiv-Coach eingeblendet (Seite gesperrt)");
   return true;
  }
  function hideCoach() {
   if (!coachShown) return;
   coachShown = false;
   markCoachSeen();
   if (coachEl) {
    coachEl.classList.remove("is-open");
    if (coachEl.parentNode) coachEl.parentNode.removeChild(coachEl);
   }
  }
  var fpdToolbarKills = 0;
  function hideFpdToolbars() {
   try {
    var list = document.querySelectorAll("fpd-element-toolbar, .fpd-element-toolbar");
    for (var i = 0; i < list.length; i++) {
     var tb = list[i];
     var dirty = tb.classList.contains("fpd-show") || tb.style.display !== "none";
     if (dirty) {
      tb.classList.remove("fpd-show");
      tb.style.setProperty("display", "none", "important");
      tb.style.setProperty("visibility", "hidden", "important");
      tb.style.setProperty("pointer-events", "none", "important");
      fpdToolbarKills++;
      if (fpdToolbarKills <= 3) console.log("[dh-stepper] " + STEPPER_VERSION + " FPD-Werkzeugleiste neutralisiert #" + fpdToolbarKills + " (" + String(tb.className || "").slice(0, 60) + ")");
     }
     if (!tb.__dhTbObs) {
      try {
       tb.__dhTbObs = new MutationObserver(function() {
        if (tb.classList.contains("fpd-show") || tb.style.display !== "none") hideFpdToolbars();
       });
       tb.__dhTbObs.observe(tb, {
        attributes: true,
        attributeFilter: [ "class", "style" ]
       });
      } catch (eO) {}
     }
    }
   } catch (e) {}
  }
  try {
   fpd.addEventListener("elementSelect", function() {
    hideFpdToolbars();
    setTimeout(hideFpdToolbars, 60);
   });
  } catch (eSel) {}
  var sheetScanAt = 0;
  function nodeChainDeep(n) {
   var out = [], i = 0;
   try {
    while (n && n.nodeType === 1 && i < 6) {
     out.push(n.tagName.toLowerCase() + (n.className && typeof n.className === "string" && n.className.trim() ? "." + n.className.trim().replace(/\s+/g, ".").slice(0, 60) : "") + (n.id ? "#" + n.id : ""));
     n = n.parentElement || (n.getRootNode && n.getRootNode().host) || null;
     i++;
    }
   } catch (e) {}
   return out.join(" < ");
  }
  function scanBottomSheets() {
   if (window.innerWidth >= MINI_BREAKPOINT) return;
   var now = Date.now();
   if (now - sheetScanAt < 1500) return;
   sheetScanAt = now;
   try {
    var vh = window.innerHeight, out = [];
    function scan(root, depth) {
     if (depth > 4) return;
     var all = root.querySelectorAll("*");
     for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.closest && el.closest(".dh-topbar, .dh-coach, .dh-stepper, .dh-modal-backdrop")) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== "fixed" && cs.position !== "absolute") continue;
      if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") continue;
      var r = el.getBoundingClientRect();
      if (r.width < window.innerWidth * .4 || r.height < 30 || r.bottom < vh - 4 || r.top < vh * .3) continue;
      out.push(nodeChainDeep(el) + " | " + Math.round(r.width) + "x" + Math.round(r.height) + " @top " + Math.round(r.top) + " | " + cs.position + " z" + cs.zIndex + " bg " + cs.backgroundColor);
      if (out.length >= 6) return;
     }
     for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) scan(all[j].shadowRoot, depth + 1);
     }
    }
    scan(document, 0);
    console.log("[dh-stepper] " + STEPPER_VERSION + " Bottom-Sheet-Scan nach Tipp auf die Bühne: " + (out.length ? out.join(" || ") : "nichts Fixes am unteren Rand"));
   } catch (e) {}
  }
  [ "touchend", "mouseup" ].forEach(function(type) {
   document.addEventListener(type, function(ev) {
    try {
     var host = findStageHost();
     if (!host || !ev.target || !host.contains(ev.target)) return;
     hideFpdToolbars();
     setTimeout(hideFpdToolbars, 120);
     setTimeout(scanBottomSheets, 450);
    } catch (e) {}
   }, true);
  });
  var lastScrolledMotif = null;
  function scrollToNewMotif() {
   try {
    if (currentStep !== STEP.design) return;
    var m = currentFrontMotif();
    if (!m || m === lastScrolledMotif) return;
    lastScrolledMotif = m;
    if (coachShown) return;
    if (window.innerWidth < MINI_BREAKPOINT) scrollToStage();
   } catch (e) {}
  }
  var coachSkipLogged = "";
  function coachSkipLog(why) {
   if (coachSkipLogged === why) return;
   coachSkipLogged = why;
   console.log("[dh-stepper] " + STEPPER_VERSION + " Motiv-Coach nicht gezeigt: " + why);
  }
  function maybeShowCoach() {
   if (currentStep !== STEP.design) return;
   if (!getMotifElements().length) return;
   if (coachShown) return;
   if (coachSeen()) {
    coachSkipLog("auf dieser Seite bereits gezeigt (einmal pro Seitenaufruf)");
    return;
   }
   showCoach();
  }
  var miniCard = null, miniCanvas = null, miniCtx = null, miniCap = null;
  var miniTitle = null, miniSel = null, miniPrice = null;
  var miniShown = false, miniStageOut = false;
  var miniRaf = false, miniStageIO = null, miniStageNode = null, miniTopRaf = false, miniTop = -1;
  function miniEnabled() {
   return window.innerWidth < MINI_BREAKPOINT;
  }
  function productTitleText() {
   var t = String(STEPPER_DATA.productTitle || "").trim();
   if (t) return t;
   try {
    var h = document.querySelector(".dh-pdp-head h1, .product-block-title h1, h1");
    if (h) t = String(h.textContent || "").trim();
   } catch (e) {}
   return t;
  }
  function buildMiniCard() {
   if (miniCard) return miniCard;
   miniCard = document.createElement("div");
   miniCard.className = "dh-topbar";
   miniCard.setAttribute("aria-label", "Vorschau deiner Marke");
   miniCard.innerHTML = '<button type="button" class="dh-topbar-view" aria-label="Zur Marke springen" title="Zur Marke">' + '<canvas width="' + MINI_EDGE + '" height="' + MINI_EDGE + '"></canvas>' + "</button>" + '<div class="dh-topbar-main"><div class="dh-topbar-title"></div><div class="dh-topbar-sel"></div></div>' + '<div class="dh-topbar-right"><div class="dh-topbar-price"></div>' + '<button type="button" class="dh-topbar-flip" aria-label="Andere Seite anzeigen" title="Seite wechseln"><span class="dh-topbar-cap"></span><span class="dh-topbar-flip-ico">&#8644;</span></button></div>';
   document.body.appendChild(miniCard);
   miniCanvas = miniCard.querySelector("canvas");
   try {
    miniCtx = miniCanvas.getContext("2d");
   } catch (e) {}
   miniCap = miniCard.querySelector(".dh-topbar-cap");
   miniTitle = miniCard.querySelector(".dh-topbar-title");
   miniSel = miniCard.querySelector(".dh-topbar-sel");
   miniPrice = miniCard.querySelector(".dh-topbar-price");
   miniTitle.textContent = productTitleText();
   miniCard.querySelector(".dh-topbar-view").addEventListener("click", scrollToStage);
   miniCard.querySelector(".dh-topbar-flip").addEventListener("click", flipMiniView);
   return miniCard;
  }
  function flipMiniView() {
   try {
    var n = fpd.viewInstances.length;
    if (n < 2) return;
    fpd.selectView((fpd.currentViewIndex + 1) % n);
    render();
    updateMiniCaption();
    scheduleMiniDraw();
   } catch (e) {}
  }
  function scrollToStage() {
   try {
    var host = findStageHost();
    if (host && typeof host.scrollIntoView === "function") {
     host.scrollIntoView({
      behavior: "smooth",
      block: "center"
     });
    }
   } catch (e) {}
  }
  function updateMiniCaption() {
   if (!miniCap) return;
   var t = viewTitleAt(fpd.currentViewIndex) || "Ansicht " + ((fpd.currentViewIndex || 0) + 1);
   if (miniCap.textContent !== t) miniCap.textContent = t;
  }
  function cleanTitle(t) {
   return String(t || "").replace(/\.(png|jpe?g|svg|webp)$/i, "").replace(/_/g, " ").trim();
  }
  function topbarSummaryParts() {
   var parts = [];
   if (processChosen()) parts.push(processLabel(process));
   var cfg = formConfig[selectedFormIndex];
   if (cfg && (formConfirmed || currentStep >= STEP.form)) parts.push(cfg.label);
   try {
    var mats = getMaterialElements();
    if (mats.length) {
     var mt = cleanTitle(mats[0].title);
     if (mt) parts.push(mt);
    }
   } catch (e) {}
   try {
    var m = currentFrontMotif();
    if (m) {
     var dt = cleanTitle(m.title);
     parts.push(dt ? "Motiv " + dt : "Motiv");
    } else if (noDesignChosen) parts.push("ohne Motiv");
   } catch (e2) {}
   if (nameValue) parts.push("\u201E" + nameValue + "\u201C");
   return parts;
  }
  function topbarPriceText() {
   var v = currentVariant();
   if (v) return formatMoney(v.price);
   var all = [];
   PRODUCT_VARIANTS.forEach(function(pv) {
    var p = parseInt(pv.price, 10);
    if (isFinite(p) && all.indexOf(p) === -1) all.push(p);
   });
   if (!all.length) return "";
   all.sort(function(a, b) {
    return a - b;
   });
   return (all.length > 1 ? "ab " : "") + formatMoney(all[0]);
  }
  function updateTopbarSummary() {
   if (!miniCard) return;
   var warn = overhangShortText(Object.keys(OVERHANG_LABELS));
   var note = !warn && overlapState.on ? "⚠ Name und Motiv überlappen sich" : "";
   var sel = warn || note || topbarSummaryParts().join(" \u00B7 ");
   if (!sel) sel = "Noch nichts gewählt";
   if (miniSel.textContent !== sel) miniSel.textContent = sel;
   if (miniSel.classList.contains("is-warn") !== !!warn) miniSel.classList.toggle("is-warn", !!warn);
   if (miniSel.classList.contains("is-note") !== !!note) miniSel.classList.toggle("is-note", !!note);
   var pr = topbarPriceText();
   if (miniPrice.textContent !== pr) miniPrice.textContent = pr;
   if (!miniTitle.textContent) miniTitle.textContent = productTitleText();
  }
  function stickyHeaderBottom() {
   var best = 0;
   try {
    var cands = document.querySelectorAll(".shopify-section-group-header-group, [data-sticky-header], .shopify-section-header, header");
    for (var i = 0; i < cands.length; i++) {
     var el = cands[i];
     if (el.closest && el.closest(".dh-topbar")) continue;
     var r = el.getBoundingClientRect();
     if (r.height <= 0 || r.width < window.innerWidth * .5) continue;
     if (r.top > 1 || r.bottom <= 1) continue;
     var stuck = false, n = el, hops = 0;
     while (n && n !== document.body && hops < 5) {
      var pos = window.getComputedStyle(n).position;
      if (pos === "sticky" || pos === "fixed") {
       stuck = true;
       break;
      }
      n = n.parentElement;
      hops++;
     }
     if (!stuck) continue;
     if (r.bottom > best) best = Math.round(r.bottom);
    }
   } catch (e) {}
   return Math.min(best, 260);
  }
  function updateTopbarTop() {
   if (!miniCard || !miniShown) return;
   var top = stickyHeaderBottom();
   if (top !== miniTop) {
    miniTop = top;
    miniCard.style.top = top + "px";
   }
   try {
    var h = miniCard.getBoundingClientRect().height || 72;
    document.documentElement.style.scrollPaddingTop = Math.round(top + h + 8) + "px";
   } catch (e) {}
  }
  function scheduleTopbarTop() {
   if (!miniShown || miniTopRaf) return;
   miniTopRaf = true;
   try {
    requestAnimationFrame(function() {
     miniTopRaf = false;
     updateTopbarTop();
    });
   } catch (e) {
    miniTopRaf = false;
    updateTopbarTop();
   }
  }
  function drawMini() {
   try {
    if (!miniShown || !miniCanvas || !miniCtx) return;
    var vi = fpd.viewInstances[fpd.currentViewIndex];
    var fc = vi && vi.fabricCanvas;
    var src = fc && fc.lowerCanvasEl;
    if (!src || !src.width || !src.height) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var px = Math.max(1, Math.round(MINI_EDGE * dpr));
    if (miniCanvas.width !== px) {
     miniCanvas.width = px;
     miniCanvas.height = px;
    }
    var s = Math.min(px / src.width, px / src.height);
    var dw = src.width * s, dh = src.height * s;
    var dx = (px - dw) / 2, dy = (px - dh) / 2;
    miniCtx.clearRect(0, 0, px, px);
    miniCtx.drawImage(src, dx, dy, dw, dh);
    if (overlayHasContent && overhangOverlay.width && overhangOverlay.parentNode === fc.wrapperEl) {
     miniCtx.drawImage(overhangOverlay, dx, dy, dw, dh);
    }
   } catch (e) {}
  }
  function scheduleMiniDraw() {
   if (!miniShown || miniRaf) return;
   miniRaf = true;
   try {
    requestAnimationFrame(function() {
     miniRaf = false;
     drawMini();
    });
   } catch (e) {
    miniRaf = false;
    drawMini();
   }
  }
  function applyMiniVisibility() {
   if (!miniCard) return;
   var modalOpen = !!(confirmModal && confirmModal.classList.contains("is-open"));
   var want = miniEnabled() && miniStageOut && !modalOpen && currentStep !== STEP.process;
   if (want === miniShown) return;
   miniShown = want;
   miniCard.classList.toggle("is-visible", want);
   if (want) {
    updateMiniCaption();
    updateTopbarSummary();
    updateTopbarTop();
    drawMini();
   } else {
    try {
     document.documentElement.style.removeProperty("scroll-padding-top");
    } catch (e) {}
   }
  }
  function ensureMiniStageObserver() {
   try {
    if (typeof window.IntersectionObserver !== "function") return;
    var host = findStageHost();
    if (!host || host === miniStageNode) return;
    if (miniStageIO) miniStageIO.disconnect();
    miniStageNode = host;
    miniStageIO = new IntersectionObserver(function(entries) {
     var en = entries[entries.length - 1];
     if (!en) return;
     miniStageOut = !(en.isIntersecting && en.intersectionRatio >= MINI_STAGE_RATIO);
     applyMiniVisibility();
    }, {
     threshold: [ 0, MINI_STAGE_RATIO, .5 ]
    });
    miniStageIO.observe(host);
   } catch (e) {}
  }
  function setupMini() {
   buildMiniCard();
   updateMiniCaption();
   updateTopbarSummary();
   ensureMiniStageObserver();
   window.addEventListener("scroll", scheduleTopbarTop, {
    passive: true
   });
   if (typeof window.IntersectionObserver !== "function") {
    console.warn("[dh-stepper] " + STEPPER_VERSION + ": IntersectionObserver fehlt — Vorschau-Leiste bleibt aus.");
   }
  }
  fixTextBaselines();
  calibrateSizeSteps();
  setTextByTitle(fpd, NAME_ELEMENT_TITLE, nameValue.length ? nameValue : NAME_PLACEHOLDER);
  writeCustomText(customTextValue);
  applyNameAutoSize();
  applyTextElementPolicy();
  attachNameDragHandlers();
  ensureDefaultMaterialReplace();
  syncShapeVisibility();
  enforceStageScale();
  collapseStageRatioBox();
  updateThumbnails();
  scanAssetOrigins();
  sweepGhostsOnce();
  armGhostObserver();
  setupMini();
  buildProcessCards();
  refreshCompareLinks();
  render();
  setTimeout(function() {
   scanAssetOrigins();
   sweepGhostsOnce();
   refreshCompareLinks();
  }, 2500);
 });
})();
